<template>
  <div class="width-100 height-100 flex-display">
    <div>
      <a-menu mode="inline" :selectedKeys="[menuSelectedKey]" @select="handleSelect" class="width-130 height-100 pt10">
        <a-menu-item key="folder" class="height-80 text-align-left">
          <FolderOpenOutlined /> 媒体库
        </a-menu-item>
        <a-menu-item v-if="auth.hasPermi(['media:folder'])" key="media" class="height-80 text-align-left">
          <PictureOutlined /> 媒体文件
        </a-menu-item>
        <a-menu-item  v-if="auth.hasPermi(['media:history'])" key="history_play" class="height-80 text-align-left">
          <PlaySquareOutlined /> 历史回放
        </a-menu-item>
        <a-menu-item  v-if="auth.hasPermi(['media:attr'])" key="composite_file" class="height-80 text-align-left">
          <PictureOutlined /> 合成文件
        </a-menu-item>
        <a-menu-item  v-if="auth.hasPermi(['media:test'])" key="monitoring" class="height-80 text-align-left">
          <PictureOutlined /> 图片检测
        </a-menu-item>
      </a-menu>
    </div>

    <div v-if="menuSelectedKey === 'folder'" class="width-100">
      <div class="tab-header">
        <a-tabs v-model:activeKey="mediaActiveKey" size="large">
          <!-- 媒体库 Tab -->
          <a-tab-pane key="folder-tab" tab="媒体库">
            <div>
              <a-select v-model:value="flightTypeValue" placeholder="飞行类型" @change="handleSearch" v-if="!isSubFolder">
                <a-select-option v-for="item in flightTypeSelectValue" :key="item.dictValue" :value="item.dictValue">{{ item.dictLabel }}</a-select-option>
              </a-select>
              <a-input v-model:value="folderName" placeholder="请输入要搜索的文件名称" @change="handleSearch" class="width-200 ml10"></a-input>
              <a-range-picker class="ml10" v-model:value="folderDataTime" @change="fetchFolders" v-if="!isSubFolder"/>
              <a-button type="primary" class="ml10" @click="handleSearch"><SearchOutlined />查询</a-button>
              <a-button type="primary" class="ml10" @click="handleReset"><SyncOutlined />重置</a-button>
              <a-button v-hasPermi="['media:move']" type="primary" v-if="isSubFolder" @click="handleRemoveFolderImage" class="ml10" :disabled="selectedFolderRowKeysForMove.length < 1">
                移动
              </a-button>
              <a-button v-hasPermi="['media:attr']" type="primary" v-if="isSubFolder" @click="handleFolderImageSynthesis" class="ml10"
                :disabled="selectedFolderRowKeys.length < 2"
                :title="selectedFolderRowKeys.length < 2 ? '请至少选择2张图片进行合成' : ''">
                图片合成
              </a-button>
              <span v-if="isSubFolder" class="ml5">{{ `已选择 ${selectedFolderRowKeys.length} 张图片` }}</span>
            </div>
            <div class="m10 folder-create">
              <a-breadcrumb>
                <a-breadcrumb-item @click="handleBreadcrumbClick(0)" class="cur-p fz15">
                  <LeftOutlined  v-if="isSubFolder"/> 全部文件夹
                </a-breadcrumb-item>
                <template v-for="(crumb, index) in breadcrumbs" :key="index">
                  <a-breadcrumb-item @click="handleBreadcrumbClick(index + 1)" class="cur-p fz15">
                    {{ crumb.folder_name }}
                  </a-breadcrumb-item>
                </template>
              </a-breadcrumb>
              <div class="mr15">
                <a-button type="text" :style="{ color: '#1890ff' }" @click="openCreateFolder" v-if="!isSubFolder">+ 新建文件夹</a-button>
              </div>
            </div>
            <div class="m10 width-985 pr10">
              <a-spin :spinning="folderLoading" :delay="1000" tip="下载中..." size="large">
                <a-table :columns="columnses" :data-source="tableDatas" row-key="id" :pagination="paginationProp1" @change="handleTableChange" :scroll="{ x: '100%', y: 550 }"
                  :row-selection="isSubFolder ? {
                    selectedRowKeys: selectedFolderRowKeysForMove,
                    onChange: onFolderSelectChange,
                    getCheckboxProps: getFolderCheckboxProps
                  } : undefined">
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'folderName'">
                      <template v-if="!isSubFolder">
                        <a @click="handleFolderNameClick(record)">📁{{ record.folder_name }}</a>
                      </template>
                      <template v-else>
                        <span class="file-icon">{{ isVideo(record) ? '📹' : (isImage(record) ? '🖼️' : '📄') }}</span>
                        {{ record.name }}
                      </template>
                    </template>
                    <template v-if="column.key === 'flightType'">
                      {{ getFlightTypeLabel(record.flight_type) }}
                    </template>
                    <template v-if="column.key === 'waylineName'">
                      <span v-if="record.wayline_name">{{ record.wayline_name }}</span><span v-else>--</span>
                    </template>
                    <template v-if="column.key === 'job_name'">
                      <span v-if="record.job_name">{{ record.job_name }}</span><span v-else>--</span>
                    </template>
                    <template v-if="column.key === 'url'">
                      <template v-if="record.file_type === 'jpeg' || record.file_type === 'jpg' || record.file_type === 'png' || record.file_type === 'mp4'">
                        <a-spin tip="缩略图正在生成中..." v-if="!record.abbreviation_url"></a-spin>
                        <img v-else :src="record.abbreviation_url" class="img-thumbnail" @click="handleFilePreview(record)" />
                        <SvgIcon name="AIshibie" :size="30" class="ai-position" v-if="record.analysis_result"/>
                      </template>
                      <template v-else>--</template>
                    </template>
                    <template v-if="column.key === 'drone'">
                      <a-tooltip :title="record.drone">
                        {{ formatDeviceSn(record.drone) }}
                      </a-tooltip>
                    </template>
                    <template v-if="column.key === 'payload'">{{ formatEmptyValue(record.payload) }}</template>
                    <template v-if="column.key === 'size'">{{ formatEmptyValue(record.size) }}</template>
                    <template v-if="column.key === 'in_report'">
                      <template v-if="isSubFolder">
                        <span v-if="record.file_type === 'mp4'">--</span>
                        <a-switch :checked="record.in_report === 0" checked-children="是" un-checked-children="否" @change="(checked) => inReportChange(checked, record)" v-else/>
                      </template>
                    </template>
                    <template v-if="column.key === 'panoramas'">
                      <template v-if="!isSubFolder">{{ formatEmptyValue(record.size) }}</template>
                      <template v-else>
                        <span v-if="record.panorama">全景图</span>
                        <span v-else-if="isVideo(record)">视频</span>
                        <span v-else>{{ record.sub_file_type === '1' ? '红外图' : '普通图' }}</span>
                      </template>
                    </template>
                    <template v-if="column.key === 'operation'">
                      <template v-if="!isSubFolder">
                        <a-popover v-hasPermi="['media:download']" trigger="click">
                          <template #content>
                            <a-button size="small" type="primary" @click="downloadFolder(record, false)" class="ml10">无水印</a-button>
                            <a-button size="small" type="primary" @click="downloadFolder(record, true)" class="ml10">含水印</a-button>
                          </template>
                          <a-tooltip title="下载"><a class="fz18"><DownloadOutlined /></a></a-tooltip>
                        </a-popover>
                        <a-tooltip v-hasPermi="['media:ai']" title="批量分析"><a class="fz20 ml5" @click="viewAnalysisResults(record)"><SvgIcon name="AIshibie" :style="{color: '#1890ff'}"/></a></a-tooltip>
                        <a-tooltip v-hasPermi="['media:image']" title="生成正射影像"><a class="fz18 ml5"><CodeSandboxOutlined @click="viewModelResults(record)"/></a></a-tooltip>
                      </template>
                      <template v-else>
                        <a-tooltip v-hasPermi="['media:ai']" title="查看分析结果"><a class="fz20 ml5" @click="viewAnalysisFilesResults(record)"><SvgIcon name="AIshibie" :style="{color: '#1890ff'}" v-if="record.file_type !== 'mp4'"/></a></a-tooltip>
                        <a-tooltip v-hasPermi="['media:download']" title="下载"><a class="fz18 ml8" @click="downloadMedias(record)"><DownloadOutlined /></a></a-tooltip>
                      </template>
                      <a-tooltip v-hasPermi="['media:status']" :title="record.map_load?'地图隐藏':'地图显示'"><a class="fz18 ml8" @click="handleSaveStatus(record,!record.map_load,'map_load')"><i :class="['iconfont', record.map_load ? 'icon-map-off' : 'icon-map-on']"></i></a></a-tooltip>
                      <a-dropdown v-hasPermi="['media:ai','media:regulations']" v-if="record.analysis_result">
                        <a-tooltip title="更多" placement="top"><SmallDashOutlined class="fz20 c189 ml8" @click.prevent /></a-tooltip>
                        <template #overlay>
                          <a-menu><a-menu-item><a-tooltip v-hasPermi="['media:ai']" title="查看AI分析图片"><SvgIcon name="AI-Photo" @click="openAIAnalysisPhoto(record)" class="fz20 cur-p"/></a-tooltip></a-menu-item></a-menu>
                        </template>
                      </a-dropdown>
                    </template>
                  </template>
                </a-table>
              </a-spin>
            </div>
          </a-tab-pane>

          <!-- 隐患识别 Tab -->
          <a-tab-pane key="identify_file" tab="隐患识别" force-render>
            <div>
              <a-input v-model:value="identifyFileName" placeholder="请输入要搜索的文件名称" @change="handleIdentifySearch" class="width-200"></a-input>
              <a-button type="primary" class="ml10" @click="handleIdentifySearch"><SearchOutlined />查询</a-button>
              <a-button type="primary" class="ml10" @click="handleIdentifyReset"><SyncOutlined />重置</a-button>
            </div>
            <div class="m10 folder-create">
              <a-breadcrumb>
                <a-breadcrumb-item @click="handleIdentifyBreadcrumbClick(0)" class="cur-p fz15">
                  <LeftOutlined  v-if="isIdentifyFolder"/> 全部文件夹
                </a-breadcrumb-item>
                <template v-for="(crumb, index) in breadcrumbsIdentify" :key="index">
                  <a-breadcrumb-item @click="handleIdentifyBreadcrumbClick(index + 1)" class="cur-p fz15">{{ crumb.folderName }}</a-breadcrumb-item>
                </template>
              </a-breadcrumb>
            </div>
            <div class="m10 width-985 pr10">
              <a-spin :spinning="identifyLoading" :delay="1000" tip="下载中..." size="large">
                <a-table :columns="identifyColumnses" :data-source="tableIdentifyDatas" row-key="id" :pagination="identifyPaginationProp" @change="handleIdentifyTableChange" :scroll="{ x: '100%', y: 600 }">
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'folderName'">
                      <template v-if="!isIdentifyFolder"><a @click="handleIdentifyNameClick(record)">📁{{ record.folderName }}</a></template>
                      <template v-else>{{ record.fileName }}</template>
                    </template>
                    <template v-if="column.key === 'url'">
                      <img :src="record.url" class="img-thumbnail" @click="openIdentifyFile(record)"/>
                    </template>
                    <template v-if="column.key === 'analysisUrl'">
                      <img :src="record.analysisUrl" class="img-thumbnail" />
                    </template>
                    <template v-if="column.key === 'analysisResult'">
                      {{ record.analysisResult || '--' }}
                    </template>
                    <template v-if="column.key === 'largeModelAnalysisResult'">
                      {{ record.largeModelAnalysisResult || '--' }}
                    </template>
                    <template v-if="column.key === 'fileSize'">
                      {{ formatFileSize(record.fileSize) }}
                    </template>
                    <template v-if="column.key === 'operation'">
                      <template v-if="isIdentifyFolder"><a-tooltip title="下载"><a class="fz18"><DownloadOutlined @click="downloadUrl(record.url)"/></a></a-tooltip></template>
                    </template>
                  </template>
                </a-table>
              </a-spin>
            </div>
          </a-tab-pane>

          <!-- 第三方媒体 Tab -->
          <a-tab-pane key="third_media" tab="第三方媒体" force-render>
            <div>
              <a-input v-model:value="thirdMediaFileName" placeholder="请输入要搜索的文件名称" @change="handleThirdMediaSearch" class="width-200"></a-input>
              <a-button type="primary" class="ml10" @click="handleThirdMediaSearch"><SearchOutlined />查询</a-button>
              <a-button type="primary" class="ml10" @click="handleThirdMediaReset"><SyncOutlined />重置</a-button>
              <a-button type="primary" @click="openAddThirdMedia" class="ml10" v-if="!isThirdMediaFolder">+上传文件</a-button>
            </div>
            <div class="m10 folder-create">
              <a-breadcrumb>
                <a-breadcrumb-item @click="handleThirdMediaBreadcrumbClick(0)" class="cur-p fz15">
                  <LeftOutlined  v-if="isThirdMediaFolder"/> 全部文件夹</a-breadcrumb-item>
                <template v-for="(crumb, index) in breadcrumbsThirdMedia" :key="index">
                  <a-breadcrumb-item @click="handleThirdMediaBreadcrumbClick(index + 1)" class="cur-p fz15">{{ crumb.folderName }}</a-breadcrumb-item>
                </template>
              </a-breadcrumb>
            </div>
            <div class="m10 width-985 pr10">
              <a-spin :spinning="thirdMediaLoading" :delay="1000" tip="下载中..." size="large">
                <a-table :columns="thirdMediaColumnses" :data-source="tableThirdMediaDatas" row-key="id" :pagination="thirdMediaPaginationProp" @change="handleThirdMediaTableChange" :scroll="{ x: '100%', y: 600 }">
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'folderName'">
                      <template v-if="!isThirdMediaFolder"><a @click="handleThirdMediaNameClick(record)">📁{{ record.folderName }}</a></template>
                      <template v-else>{{ record.fileName }}</template>
                    </template>
                    <template v-if="column.key === 'url'">
                      <img :src="record.url" class="img-thumbnail" @click="openThirdMediaFile(record)"/>
                      <SvgIcon name="AIshibie" :size="30" class="ai-third-position" v-if="record.analysisResult"/>
                    </template>
                    <template v-if="column.key === 'analysisUrl'"><img :src="record.analysisUrl" class="img-thumbnail" /></template>
                    <template v-if="column.key === 'analysisResult'">{{ record.analysisResult || '--' }}</template>
                    <template v-if="column.key === 'largeModelAnalysisResult'">{{ record.largeModelAnalysisResult || '--' }}</template>
                    <template v-if="column.key === 'fileSize'">{{ formatFileSize(record.fileSize) }}</template>
                    <template v-if="column.key === 'operation'">
                      <template v-if="isThirdMediaFolder">
                        <a-tooltip title="下载"><a class="fz18"><DownloadOutlined @click="downloadUrl(record.url)"/></a></a-tooltip>
                        <a-tooltip v-hasPermi="['media:ai']" title="查看分析结果"><a class="fz20 ml5" @click="viewAnalysisFilesResults(record)"><SvgIcon name="AIshibie" :style="{color: '#1890ff'}"/></a></a-tooltip>
                      </template>
                    </template>
                  </template>
                </a-table>
              </a-spin>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>

    <div v-if="menuSelectedKey === 'media'"> <!--媒体文件-->
      <div class="header">媒体文件</div>
      <!-- 左侧树结构区域 -->
      <div class="media-page-container">
        <div class="media-tree-wrapper-device">
          <div class="tree-header">设备列表</div>
          <a-tree :tree-data="treeData" :expanded-keys="expandedKeys" @select="handleTreeSelect" show-checkbox="false"
            @expand="handleTreeExpand" :selected-keys="currentSelectedKey ? [currentSelectedKey] : []" class="media-tree" />
        </div>

        <div class="media-tree-wrapper">
          <div class="tree-header">
            <span>飞行记录</span>
            <a-range-picker v-model:value="imgFlyDate" format="YYYY-MM-DD HH:mm:ss" size="small" style="width: 170px;"
              @change="fetchFlyRecordData" class="ml5 media-range-style" />
            <ReloadOutlined class="ml5 fz12" @click="resetFlyData"/>
          </div>
          <div class="fly-overflow">
            <div v-for="flyData in flyRecordData" :key="flyData.id">
                <div class="fly-panel pt5" @click="handleFlyRecordClick(flyData)" :class="{ active: currentFlyRecord?.id === flyData.id }">
                  <a-badge show-zero :count="flyData.image_count !== undefined ? flyData.image_count : flyData.media_count" :number-style="{ backgroundColor: '#2db7f5' }" class="fly-badge"/>
                  <div class="title">
                    <a-tooltip :title="flyData.type">
                      <div class="fly-name">{{ flyData.type }}</div>
                    </a-tooltip>
                    <a-tooltip :title="flyData.device_name">
                      <div class="way-user">
                        {{ flyData.parent_name }}
                      </div>
                    </a-tooltip>
                  </div>
                  <div class="ml10 mt5 way-color"></div>
                  <div class="mt25 ml10 way-color1">
                    <span class="mr10">{{ flyData.start_time }}</span>
                  </div>
                </div>
            </div>
          </div>
          <a-pagination simple :current="pagination.page" :page-size="pagination.page_size" :total="pagination.total" @change="handlePageChange" class="mt15 ml5" />
        </div>

        <!-- 右侧列表区域 -->
        <div class="media-content-wrapper">
          <a-spin :spinning="loading" :delay="1000" tip="下载中..." size="large">
            <div class="ml20 mt20 mr20 flex-row flex-align-center flex-justify-between">
              <div class="flex-row">
                <a-select v-model:value="panoramaSelect" @change="getFiles(true)" placeholder="图片类型">
                  <a-select-option value="false">普通图片</a-select-option>
                  <a-select-option value="true">全景图片</a-select-option>
                  <a-select-option value="1">红外图片</a-select-option>
                </a-select>
                <a-button-group>
                  <a-button @click="handleQuickSelect('yesterday')"
                    :type="rangeType === 'yesterday' ? 'primary' : 'default'">昨日</a-button>
                  <a-button @click="handleQuickSelect('today')" :type="rangeType === 'today' ? 'primary' : 'default'"
                    class="ml10">今日</a-button>
                </a-button-group>
                <a-range-picker v-model:value="imgDataTime" format="YYYY-MM-DD HH:mm:ss" :placeholder="['开始时间', '结束时间']"
                  @change="handleCustomDateChange" class="ml10" />
                <a-button type="primary" class="width-80" @click="getFiles(true)"><SearchOutlined />查询</a-button>
                <a-button type="primary" class="width-80" @click="reset(1)"><SyncOutlined />重置</a-button>
                <a-button type="primary" class="width-80" @click="exportMadel"><ExportOutlined />导出</a-button>
                <a-button type="primary" @click="handleImageSynthesis" :disabled="selectedRowKeys.length < 2"
                  :title="selectedRowKeys.length < 2 ? '请至少选择2张图片进行合成' : ''">
                  <SwitcherOutlined />图片合成
                </a-button>
                <span>{{ `已选择 ${selectedRowKeys.length} 张图片` }}</span>
              </div>
              <!-- 可加筛选项 -->
            </div>
            <div class="media-panel-wrapper">
              <a-table class="media-table" :columns="columns" :data-source="mediaData.data" row-key="file_id"
                :pagination="paginationProp" :scroll="{ x: '100%', y: 600 }" @change="refreshData"
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, getCheckboxProps: getCheckboxProps }">
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'url'">
                    <template v-if="record.file_type === 'jpeg' || record.file_type === 'jpg' || record.file_type === 'png'">
                      <a-spin tip="缩略图正在生成中..." v-if="!record.abbreviation_url"></a-spin>
                      <img v-else :src="record.abbreviation_url" class="img-thumbnail"
                        @click="handleMediaImagePreview(record.url, mediaData.data.indexOf(record), record)" />
                      <SvgIcon name="AIshibie" :size="30" class="ai-position" v-if="record.analysis_result"/>
                    </template>
                  </template>
                  <template v-if="column.key === 'img'">
                    <div class="media-item-container">
                      <span class="media-item-filename" :title="record.file_name">{{ record.file_name }}</span>
                    </div>
                  </template>
                  <template v-if="column.dataIndex === 'panorama'">
                    <span v-if="record.panorama">全景图</span>
                    <span v-else-if="record.panorama === false && record.sub_file_type === 1">红外图</span>
                    <span v-else-if="record.panorama === false && record.sub_file_type === 0">普通图</span>
                  </template>
                  <template v-if="column.dataIndex === 'in_report'">
                    <a-switch :checked="record.in_report === 0" checked-children="是" un-checked-children="否" @change="(checked) => inReportFileChange(checked, record)" />
                  </template>
                  <template v-if="column.dataIndex === 'drone'">
                    <a-tooltip :title="record.drone">
                      {{ formatDeviceSn(record.drone) }}
                    </a-tooltip>
                  </template>
                  <template v-if="column.key === 'action'">
                    <a-tooltip v-hasPermi="['media:download']" title="下载">
                      <a class="fz18" @click="downloadMedia(record)">
                        <DownloadOutlined />
                      </a>
                    </a-tooltip>
                    <a-tooltip v-hasPermi="['media:preview']" title="图片预览">
                      <template v-if="record.url.toLowerCase().includes('mp4')"></template>
                      <template v-else>
                        <span @click="handleMediaImagePreview(record.url, mediaData.data.indexOf(record), record)"
                          class="media-item-video-preview fz18 ml5">
                          <EyeTwoTone />
                        </span>
                      </template>
                    </a-tooltip>
                    <a-tooltip v-hasPermi="['media:ai']" title="查看分析结果">
                      <a class="fz20 ml5" @click="viewAnalysisFilesResults(record)">
                        <SvgIcon name="AIshibie" :style="{color: '#1890ff'}"/>
                      </a>
                    </a-tooltip>
                    <a-tooltip v-hasPermi="['media:status']" :title="record.map_load?'地图隐藏':'地图显示'">
                      <a class="fz18 ml8" @click="handleImgMapLoadStatus(record,!record.map_load,'map_load')">
                        <i :class="['iconfont', record.map_load ? 'icon-map-off' : 'icon-map-on']"></i>
                      </a>
                    </a-tooltip>
                    <a-dropdown v-if="record.analysis_result" v-hasPermi="['media:regulations','media:ai']">
                      <a-tooltip title="更多" placement="top">
                        <SmallDashOutlined class="fz20 c189 ml8" @click.prevent />
                      </a-tooltip>
                      <template #overlay>
                        <a-menu>
                          <a-menu-item v-hasPermi="['media:ai']">
                            <a-tooltip title="查看AI分析图片">
                              <SvgIcon name="AI-Photo" @click="openAIAnalysisPhoto(record)" class="fz20 cur-p"/>
                            </a-tooltip>
                          </a-menu-item>
                          <!-- <a-menu-item>
                            <a-tooltip v-hasPermi="['media:regulations']" title="添加规章制度条约">
                              <DiffOutlined @click="openRegulations(record)" class="fz18 cur-p c189"/>
                            </a-tooltip>
                          </a-menu-item> -->
                        </a-menu>
                      </template>
                    </a-dropdown>
                  </template>
                </template>
              </a-table>
            </div>
          </a-spin>

          <!--全景-->
          <a-modal class="pic-modal" v-model:visible="panaraShow" :footer="null" width="80%" @cancel="handleCancel" :zIndex="10">
            <template #title>
              <div>图片预览--{{ currentMediaFileInfo?.file_name }}</div>
            </template>
            <div>
              <a-spin :spinning="mediaPanoramaLoading" tip="全景图加载中..." size="large">
                <PanoramaViewer :panorama="mediaPanoramaUrl" :minFov="20" :maxFov="100" :defaultZoomLvl="60"
                  :mousewheel="true" :touchmoveTwoFingers="true" :showNavbar="false" :zoomSpeed="1.5"
                  @load="mediaPanoramaLoading = false" class="panoStyle" />
              </a-spin>
            </div>
            <div class="pana-info-overlay">
              <div>经度: {{ Number(currentMediaFileInfo?.lon).toFixed(6) || '-' }}</div>
              <div>纬度: {{ Number(currentMediaFileInfo?.lat).toFixed(6) || '-' }}</div>
              <div v-show="currentMediaFileInfo?.absolute_altitude">海拔高度: {{ currentMediaFileInfo?.absolute_altitude + ' m' || '-' }}</div>
              <div>时间: {{ currentMediaFileInfo?.create_time || '-' }}</div>
              <div>负载: {{ currentMediaFileInfo?.payload || '-' }}</div>
            </div>
          </a-modal>

          <a-modal v-model:visible="exportShow" title="导出" :width="720" @cancel="exportShow = false" @ok="doExport" :zIndex="10">
            <div class="export-modal-content">
              <a-tabs v-model:activeKey="exportTabKey">
                <a-tab-pane key="today" tab="今天" />
                <a-tab-pane key="yesterday" tab="昨天" />
                <a-tab-pane key="custom" tab="自定义时间">
                  <div class="export-field">
                    <span class="export-label">开始时间</span>
                    <a-date-picker v-model:value="customStart" :show-time="{ format: 'HH:mm:ss' }"
                      format="YYYY-MM-DD HH:mm:ss" placeholder="选择开始时间" class="export-picker" />
                  </div>
                  <div class="export-field">
                    <span class="export-label">结束时间</span>
                    <a-date-picker v-model:value="customEnd" :show-time="{ format: 'HH:mm:ss' }"
                      format="YYYY-MM-DD HH:mm:ss" placeholder="选择结束时间" class="export-picker" />
                  </div>
                </a-tab-pane>
              </a-tabs>
              <div class="export-field">
                <span class="export-label">设备</span>
                <a-select ref="select" v-model:value="droneValue" allow-clear class="export-select">
                  <a-select-option v-for="item in droneDataList" :key="item.device_sn" :value="item.device_sn">
                    {{ item.nickname }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </a-modal>
        </div>
      </div>
    </div>

    <div v-if="menuSelectedKey === 'history_play'"> <!--历史回放-->
      <div class="header">历史回放</div>
      <div class="media-page-container">
        <div class="media-tree-wrapper-device">
          <div class="tree-header">设备列表</div>
          <a-tree :tree-data="treeData" :expanded-keys="expandedKeys" @select="handleTreeSelect" show-checkbox="false"
            @expand="handleTreeExpand" :selected-keys="currentSelectedKey ? [currentSelectedKey] : []" class="media-tree" />
        </div>

        <div class="media-tree-wrapper">
          <div class="tree-header">
            <span>飞行记录</span>
            <a-range-picker v-model:value="imgFlyDate" format="YYYY-MM-DD HH:mm:ss" :size="'small'"
              style="width: 170px;" @change="fetchFlyRecordData" class="ml5" />
              <ReloadOutlined class="ml5 fz12" @click="resetFlyData"/>
          </div>
          <div class="fly-overflow">
            <div v-for="flyData in flyRecordData" :key="flyData.id">

              <div class="fly-panel pt5" @click="handleFlyRecordClick(flyData)" :class="{ active: currentFlyRecord?.id === flyData.id }">
                <a-badge show-zero :count="flyData.video_count !== undefined ? flyData.video_count : flyData.media_count" :number-style="{ backgroundColor: '#2db7f5' }" class="fly-badge"/>
                <div class="title">
                  <a-tooltip :title="flyData.type">
                    <div class="pr10 fly-name">{{ flyData.type }}</div>
                  </a-tooltip>
                  <a-tooltip :title="flyData.device_name">
                    <div class="ml5 pr10 way-user">{{ flyData.parent_name }}</div>
                  </a-tooltip>
                </div>
                <div class="mt25 ml10 way-color1">
                  <span class="mr10">{{ flyData.start_time }}</span>
                </div>
              </div>
            </div>
          </div>
          <a-pagination simple :current="pagination.page" :page-size="pagination.page_size" :total="pagination.total" @change="handlePageChange" class="mt15 ml5" />
        </div>

        <div class="media-content-wrapper">
          <a-spin :spinning="loading" :delay="1000" tip="下载中..." size="large">
            <div class="ml20 mt20 mr20 flex-row flex-align-center flex-justify-between">
              <div class="flex-row">
                <a-button-group>
                  <a-button @click="handleQuickSelect('yesterday')"
                    :type="rangeType === 'yesterday' ? 'primary' : 'default'">昨日</a-button>
                  <a-button @click="handleQuickSelect('today')" :type="rangeType === 'today' ? 'primary' : 'default'"
                    class="ml10">今日</a-button>
                </a-button-group>
                <a-range-picker v-model:value="vidDataTime" format="YYYY-MM-DD HH:mm:ss" :placeholder="['开始时间', '结束时间']"
                  @change="handleCustomDateChange" class="ml10" />
                <a-button type="primary" class="width-80" @click="getHistoryPlayFiles(true)"><SearchOutlined />查询</a-button>
                <a-button type="primary" class="width-80" @click="reset(2)"><SyncOutlined />重置</a-button>
                <a-button type="primary" class="width-80" @click="exportMadel"><ExportOutlined />导出</a-button>
              </div>
              <!-- 可加筛选项 -->
            </div>
            <div class="media-panel-wrapper">
              <a-table class="media-table" :columns="historyPlayColumns" :data-source="historyPlayData.data"
                row-key="fingerprint" :pagination="paginationHistoryPlayProp" :scroll="{ x: '100%', y: 600 }"
                @change="refreshHistoryPlayData">
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'img'">
                    <div class="media-item-container">
                      <span class="media-item-filename" :title="record.file_name">{{ record.file_name }}</span>
                    </div>
                  </template>
                  <template v-if="column.key === 'panoramas'">
                    <span v-if="isVideo(record)">视频</span>
                  </template>
                  <template v-if="column.key === 'drone'">
                    <a-tooltip :title="record.drone">
                      {{ formatDeviceSn(record.drone) }}
                    </a-tooltip>
                  </template>
                  <template v-if="column.key === 'action'">
                    <a-tooltip v-hasPermi="['media:download']" title="下载">
                      <a class="fz18" @click="downloadMediaVideo(record)">
                        <DownloadOutlined />
                      </a>
                    </a-tooltip>
                    <a-tooltip v-hasPermi="['media:preview']" title="视频预览">
                      <template v-if="record.url.toLowerCase().includes('mp4')">
                        <span @click="showHistoryVideo(record.url, record)" class="media-item-video-preview ml5 fz18">
                          <EyeTwoTone />
                        </span>
                      </template>
                    </a-tooltip>
                    <a-tooltip v-hasPermi="['media:status']" :title="record.map_load?'地图隐藏':'地图显示'">
                      <a class="fz18 ml8" @click="handleImgMapLoadStatus(record,!record.map_load,'map_load')">
                        <i :class="['iconfont', record.map_load ? 'icon-map-off' : 'icon-map-on']"></i>
                      </a>
                    </a-tooltip>
                  </template>
                </template>
              </a-table>
            </div>
          </a-spin>
          <a-modal class="video-modal" v-model:visible="videoShow" @cancel="videoShowCancel" :footer="null" width="60%" :zIndex="10">
            <template #title>
              <div>视频预览--{{ currentHistoryVideoInfo?.file_name }}</div>
            </template>

            <video v-if="videoUrl" class="width-100 max-height-600" controls loop muted autoplay preload="auto">
              <source :src="videoUrl" type="video/mp4">
            </video>
            <div class="info-overlay-folder-video">
              <div>经度: {{ Number(currentHistoryVideoInfo?.lon).toFixed(6) || '-' }}</div>
              <div>纬度: {{ Number(currentHistoryVideoInfo?.lat).toFixed(6) || '-' }}</div>
              <div>时间: {{ currentHistoryVideoInfo?.create_time || '-' }}</div>
              <div>负载: {{ currentHistoryVideoInfo?.payload || '-' }}</div>
            </div>
          </a-modal>
          <a-modal v-model:visible="exportShow" title="导出" :width="720" @cancel="exportShow = false" @ok="doExport" :zIndex="10">
            <div class="export-modal-content">
              <a-tabs v-model:activeKey="exportTabKey">
                <a-tab-pane key="today" tab="今天" />
                <a-tab-pane key="yesterday" tab="昨天" />
                <a-tab-pane key="custom" tab="自定义时间">
                  <div class="export-field">
                    <span class="export-label">开始时间</span>
                    <a-date-picker v-model:value="customStart" :show-time="{ format: 'HH:mm:ss' }"
                      format="YYYY-MM-DD HH:mm:ss" placeholder="选择开始时间" class="export-picker" />
                  </div>
                  <div class="export-field">
                    <span class="export-label">结束时间</span>
                    <a-date-picker v-model:value="customEnd" :show-time="{ format: 'HH:mm:ss' }"
                      format="YYYY-MM-DD HH:mm:ss" placeholder="选择结束时间" class="export-picker" />
                  </div>
                </a-tab-pane>
              </a-tabs>
              <div class="export-field">
                <span class="export-label">设备</span>
                <a-select ref="select" v-model:value="droneValue" allow-clear class="export-select">
                  <a-select-option v-for="item in droneDataList" :key="item.device_sn" :value="item.device_sn">
                    {{ item.nickname }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </a-modal>
        </div>
      </div>
    </div>

    <div v-if="menuSelectedKey === 'composite_file'" class="width-100">
      <div class="header">合成文件</div>
      <div class="m10">
        <a-input v-model:value="compositeName" placeholder="请输入要搜索的文件名" class="width-200 mr10" @change="fetchCompositeData(true)"></a-input>
        <a-select v-model:value="compositeSelect" placeholder="合成方式" @change="fetchCompositeData(true)">
          <a-select-option value="fusion">融合合成</a-select-option>
          <a-select-option value="opencv">特征合成</a-select-option>
          <a-select-option value="orb">特质合成</a-select-option>
          <a-select-option value="simple">拼凑合成</a-select-option>
        </a-select>
        <a-button type="primary" class="ml10" @click="fetchCompositeData(true)"><SearchOutlined />查询</a-button>
        <a-button type="primary" class="ml10" @click="refreshCompositeData"><SyncOutlined />重置</a-button>
      </div>
      <div class="m10 pr10">
        <a-table :columns="compositeColumns" :data-source="compositeTableDatas" row-key="id"
          :pagination="compositePaginationProp" @change="handleCompositeTableChange" :scroll="{ x: '100%', y: 600 }">
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'type'">{{ compositeEmus[record.type] }}</template>
            <template v-if="column.url === 'url'"><img :src="record.url" class="img-thumbnail" @click="openCompositeFile(record)" /></template>
            <template v-if="column.action === 'action'">
              <a-tooltip v-hasPermi="['media:preview']" title="查看原图" @click="openCompositeFile(record)">
                <a class="fz18 mr10">
                  <EyeTwoTone />
                </a>
              </a-tooltip>
              <a-tooltip v-hasPermi="['media:download']" title="下载">
                <a class="fz18" @click="downloadUrl(record.url)">
                  <DownloadOutlined />
                </a>
              </a-tooltip>
            </template>
          </template>
        </a-table>
      </div>
    </div>

    <div v-if="menuSelectedKey === 'monitoring'" class="width-100">
      <div class="header">图片检测</div>
      <div class="m10">
        <a-select v-model:value="monitorTypeValue" placeholder="状态" @change="fetchMonitorData" class="width-120">
          <a-select-option value="SUCCESS">成功</a-select-option>
          <a-select-option value="FAILED">失败</a-select-option>
          <a-select-option value="PENDING">待处理</a-select-option>
          <a-select-option value="RUNNING">处理中</a-select-option>
        </a-select>
        <a-input v-model:value="monitorName" placeholder="请输入要搜索的文件名称" @change="fetchMonitorData" class="width-200 ml10"></a-input>
        <a-range-picker class="ml10" v-model:value="monitorDataTime" @change="fetchMonitorData"/>
        <a-button type="primary" class="ml10" @click="fetchMonitorData"><SearchOutlined />查询</a-button>
        <a-button type="primary" class="ml10" @click="handleMonitorReset"><SyncOutlined />重置</a-button>
        <a-button type="primary"  v-hasPermi="['media:add']" @click="handleMonitorCreate" class="ml10" style="background-color: #67C23A; border-color: #67C23A;"><PlusOutlined />创建变化检测任务</a-button>
      </div>
      <div class="monitor-content">
        <div class="monitor-list">
          <div class="monitor-container" v-for="item in monitorValue" :key="item.id">
            <a-image-preview-group>
              <div>
                <div class="fz15">目标图片(源图)</div>
                <div class="mt10">
                  <a-image :src="item.sourceImageUrl" width="300px" height="250px"/>
                </div>
              </div>
              <div>
                <div class="fz15">对比图片(目标图)</div>
                <div class="mt10">
                  <a-image :src="item.targetImageUrl" width="300px" height="250px"/>
                </div>
              </div>
              <div>
                <div class="fz15">配准后目标图</div>
                <div class="mt10">
                  <a-image :src="item.matchedSourceImageUrl" width="300px" height="250px"/>
                </div>
              </div>
              <div>
                <div class="fz15">配准后对比图</div>
                <div class="mt10">
                  <a-image :src="item.matchedTargetImageUrl" width="300px" height="250px"/>
                </div>
              </div>
              <div class="monitor-result">
                <div class="monitor-result-header mb10">
                  <a-collapse v-model:activeKey="panelActiveKeys[item.id]" ghost  class="monitor-title monitor-collapse">
                    <a-collapse-panel key="1" header="变化检测结果">
                      <div class="result-container">
                        <div class="result-content">
                          <div>
                            配准模型：
                            <a-tooltip title="图像配准使用的几何变换模型，HOMOGRAPHY适用于透视差异较大的场景">
                              <QuestionCircleOutlined />
                            </a-tooltip>
                          </div>
                          <div>{{ item.alignmentModel }}</div>
                        </div>
                        <div class="result-content">
                          <div>
                            光照模式：
                            <a-tooltip title="处理光照差异的方法，NORMALIZE_MEAN_STD可减小光照影响提高配准稳定性">
                              <QuestionCircleOutlined />
                            </a-tooltip>
                          </div>
                          <div>{{ item.illuminanceMode }}</div>
                        </div>
                        <div class="result-content">
                          <div>ORB特征数：
                            <a-tooltip title="提取的特征点数量，值越大检测越精细但处理速度越慢（范围：1000-20000）">
                              <QuestionCircleOutlined />
                            </a-tooltip>
                          </div>
                          <div>{{ item.orbFeatures }}</div>
                        </div>
                        <div class="result-content">
                          <div>匹配比例：
                            <a-tooltip title="特征匹配阈值，值越大匹配条件越严格，误匹配越少但可能漏配（范围：0.5-0.95）">
                              <QuestionCircleOutlined />
                            </a-tooltip>
                          </div>
                          <div>{{ item.matchRatio }}</div>
                        </div>
                        <div class="result-content">
                          <div>RANSAC阈值：
                            <a-tooltip title="异常值剔除阈值，值越大对误匹配点的容忍度越高（范围：1-10像素）">
                              <QuestionCircleOutlined />
                            </a-tooltip>
                          </div>
                          <div>{{ item.ransacReprojThreshold }}</div>
                        </div>
                        <div class="result-content">
                          <div>最小轮廓比例：
                            <a-tooltip title="过滤小噪点的面积阈值，值越大过滤越多小区域，检测结果更干净（范围：0.00001-0.001）">
                              <QuestionCircleOutlined />
                            </a-tooltip>
                          </div>
                          <div>{{ item.minContourAreaRatio }}</div>
                        </div>
                        <div class="result-content">
                          <div>合并框I0U：
                            <a-tooltip title="检测框合并的交并比阈值，值越大越容易合并相邻的检测框（范围：0.1-0.9）">
                              <QuestionCircleOutlined />
                            </a-tooltip>
                          </div>
                          <div>{{ item.mergeBoxIou }}</div>
                        </div>
                        <div class="result-content">
                          <div>最大框数：
                            <a-tooltip title="输出检测结果的最大数量限制，超过此数量的变化区域将被忽略（范围：10-500）">
                              <QuestionCircleOutlined />
                            </a-tooltip>
                          </div>
                          <div>{{ item.maxBoxes }}</div>
                        </div>
                        <div class="result-content">
                          <div>最小内点数：
                            <a-tooltip title="图像配准质量要求，值越大配准条件越严格，配准失败的概率增加（范围：10-200）">
                              <QuestionCircleOutlined />
                            </a-tooltip>
                          </div>
                          <div>{{ item.minInliers }}</div>
                        </div>
                        <div class="result-content">
                          <div>最小绝对差：
                            <a-tooltip title="Otsu阈值后的最小差值过滤，值越大变化检测越严格，细微变化可能被忽略（范围：0-100）">
                              <QuestionCircleOutlined />
                            </a-tooltip>
                          </div>
                          <div>{{ item.minAbsdiffAfterOtsu }}</div>
                        </div>
                      </div>
                      <template #extra>
                        <div class="display-flex text-align-center">
                          <a-tag :color="statusConfig[item.status]?.color || 'gray'" class="monitor-tag">
                            {{ statusConfig[item.status]?.text || '未知' }}
                          </a-tag>
                          <a-tooltip :title="item.errorMsg">
                            <QuestionCircleOutlined v-if="item.status === 'FAILED'" style="color: red; font-size: 15px; margin-top: 7%;"/>
                          </a-tooltip>
                        </div>
                      </template>
                    </a-collapse-panel>
                  </a-collapse>
                </div>
                <div class="mb20">
                  <div class="monitor-message">
                    <div class="mb5">监测到 {{ item.changeAreaCount }} 处变化区域</div>
                    <div class="mb5">监测用时：{{ item.detectDurationMs / 1000 }}秒</div>
                    <div class="mb5">检测时间：{{ item.createTime }}</div>
                    <div class="mb5">任务名称：{{ item.name }}</div>
                    <div class="mb10">变化数量：{{ item.changeAreaCount }}</div>
                  </div>
                </div>
                <a-space wrap>
                  <a-button v-hasPermi="['media:download']" type="primary" @click="downloadUrl(item.matchedSourceImageUrl)" size="small"><DownloadOutlined />配准后目标图</a-button>
                  <a-button v-hasPermi="['media:download']" type="primary" class="ml5" @click="downloadUrl(item.matchedTargetImageUrl)" size="small"><DownloadOutlined />配准后对比图</a-button>
                  <a-button type="primary" @click="resetMonitor(item)" size="small" style="background-color: #E6A23C; border-color: #E6A23C;"><SyncOutlined />手动调整参数</a-button>
                  <a-button type="primary" class="ml5" @click="historyMonitor(item)" style="background-color: #909399; border-color: #909399;" size="small"><FieldTimeOutlined />历史记录</a-button>
                </a-space>
              </div>
            </a-image-preview-group>
          </div>
        </div>
      </div>
      <div class="pagination-wrapper">
        <a-pagination
          v-model:current="monitorPagination.current"
          v-model:pageSize="monitorPagination.pageSize"
          :total="monitorPagination.total"
          :page-size-options="monitorPagination.pageSizeOptions"
          show-size-changer
          show-quick-jumper
          :show-total="(total: number) => `总计 ${total} 条`"
          @change="handleMonitorPageChange"
          @showSizeChange="handleMonitorPageSizeChange"
        />
      </div>
    </div>

    <a-modal v-model:visible="mediaFolderVisible" :footer="null" title="分析结果" @cancel="cancelAnalysisResults">
          <div v-if="folderAnalysisLoading" class="analysis-loading">
            <a-spin tip="分析结果加载中..." size="large" />
          </div>
          <div v-else class="analysis-results-container">
            <div v-if="mediaFolderMes && mediaFolderMes.length > 0" class="analysis-items">
              <div v-for="(item, index) in mediaFolderMes" :key="index" class="analysis-item">
                <div class="analysis-item-content">
                  <span class="analysis-name">{{ item.name }}：</span>
                  <span class="analysis-name">{{ item.count }}</span>
                </div>
              </div>
            </div>
            <div v-else class="no-analysis-results">
              <a-empty description="当前无分析结果" />
            </div>
          </div>
        </a-modal>

    <a-modal v-model:visible="newFolderVisible" title="新建文件夹" @ok="handleFolderSubmit" @cancel="cancelFolderSubmit" centered>
          <div>
            <a-form ref="createFormRef" :model="createForm" :rules="createRules" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
              <a-form-item label="文件夹名称" name="name">
                <a-input v-model:value="createForm.name" placeholder="请输入文件夹名称"/>
              </a-form-item>
              <a-form-item label="飞行类型" name="flightType">
                <a-select v-model:value="createForm.flightType" placeholder="请选择">
                  <a-select-option v-for="item in flightTypeSelectValue" :key="item.dictValue" :value="item.dictValue">{{ item.dictLabel }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-form>
          </div>
        </a-modal>

    <a-modal v-model:visible="removeFolderVisible" title="文件移动" @ok="handleRemoveSubmit" @cancel="cancelRemoveSubmit" width="60%" centered>
          <a-table :columns="removeColumns" :data-source="removeDatas" row-key="id" :pagination="removePaginationProp"
            @change="handleRemoveChange" :scroll="{ x: '100%', y: 600 }" :row-selection="removeRowSelection">
            <template #bodyCell="{ column, record }">
              <template v-if="column.key === 'flightType'">{{ getFlightTypeLabel(record.flight_type) }}</template>
            </template>
          </a-table>
        </a-modal>

    <a-modal v-model:visible="newModelVisible" title="正射影像生成" @ok="handleModelSubmit" @cancel="cancelModelSubmit" centered>
          <div>
            <a-form ref="modelFormRef" :model="modelForm" :rules="modelRules" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
              <a-form-item label="文件名称" name="name">
                <a-input v-model:value="modelForm.name" placeholder="请输入文件名称"/>
              </a-form-item>
              <a-form-item label="设备" name="device">
                <template v-if="isDeviceFixed">
                  <a-input :value="fixedDeviceNickname" disabled />
                  <input type="hidden" v-model="modelForm.device" />
                </template>
                <template v-else>
                  <a-select v-model:value="modelForm.device" placeholder="请选择设备">
                    <a-select-option v-for="item in deviceSelectValue" :key="item.workspace_id" :value="item.workspace_id">
                      {{ item.nickname }}
                    </a-select-option>
                  </a-select>
                </template>
              </a-form-item>
            </a-form>
            <div v-if="progressPercent > 0" style="margin-top: 16px; text-align: center;">
              <a-progress :percent="progressPercent" status="active" />
            </div>
          </div>
          <template #footer>
            <a-button @click="cancelModelSubmit">取消</a-button>
            <a-button type="primary" :loading="modelLoading" @click="handleModelSubmit">确定</a-button>
          </template>
        </a-modal>

        <a-modal class="pic-modal" v-model:visible="imageShow" :footer="null" width="60%" @cancel="handleCancel" :zIndex="10">
            <template #title>
              <div>图片预览--{{ currentMediaFileInfo?.file_name || currentMediaFileInfo.fileName }}</div>
            </template>
            <div class="preview-container">
              <!-- 主预览图 -->
              <div class="main-preview" @mousedown.prevent="startDrag" @mousemove.prevent="handleDrag"
                @mouseup.prevent="stopDrag" @mouseleave.prevent="stopDrag">

                <a-spin :spinning="mediaImageLoading || analysisLoading" :tip="loadingTip" size="large">
                  <!-- 原图显示区域 -->
                  <div v-show="analysisChecked && analysisUrl" class="image-wrapper">
                    <img v-if="analysisUrl" :src="analysisUrl" class="preview-image" alt="分析图片"
                      @load="handleAnalysisImageLoad"
                      @error="handleAnalysisImageError"
                      @wheel.prevent="handleZoom"
                      :style="{
                        transform: `scale(${scale}) translate(${x}px, ${y}px)`,
                        cursor: isDragging ? 'grabbing' : 'auto'
                      }" :class="{
                        'zoom-out-cursor': scale > 1,
                        'zoom-in-cursor': scale <= 1
                      }" />
                  </div>

                  <div v-show="!analysisChecked || !analysisUrl" class="image-wrapper">
                    <img v-if="imageUrl" :src="imageUrl" class="preview-image" alt="预览图片"
                      @load="handleOriginalImageLoad"
                      @error="handleOriginalImageError"
                      @wheel.prevent="handleZoom"
                      :style="{
                        transform: `scale(${scale}) translate(${x}px, ${y}px)`,
                        cursor: isDragging ? 'grabbing' : 'auto'
                      }" :class="{
                        'zoom-out-cursor': scale > 1,
                        'zoom-in-cursor': scale <= 1
                      }" />
                  </div>
                </a-spin>

                <div v-if="analysisChecked && !analysisLoading && analysisUrl && analysisResults && analysisResults.length > 0" class="analysis-results-float">
                  <div class="analysis-results-header">
                    <span>分析结果</span>
                  </div>
                  <div class="analysis-results-content">
                    <div v-for="(item, index) in analysisResults" :key="index" class="analysis-result-item">
                      <span class="result-name">{{ item.name || item.type }} ：</span>
                      <span class="result-count">{{ item.count || '0' }}</span>
                    </div>
                  </div>
                </div>
                <div v-else-if="analysisMessage" class="analysis-results-float">
                  <div class="analysis-results-content">
                    <span class="no-analysis-data">当前无分析对象</span>
                  </div>
                </div>

                <div class="info-overlay">
                  <div v-if="currentMediaFileInfo?.lon">经度: {{ Number(currentMediaFileInfo?.lon).toFixed(6) || '-' }}</div>
                  <div v-if="currentMediaFileInfo?.lat">纬度: {{ Number(currentMediaFileInfo?.lat).toFixed(6) || '-' }}</div>
                  <div v-if="currentMediaFileInfo?.absolute_altitude" v-show="currentMediaFileInfo?.absolute_altitude">海拔高度: {{ currentMediaFileInfo?.absolute_altitude + ' m' || '-' }}</div>
                  <div v-if="currentMediaFileInfo?.create_time || currentMediaFileInfo?.createTime">时间: {{ currentMediaFileInfo?.create_time || currentMediaFileInfo?.createTime || '-' }}</div>
                  <div v-if="currentMediaFileInfo?.payload">负载: {{ currentMediaFileInfo?.payload || '-' }}</div>
                </div>
              </div>

              <div class="thumbnail-nav">
                <div>
                  <span class="ml10">目标检测:</span>
                  <a-switch v-model:checked="analysisChecked" @change="handleAnalysisChange" :loading="analysisLoading" :disabled="mediaImageLoading" class="ml10"/>
                  <!-- <span v-show="analysisMessage" class="ml10">当前分析对象为0</span> -->
                </div>
                <div class="zoom-controls">
                  <ZoomOutOutlined @click="scale = Math.max(0.5, scale - 0.1)" />
                  <span>{{ Math.round(scale * 100) }}%</span>
                  <ZoomInOutlined @click="scale = Math.min(3, scale + 0.1)" />
                  <a-button @click="resetImage">重置</a-button>
                </div>
              </div>
            </div>
          </a-modal>

    <a-modal
      v-model:visible="monitorCreateVisible"
      title="创建变化检测任务"
      width="920px"
      :destroyOnClose="true"
      :maskClosable="false"
      @cancel="resetCreateTaskDialog"
    >
      <div class="monitor-create-body">
        <!-- 任务名称 -->
        <a-form ref="createTaskFormRef" :model="createTaskForm" :rules="createTaskRules">
          <a-form-item label="任务名称" name="name">
            <a-input v-model:value="createTaskForm.name" placeholder="请输入任务名称" :maxlength="80" showCount />
          </a-form-item>
        </a-form>

        <a-collapse v-model:activeKey="advancedActiveKey" class="advanced-collapse" :bordered="true">
          <a-collapse-panel key="1" header="高级比对参数（可选，默认已优化）">
            <a-row :gutter="16">
              <a-col :span="12">
                <a-form-item label="对齐模型" :tooltip="alignmentModelTooltip">
                  <a-select v-model:value="createTaskForm.alignmentModel">
                    <a-select-option value="HOMOGRAPHY">HOMOGRAPHY (透视变换)</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="光照模式" :tooltip="illuminanceModeTooltip">
                  <a-select v-model:value="createTaskForm.illuminanceMode">
                    <a-select-option value="NORMALIZE_MEAN_STD">NORMALIZE_MEAN_STD (归一化)</a-select-option>
                    <a-select-option value="STANDARD">STANDARD (标准)</a-select-option>
                    <a-select-option value="GRADIENT_MAGNITUDE">GRADIENT_MAGNITUDE (梯度)</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="ORB特征点数" tooltip="特征点提取数量，值越大检测越精细但速度越慢（1000-20000）">
                  <a-input-number v-model:value="createTaskForm.orbFeatures" :min="1000" :max="20000" :step="1000" style="width: 100%" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="匹配比率" tooltip="特征匹配阈值，值越大越严格，误匹配少但可能漏配（0.5-0.95）">
                  <a-input-number v-model:value="createTaskForm.matchRatio" :min="0.5" :max="0.95" :step="0.01" style="width: 100%" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="RANSAC阈值" tooltip="异常值剔除阈值，值越大对误匹配容忍度越高（1-10像素）">
                  <a-input-number v-model:value="createTaskForm.ransacReprojThreshold" :min="1" :max="10" :step="0.01" style="width: 100%" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="轮廓面积比例" tooltip="过滤小噪点的阈值，值越大过滤越多小区域（0.00001-0.001）">
                  <a-input-number v-model:value="createTaskForm.minContourAreaRatio" :min="0.00001" :max="0.001" :step="0.00001" :precision="5" style="width: 100%" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="合并框IoU" tooltip="检测框合并阈值，值越大越容易合并相邻框（0.1-0.9）">
                  <a-input-number v-model:value="createTaskForm.mergeBoxIou" :min="0.1" :max="0.9" :step="0.01" style="width: 100%" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="最大框数量" tooltip="检测结果最大数量限制，超过此值的变化区域被忽略（10-500）">
                  <a-input-number v-model:value="createTaskForm.maxBoxes" :min="10" :max="500" :step="10" style="width: 100%" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="最小内点数" tooltip="配准质量要求，值越大条件越严格，失败概率增加（10-200）">
                  <a-input-number v-model:value="createTaskForm.minInliers" :min="10" :max="200" :step="1" style="width: 100%" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="Otsu最小差值" tooltip="差值过滤阈值，值越大检测越严格，细微变化被忽略（0-100）">
                  <a-input-number v-model:value="createTaskForm.minAbsdiffAfterOtsu" :min="0" :max="100" :step="1" style="width: 100%" />
                </a-form-item>
              </a-col>
            </a-row>
          </a-collapse-panel>
        </a-collapse>

        <!-- 图片选择区域 -->
        <div class="image-select-section">
          <a-alert message="请选择两张图片进行对比检测，每张图片可以从系统选择或本地上传" type="info" show-icon />
          <div class="image-select-grid">
            <!-- 原图卡片 -->
            <div class="image-card" :class="{ 'is-selected': sourceImage }">
              <div class="image-card-header">
                <span class="card-title">原图（源图）</span>
                <a-tag v-if="sourceImage?.isUploaded" color="success">本地上传</a-tag>
                <a-tag v-else-if="sourceImage" color="default">系统文件</a-tag>
              </div>
              <div class="image-preview-area">
                <a-image v-if="sourceImage" :src="sourceImage.url || sourceImage.previewUrl" fit="cover" />
                <div v-else class="empty-preview">
                  <picture-outlined />
                  <span>请选择图片</span>
                </div>
              </div>
              <div class="image-actions">
                <a-button type="primary" size="small" @click="openSystemPicker('source')">从系统选择</a-button>
                <a-button type="primary" size="small" @click="triggerUpload('source')" :loading="uploadingState === 'source'">
                  <upload-outlined /> 本地上传
                </a-button>
                <a-button v-if="sourceImage" danger size="small" @click="clearImage('source')">清除</a-button>
              </div>
            </div>

            <!-- 对比图卡片 -->
            <div class="image-card" :class="{ 'is-selected': targetImage }">
              <div class="image-card-header">
                <span class="card-title">对比图（目标图）</span>
                <a-tag v-if="targetImage?.isUploaded" color="success">本地上传</a-tag>
                <a-tag v-else-if="targetImage" color="default">系统文件</a-tag>
              </div>
              <div class="image-preview-area">
                <a-image v-if="targetImage" :src="targetImage.url || targetImage.previewUrl" fit="cover" />
                <div v-else class="empty-preview">
                  <picture-outlined />
                  <span>请选择图片</span>
                </div>
              </div>
              <div class="image-actions">
                <a-button type="primary" size="small" @click="openSystemPicker('target')">从系统选择</a-button>
                <a-button type="primary" size="small" @click="triggerUpload('target')" :loading="uploadingState === 'target'">
                  <upload-outlined /> 本地上传
                </a-button>
                <a-button v-if="targetImage" danger size="small" @click="clearImage('target')">清除</a-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <a-button @click="monitorCreateVisible = false">取消</a-button>
        <a-button type="primary" :loading="createSubmitting" :disabled="!canCreateTask" @click="submitNewCreateTask">
          创建任务
        </a-button>
      </template>
    </a-modal>

    <!-- 系统图片选择弹窗 -->
    <a-modal
      v-model:visible="systemPickerVisible"
      title="选择系统图片"
      width="60%"
      :destroyOnClose="true"
      :maskClosable="false"
    >
      <div class="system-picker-body">
        <a-form layout="inline" class="picker-search-form">
          <a-form-item label="文件名称">
            <a-input v-model:value="pickerQuery.fileName" placeholder="请输入文件名称" allowClear @pressEnter="fetchSystemMediaList" />
          </a-form-item>
          <a-form-item label="开始时间">
            <a-date-picker v-model:value="pickerQuery.startTime" show-time format="YYYY-MM-DD HH:mm:ss" />
          </a-form-item>
          <a-form-item label="结束时间">
            <a-date-picker v-model:value="pickerQuery.endTime" show-time format="YYYY-MM-DD HH:mm:ss" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="fetchSystemMediaList">搜索</a-button>
            <a-button @click="resetPickerQuery" class="ml10">重置</a-button>
          </a-form-item>
        </a-form>

        <a-table
          :columns="pickerColumns"
          :data-source="systemMediaList"
          :loading="pickerLoading"
          :pagination="pickerPagination"
          row-key="file_id"
          @change="handlePickerTableChange" :scroll="{ y: 450 }"
          :row-selection="{ type: 'radio', selectedRowKeys: selectedPickerRowKey, onChange: onPickerRowSelect }"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'thumb'">
              <a-image v-if="record.abbreviation_url" :src="record.abbreviation_url" width="80" height="60" fit="cover" />
              <span v-else>无预览</span>
            </template>
            <template v-else-if="column.key === 'fileName'">{{ record.file_name }}</template>
            <template v-else-if="column.key === 'createTime'">{{ record.create_time || '--' }}</template>
          </template>
        </a-table>
      </div>

      <template #footer>
        <a-button @click="systemPickerVisible = false">取消</a-button>
        <a-button type="primary" :disabled="!selectedPickerRecord" @click="confirmPickerSelection">确定</a-button>
      </template>
    </a-modal>

    <a-modal v-model:visible="retryMonitorVisible" title="调整重试参数" width="45%" :destroyOnClose="true" :maskClosable="false" @cancel="retryMonitorCancel" :zIndex="10">
      <div class="monitor-body">
        <a-alert type="info" showIcon :closable="false" class="step-alert" message="如果存在参数完全相同的历史记录，将直接返回该记录而不再重新比对"/>
        <div class="monitor-image">
          <div class="monitorImage">
            <div class="mb5">目标图</div>
            <a-image :src="MonitorTaskData.sourceImageUrl" style="width: 100%; height: 100%; object-fit: contain" />
          </div>
          <div class="monitorImage ml50">
            <div class="mb5">对比图</div>
            <a-image :src="MonitorTaskData.targetImageUrl" style="width: 100%; height: 100%; object-fit: contain" />
          </div>
        </div>

        <a-divider>高级对比参数</a-divider>

        <div class="height-content">
          <div class="height-data">
            <a-form ref="retryMonitorFormRef" :model="retryMonitorFormData" :label-col="{ style: { width: '150px' } }" :wrapper-col="{ style: { width: '225px' } }" layout="horizontal" class="two-column-form">
              <a-form-item label="对齐模型" name="alignmentModel" :tooltip="alignmentModelTooltip">
                <a-select v-model:value="retryMonitorFormData.alignmentModel">
                  <a-select-option value="HOMOGRAPHY">HOMOGRAPHY(透视变换)</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="光照模式" name="illuminanceMode" :tooltip="illuminanceModeTooltip">
                <a-select v-model:value="retryMonitorFormData.illuminanceMode">
                  <a-select-option value="NORMALIZE_MEAN_STD">NORMALIZE_MEAN_STD(归一化)</a-select-option>
                  <a-select-option value="STANDARD">STANDARD(标准)</a-select-option>
                  <a-select-option value="GRADIENT_MAGNITUDE">GRADIENT_MAGNITUDE(梯度)</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="ORB特征点数" name="orbFeatures" :tooltip="'特征点提取数量，值越大检测越精细但速度越慢（1000-20000）'">
                <a-input-number v-model:value="retryMonitorFormData.orbFeatures" :min="1000" :max="20000" :step="1000" style="width: 100%" />
              </a-form-item>
              <a-form-item label="匹配比率" name="matchRatio" :tooltip="'特征匹配阈值，值越大越严格，误匹配少但可能漏配（0.5-0.95）'">
                <a-input-number v-model:value="retryMonitorFormData.matchRatio" :min="0.5" :max="0.95" :step="0.01" style="width: 100%" />
              </a-form-item>
              <a-form-item label="RANSAC阈值" name="ransacReprojThreshold" :tooltip="'异常值剔除阈值，值越大对误匹配容忍度越高（1-10像素）'">
                <a-input-number v-model:value="retryMonitorFormData.ransacReprojThreshold" :min="1" :max="10" :step="0.01" style="width: 100%" />
              </a-form-item>
              <a-form-item label="轮廓面积比例" name="minContourAreaRatio" :tooltip="'过滤小噪点的阈值，值越大过滤越多小区域（0.00001-0.001）'">
                <a-input-number v-model:value="retryMonitorFormData.minContourAreaRatio" :min="0.00001" :max="0.001" :step="0.00001" :precision="5" style="width: 100%" />
              </a-form-item>
              <a-form-item label="合并框IOU" name="mergeBoxIou" :tooltip="'检测框合并阈值，值越大越容易合并相邻框（0.1-0.9）'">
                <a-input-number v-model:value="retryMonitorFormData.mergeBoxIou" :min="0.1" :max="0.9" :step="0.01" style="width: 100%" />
              </a-form-item>
              <a-form-item label="最大框数量" name="maxBoxes" :tooltip="'检测结果最大数量限制，超过此值的变化区域被忽略（10-500）'">
                <a-input-number v-model:value="retryMonitorFormData.maxBoxes" :min="10" :max="500" :step="10" style="width: 100%" />
              </a-form-item>
              <a-form-item label="最小内点数" name="minInliers" :tooltip="'配准质量要求，值越大条件越严格，失败概率增加（10-200）'">
                <a-input-number v-model:value="retryMonitorFormData.minInliers" :min="10" :max="200" :step="1" style="width: 100%" />
              </a-form-item>
              <a-form-item label="Otsu最小差值" name="minAbsdiffAfterOtsu" :tooltip="'差值过滤阈值，值越大检测越严格，细微变化被忽略（0-100）'">
                <a-input-number v-model:value="retryMonitorFormData.minAbsdiffAfterOtsu" :min="0" :max="100" :step="1" style="width: 100%" />
              </a-form-item>
            </a-form>
          </div>
        </div>
      </div>

      <template #footer>
        <a-button @click="retryMonitorCancel">取消</a-button>
        <a-button type="primary" :loading="retryMonitorLoading" @click="retryMonitorSubmit">确认重试</a-button>
      </template>
    </a-modal>

    <a-modal v-model:visible="historyDialogVisible" title="对比历史记录" width="900px" :destroyOnClose="true" :maskClosable="false" class="history-dialog" @cancel="historyDialogVisible = false" :zIndex="10">
      <a-spin :spinning="historyLoading">
        <a-empty v-if="historyList.length === 0" description="暂无历史记录" />
        <div v-else class="history-list">
          <!-- 使用 Steps 纵向模式模拟时间线 -->
          <a-steps direction="vertical" :current="historyList.length - 1" class="history-steps">
            <a-step v-for="(item, idx) in historyList" :key="item.id" :status="idx === 0 ? 'finish' : 'wait'">
              <template #title>
                <div class="history-card-header">
                  <span class="history-title">历史版本 #{{ historyList.length - idx }}</span>
                  <a-tag :color="statusConfig[item.status]?.color" class="ml10">
                    {{ statusConfig[item.status]?.text }}
                  </a-tag>
                </div>
              </template>
              <template #description>
                <div class="step-description">
                  <div class="history-time">{{ item.createTime }}</div>
                  <a-card :bordered="false" class="history-card" :body-style="{ padding: '12px' }">
                    <div class="history-params">
                      <div class="history-params-title">对比参数：</div>
                      <div class="history-params-grid">
                        <span class="param-tag">配准: {{ item.alignmentModel || '-' }}</span>
                        <span class="param-tag">光照: {{ item.illuminanceMode || '-' }}</span>
                        <span class="param-tag">ORB: {{ item.orbFeatures ?? '-' }}</span>
                        <span class="param-tag">匹配: {{ item.matchRatio ?? '-' }}</span>
                        <span class="param-tag">RANSAC: {{ item.ransacReprojThreshold ?? '-' }}</span>
                        <span class="param-tag">轮廓: {{ item.minContourAreaRatio ?? '-' }}</span>
                        <span class="param-tag">IoU: {{ item.mergeBoxIou ?? '-' }}</span>
                        <span class="param-tag">框数: {{ item.maxBoxes ?? '-' }}</span>
                        <span class="param-tag">内点: {{ item.minInliers ?? '-' }}</span>
                        <span class="param-tag">差值: {{ item.minAbsdiffAfterOtsu ?? '-' }}</span>
                      </div>
                    </div>
                    <div class="history-result">
                      <span class="result-text">检测到 {{ item.changeAreaCount || 0 }} 处变化</span>
                      <span class="result-text">用时 {{ ((item.detectDurationMs || 0) / 1000).toFixed(2) }} 秒</span>
                    </div>
                    <div class="history-images" v-if="item.matchedSourceImageUrl || item.matchedTargetImageUrl">
                      <div class="history-image-item" v-if="item.matchedSourceImageUrl">
                        <span class="image-label">目标图：</span>
                        <a-image
                          :src="item.matchedSourceImageUrl"
                          :preview="{ mask: '预览' }"
                          width="100%"
                          fit="contain"
                          :style="{ maxHeight: '150px', objectFit: 'contain' }"
                        />
                      </div>
                      <div class="history-image-item" v-if="item.matchedTargetImageUrl">
                        <span class="image-label">对比图：</span>
                        <a-image
                          :src="item.matchedTargetImageUrl"
                          :preview="{ mask: '预览' }"
                          width="100%"
                          fit="contain"
                          :style="{ maxHeight: '150px', objectFit: 'contain' }"
                        />
                      </div>
                    </div>
                    <div class="history-actions">
                      <a-button type="primary" size="small" @click="downloadUrl(item.matchedSourceImageUrl)">
                        <DownloadOutlined /> 下载目标图
                      </a-button>
                      <a-button type="primary" size="small" @click="downloadUrl(item.matchedTargetImageUrl)">
                        <DownloadOutlined /> 下载对比图
                      </a-button>
                      <a-button type="success" size="small" @click="resetMonitor(item)">
                        <SyncOutlined /> 使用此参数重试
                      </a-button>
                    </div>
                  </a-card>
                </div>
              </template>
            </a-step>
          </a-steps>
        </div>
      </a-spin>
    </a-modal>

    <a-modal class="pic-modal" v-model:visible="compositeShow" :footer="null" width="60%" @cancel="compositeShow = false" :zIndex="10">
        <template #title>
          <div>图片预览--{{ currentCompositeFile?.name || currentCompositeFile?.fileName }}</div>
        </template>
        <div class="preview-container">
          <!-- 主预览图 -->
          <div class="main-preview" @mousedown.prevent="startDrag" @mousemove.prevent="handleDrag"
            @mouseup.prevent="stopDrag" @mouseleave.prevent="stopDrag">
            <a-spin :spinning="compositeImageLoading" tip="图片加载中..." size="large">
              <img v-if="compositeUrl" :src="compositeUrl" class="preview-image" alt="预览图片" @wheel.prevent="handleZoom"
                @load="compositeImageLoading = false" @error="compositeImageLoading = false"
                :style="{
                  transform: `scale(${scale}) translate(${x}px, ${y}px)`,
                  cursor: isDragging ? 'grabbing' : 'auto'
                }" :class="{
                      'zoom-out-cursor': scale > 1,
                      'zoom-in-cursor': scale <= 1
                    }" />
            </a-spin>
          </div>

          <div class="thumbnail-nav">
            <div class="zoom-controls">
              <ZoomOutOutlined @click="scale = Math.max(0.5, scale - 0.1)" />
              <span>{{ Math.round(scale * 100) }}%</span>
              <ZoomInOutlined @click="scale = Math.min(3, scale + 0.1)" />
              <a-button @click="resetImage">重置</a-button>
            </div>
          </div>
        </div>
      </a-modal>

    <a-modal v-model:visible="synthesisShow" title="图片合成" centered :ok-button-props="okButtonProps" :zIndex="10"
      @cancel="handleSynthesisCancel" @ok="synthesisOk" :ok-text="'合成'"
      :cancel-text="'取消'" :width="520" :confirm-loading="synthesisLoading" >
      <div class="synthesis-modal-content">
        <div class="synthesis-form">
          <div class="form-item">
            <div class="form-label">
              <span class="required">*</span>合成文件名：
            </div>
            <div class="form-content">
              <a-input v-model:value="synthesisValue" placeholder="请输入合成图片文件名" :maxlength="50" allow-clear :disabled="synthesisLoading" />
              <div class="form-tips">支持中文、英文、数字和下划线，不超过50个字符</div>
            </div>
          </div>
          <div class="form-item">
            <div class="form-label">
              <span class="required">*</span>拼接方式：
            </div>
            <div class="form-content">
              <a-radio-group v-model:value="synthesisRadioValue" :disabled="synthesisLoading">
                <div class="radio-options">
                  <a-radio value="fusion" class="radio-item">
                    <div class="radio-content mt5">
                      <span class="radio-label">融合合成</span>
                      <span class="radio-desc">  (多源信息整合，生成新内容或模型)</span>
                    </div>
                  </a-radio>
                  <a-radio value="opencv" class="radio-item">
                    <div class="radio-content mt5">
                      <span class="radio-label">特征合成</span>
                      <span class="radio-desc">  (基于特征点匹配进行图像合成)</span>
                    </div>
                  </a-radio>
                  <a-radio value="orb" class="radio-item">
                    <div class="radio-content mt5">
                      <span class="radio-label">特质合成</span>
                      <span class="radio-desc">  (使用ORB特征检测算法)</span>
                    </div>
                  </a-radio>
                  <a-radio value="simple" class="radio-item">
                    <div class="radio-content mt5">
                      <span class="radio-label">拼凑合成</span>
                      <span class="radio-desc">  (简单拼接，不进行特征匹配)</span>
                    </div>
                  </a-radio>
                </div>
              </a-radio-group>
            </div>
          </div>
          <div class="form-item">
            <div class="form-label">已选图片：</div>
            <div class="form-content">
              <div class="selected-images">
                <div class="selected-count">
                  已选择 {{ currentSelectedCount }} 张图片
                  <span v-if="currentSelectedCount < 2" class="error-tip">（至少需要2张）</span>
                </div>
                <div class="image-preview-list" v-if="currentSelectedImages.length > 0">
                  <div class="image-preview-item" v-for="(item, index) in currentSelectedImages.slice(0, 5)" :key="index">
                    <!-- 根据数据来源显示不同的图片 -->
                     <img :src="item.abbreviation_url || item.url" class="preview-image" />
                     <div class="preview-name">{{ item.file_name || item.name }}</div>
                    </div>
                    <div class="more-images" v-if="currentSelectedImages.length > 5">
                      还有 {{ currentSelectedImages.length - 5 }} 张图片...
                    </div>
                  </div>
                  <div class="no-images" v-else>
                    请选择至少2张图片进行合成
                  </div>
                </div>
              </div>
            </div>
            <div class="synthesis-progress" v-if="synthesisLoading">
              <div class="progress-info">
                <a-progress :percent="synthesisProgress" :status="synthesisProgress === 100 ? 'success' : 'active'"
                  :stroke-color="{ '0%': '#108ee9', '100%': '#87d068' }" />
                <div class="progress-text" v-if="synthesisProgress < 100">
                  正在合成图片，请勿关闭窗口...
                </div>
                <div class="progress-text success" v-else>
                  合成完成！
                </div>
              </div>
            </div>
          </div>
        </div>
    </a-modal>
    <mediaContent ref="mediaContentRef" :workspaceId="workspaceId" :selectFolderId="childFolderId" :folderName="childFolderName" @toggleDisplay="handleSaveStatus" />

    <a-modal class="pic-modal" v-model:visible="analysisShow" :footer="null" width="60%" @cancel="analysisShow = false" :zIndex="10">
        <template #title>
          <div>分析图片预览--{{ currentAnalysisFile?.file_name }}</div>
        </template>
        <div class="preview-container">
          <!-- 主预览图 -->
          <div class="main-preview" @mousedown.prevent="startDrag" @mousemove.prevent="handleDrag"
            @mouseup.prevent="stopDrag" @mouseleave.prevent="stopDrag">
            <a-spin :spinning="analysisImageLoading" tip="图片加载中..." size="large">
              <img v-if="analysisUrls" :src="analysisUrls" class="preview-image" alt="预览图片" @wheel.prevent="handleZoom"
                @load="analysisImageLoading = false" @error="analysisImageLoading = false"
                :style="{
                  transform: `scale(${scale}) translate(${x}px, ${y}px)`,
                  cursor: isDragging ? 'grabbing' : 'auto'
                }" :class="{
                      'zoom-out-cursor': scale > 1,
                      'zoom-in-cursor': scale <= 1
                    }" />
            </a-spin>
          </div>

          <div class="analysis-results-float">
            <div class="analysis-results-header">
              <span>分析结果</span>
            </div>
            <div class="analysis-results-content">
              <div v-for="(item, index) in readyAnalysisResults" :key="index" class="analysis-result-item">
                <span class="result-name">{{ item.name || item.type }} ：</span>
                <span class="result-count">{{ item.count || '0' }}</span>
              </div>
            </div>
          </div>

          <div class="ana-info-overlay">
            <div>经度: {{ Number(currentAnalysisFile?.lon).toFixed(6) || '-' }}</div>
            <div>纬度: {{ Number(currentAnalysisFile?.lat).toFixed(6) || '-' }}</div>
            <div v-show="currentAnalysisFile?.absolute_altitude">海拔高度: {{ currentAnalysisFile?.absolute_altitude + ' m' || '-' }}</div>
            <div>时间: {{ currentAnalysisFile?.create_time || '-' }}</div>
            <div>负载: {{ currentAnalysisFile?.payload || '-' }}</div>
          </div>

          <div class="ana-thumbnail-nav">
            <div class="zoom-controls">
              <ZoomOutOutlined @click="scale = Math.max(0.5, scale - 0.1)" />
              <span>{{ Math.round(scale * 100) }}%</span>
              <ZoomInOutlined @click="scale = Math.min(3, scale + 0.1)" />
              <a-button @click="resetImage">重置</a-button>
            </div>
          </div>
        </div>
    </a-modal>

      <!--规章条约-->
    <a-modal v-model:visible="regulationVisible" centered :title="regulationVisibleName" @ok="addRegulaionOk" @cancel="addRegulaionCancel" :zIndex="10">
        <div class="regulation-modal-content">
          <div class="regulation-field">
            <div class="regulation-label">
              <span class="required">*</span>选择条约：
            </div>
            <div class="regulation-content">
              <div class="rule-select-wrapper">
                <a-input v-model:value="ruleChoseDisplay" placeholder="请选择条约(可多选)" readonly class="rule-input" @click="selectRules" />
                <a-button type="primary" size="small" @click="selectRules" class="select-btn">选择</a-button>
              </div>
              <div class="form-tips">点击选择按钮，从列表中选择相关条约</div>
            </div>
          </div>
          <div class="regulation-field">
            <div class="regulation-label">
              <span class="required">*</span>存在隐患：
            </div>
            <div class="regulation-content">
              <a-textarea v-model:value="hiddenDanger" placeholder="请填写存在隐患" :rows="4" :maxlength="500" show-count />
            </div>
          </div>
        </div>
        <template #footer>
          <a-button @click="addRegulaionCancel">取消</a-button>
          <a-button type="primary" :disabled="!ruleChoseDisplay || !hiddenDanger" @click="addRegulaionOk">确定</a-button>
        </template>
    </a-modal>

    <a-modal v-model:visible="regulationTableVisible" centered title="选择条约（可多选）" @ok="addRegulaionTableOk" @cancel="addRegulaionTableCancel" width="80%" :zIndex="10">
        <a-table :columns="ruleColumns" :data-source="ruleData" @change="refreshRuleData" :pagination="rulePagination" :row-selection="rowRuleSelection" row-key="id" :scroll="{ y: 400 }"></a-table>
    </a-modal>

    <a-modal v-model:visible="filesResultsVisible" title="分析结果" width="40%" centered :destroyOnClose="true" :maskClosable="false" :footer="null" @cancel="resetFilesResults" :zIndex="10">
      <div class="results-body">
        <a-form ref="resultsFormRef" :model="editingResultsForm" layout="horizontal">
          <a-form-item label="AI算法分析结果" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
            <div style="display: flex; align-items: center; gap: 8px;">
              <a-textarea v-model:value="editingResultsForm.analysisResult" placeholder="请输入AI算法分析结果" :rows="3" />
              <a-button :loading="algorithmAnalysisLoading" @click="openAiAnalysisForField('analysisResult')" v-if="!currentEditingFileRecord?.analysis_result" type="link" style="padding: 0;">
                <a-tooltip title="算法识别">
                  <SvgIcon name="AIshibie" class="analysis-position"/>
                </a-tooltip>
              </a-button>
            </div>
          </a-form-item>

          <a-form-item label="AI大模型识别结果" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }"><!-- v-if="mediaActiveKey === 'third_media' || currentOptionData"-->
            <div style="display: flex; align-items: center; gap: 8px;">
              <a-textarea v-model:value="editingResultsForm.largeModelAnalysisResult" placeholder="请输入大模型识别结果" :rows="3" style="flex: 1;" />
              <a-tooltip title="隐患识别">
                <SvgIcon name="AIshibie" class="analysis-position" @click="openAiAnalysisForField('largeModelAnalysisResult')"/>
              </a-tooltip>
            </div>
          </a-form-item>

          <a-form-item label="AI大模型识别条例" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }"><!-- v-if="mediaActiveKey === 'third_media' || currentOptionData"-->
            <div style="display: flex; align-items: center; gap: 8px;">
              <a-textarea v-model:value="editingResultsForm.regulationDetails" placeholder="请输入模型识别条例" :rows="3" style="flex: 1;" />
              <a-tooltip title="条例识别">
                <SvgIcon name="AIshibie" class="analysis-position" @click="openAiAnalysisForField('regulationDetails')"/>
              </a-tooltip>
            </div>
          </a-form-item>
        </a-form>

        <div class="results-actions">
          <a-button type="primary" :loading="saveResultsLoading" @click="handleSaveResults">保存</a-button>
          <a-button @click="resetFilesResults">取消</a-button>
        </div>
      </div>
    </a-modal>

    <a-modal v-model:visible="aiResultVisible" :title="aiTitle" width="1200px" :mask-closable="false" centered @cancel="handleCloseAiResult" :z-index="20">
      <div class="special-app-content">
        <a-spin :spinning="aiResultLoading" tip="加载中...">
          <template v-for="categoryItem in categoryList" :key="categoryItem.code || categoryItem.id">
            <div v-if="getAppsByCategory(categoryItem.code).length > 0" class="category-section">
              <div class="category-title">
                <div class="title-bar"></div>
                <span class="title-text">
                  {{ categoryItem.fullPathName || categoryItem.name }}
                </span>
              </div>
              <div class="app-grid">
                <div v-for="app in getAppsByCategory(categoryItem.code)" :key="app.id" class="app-card" :class="{ selected: isSelected(app.id) }"
                  :style="{ background: getCardBackground(app.colorTheme) }" @click="handleCardClick(app)" >
                  <div class="app-icon">
                    <a-image v-if="app.iconPath" :src="getIconUrl(app.iconPath)" :preview="false"
                      fallback="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ccc'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 13c-2.33 0-4.31-1.46-5.11-3.5h10.22c-.8 2.04-2.78 3.5-5.11 3.5z'/%3E%3C/svg%3E"
                    />
                    <SettingOutlined v-else class="app-icon-placeholder" />
                  </div>
                  <div class="app-name">{{ app.appName }}</div>
                </div>
              </div>
            </div>
          </template>
          <a-empty v-if="!aiResultLoading && appList.length === 0" description="暂无专题应用数据" />
        </a-spin>
      </div>
      <template #footer>
        <a-button @click="handleCloseAiResult">关闭</a-button>
        <a-button type="primary" :loading="submitAiLoading" @click="toggleSelection" :disabled="!aiResultForm.typeId">识别</a-button>
      </template>
    </a-modal>

    <a-modal v-model:visible="addThirdMediaVisible" title="新增素材文件夹" :footer="null" centered :zIndex="10">
  <a-form :footer="null" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }" :model="formAddTreeData" :rules="formAddRules" name="basic" ref="formAddRef" autocomplete="off">

    <!-- 文件夹来源选择 -->
    <a-form-item label="文件夹来源" name="folderType">
      <a-radio-group v-model:value="folderType">
        <a-radio value="custom">自定义名称</a-radio>
        <a-radio value="existing">选择已有文件夹</a-radio>
      </a-radio-group>
    </a-form-item>

    <!-- 自定义名称模式 -->
    <a-form-item v-if="folderType === 'custom'" label="文件夹名称" name="folderName" required>
      <a-input v-model:value="formAddTreeData.folderName" placeholder="请输入文件夹名称"></a-input>
    </a-form-item>

    <!-- 选择已有文件夹模式 -->
    <a-form-item v-else label="选择文件夹" name="existingFolderId" required>
      <a-select
      v-model:value="selectedFolderId"
      :loading="existingFolderLoading"
      placeholder="请选择已有文件夹"
      show-search
      option-filter-prop="label"
      @dropdownVisibleChange="handleDropdownVisibleChange"
    >
      <a-select-option v-for="item in existingFolderList" :key="item.folderId" :value="item.folderId" :label="item.folderName">
        {{ item.folderName }}
      </a-select-option>
      <template #dropdownRender="{ menuNode }">
        <div>
          <component :is="menuNode" />
          <div v-if="hasMoreFolders" style="padding: 8px; text-align: center; border-top: 1px solid #f0f0f0;">
            <a-button type="link" size="small" :loading="existingFolderLoading" @click.stop="loadMoreFolders">加载更多</a-button>
          </div>
        </div>
      </template>
    </a-select>
    </a-form-item>

    <a-form-item label="备注" name="remark">
      <a-input v-model:value="formAddTreeData.remark" placeholder="请输入备注"></a-input>
    </a-form-item>

    <a-form-item label="文件" name="file">
      <a-upload ref="uploadRef" :maxCount="1" action="#" accept=".zip" name="file" :multiple="false" :show-file-list="false" @change="handleThirdMediaChange" :beforeUpload="handleThirdMediaUpload">
        <a-button>
          <upload-outlined></upload-outlined>
          选择图片压缩包
        </a-button>
      </a-upload>
    </a-form-item>

    <div v-if="addLoading">
      <a-progress :percent="addThirdPercent"/>
    </div>

    <a-form-item>
      <div style="display: flex; gap: 10px; justify-content: flex-end;">
        <a-button type="primary" :loading="addLoading" html-type="submit" @click="handleThirdMediaSubmit">确定</a-button>
        <a-button type="default" @click="handleThirdMediaCancel">取消</a-button>
      </div>
    </a-form-item>
  </a-form>
</a-modal>

    <a-modal v-model:visible="algoMediaAnalysisVisible" title="媒体分析" centered :zIndex="20" :footer="null" @cancel="handleCloseAlgoMediaAnalysis">
      <div class="algo-analysis-form">
        <div class="form-item">
          <div class="form-label">算法</div>
          <div class="form-control">
            <a-select v-model:value="formAlgoAnalysisData.algorithmId" placeholder="请选择算法" :dropdownMatchSelectWidth="false" >
              <a-select-option v-for="item in algorithmDataList" :key="item.id" :value="item.id" >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">置信度</div>
          <div class="form-control">
            <a-input-number v-model:value="formAlgoAnalysisData.confidence" :min="0.1" :max="1.0" :step="0.1" style="width: 100%" />
          </div>
        </div>
        <div class="form-item" v-if="mediaActiveKey !== 'third_media'">
          <div class="form-label">
            <a-tooltip title="同时进行大模型分析">
              <QuestionCircleOutlined class="c189 ml5" />
            </a-tooltip>
            <span>大模型</span>
          </div>
          <div class="form-control">
            <a-radio-group v-model:value="formAlgoAnalysisData.enableLargeModel">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </div>
        </div>
        <div class="form-actions">
          <a-button @click="handleCloseAlgoMediaAnalysis">关闭</a-button>
          <a-button type="primary" :loading="submitAlgoAnalysisLoading" @click="toggleAlgoAnalysis" >
            分析
          </a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, reactive, computed, onUnmounted } from 'vue'
import { TableState } from 'ant-design-vue/lib/table/interface'
import { IPage } from '../api/http/type'
import { ELocalStorageKey } from '../types/enums'
import { downloadFile } from '../utils/common'
import {
  getMediaFilesPage, downloadZip, getFolderPage, getSubsetPage, subsetParam, folderParam, getNewFolderDownload,
  downloadMediaFile, downloadWatermarkMediaFile, updateMediaStatus, getImageSynthesis, synthesisPageRequest, getImageSynthesisPage,
  getCreateNewFolder, getRemoveFolder
} from '../api/media'
import {
  DownloadOutlined, FolderOpenOutlined, PictureOutlined, PlaySquareOutlined, ZoomOutOutlined,
  ReloadOutlined, ZoomInOutlined, EyeTwoTone
} from '@ant-design/icons-vue'
import { message, Modal, Pagination, UploadProps } from 'ant-design-vue'
import { getDictDataList } from '../api/dict'
import dayjs, { Dayjs } from 'dayjs'
import { formatDeviceSn, getBindingDevices, getDevice, getDeviceTopo } from '../api/manage'
import { fightPath, fightPathPageRequest, getFightPathPage } from '../api/flightTrajectory'
import PanoramaViewer from '../pages/page-web/projects/panorama/mediaPanorama.vue'
import mediaContent from '/@/components/media/media-content.vue'
import { getDictList, getMediaFileAnalysis, getMediaFileAnalysisStatistics } from '../api/algCode'
import { getGenerateorthophoto } from '../api/insp-device'
import { getAllSpecialData, getFileRegulations, getRegulationsFileRule, getRegulationsPage, listAllSpecialAppCategory } from '../api/insp/insp-regulations'
import { checkSameMontiorTask, getAiOutFileAnalysisResult, getAlgoAnalysisResult, getCreateMontior, getFileUrlByObjectKeyLong, getFileUrlByObjectKeyLongZst, getModelOutFileAnalysisResult, getMontiorPage, getOutFilePage, getOutFolderLmFilePage, getOutFolderLmPage, getOutFolderPage, getWhetherUpdatedReport, historyMontiorTask, montiorTaskData, resetParameterMontiorTask, updateFileAnalysisResult, updateImageZip, updateOutFileAnalysisResult, uploadUavFile } from '../api/insp/insp-media'
import auth from '../plugins/auth'
import { getAcquisitionRegulations, getAlarmModelAnalysis } from '../api/insp/insp-alarm'
import { getAllAlgList } from '../api/insp-algorithm'

const mediaActiveKey = ref('folder-tab')
// 排序状态
const sortFolderField = ref<string>('') // 可用值:CREATE_TIME,FLIGHT_TYPE
const sortFolderOrder = ref<string>('') // 可用值:ASC,DESC

const sortFilesField = ref<string>('') // 可用值:CREATE_TIME,STATUS
const sortFilesOrder = ref<string>('') // 可用值:ASC,DESC

const sortImageField = ref<string>('') // 可用值:CREATE_TIME,STATUS
const sortImageOrder = ref<string>('') // 可用值:ASC,DESC

const sortVideoField = ref<string>('') // 可用值:CREATE_TIME,STATUS
const sortVideoOrder = ref<string>('') // 可用值:ASC,DESC

const sortAnalysisField = ref<string>('') // 可用值:CREATE_TIME,STATUS
const sortAnalysisOrder = ref<string>('') // 可用值:ASC,DESC

const folderImageLoading = ref(false)
const mediaImageLoading = ref(false)
const compositeImageLoading = ref(false)
const analysisLoading = ref(false)
const analysisError = ref(false)

const normalizeDateRange = (dates: [Dayjs | null, Dayjs | null]): [Dayjs | null, Dayjs | null] => {
  if (!dates || !dates[0] || !dates[1]) return dates
  const start = dates[0]
  const end = dates[1]
  if (start.isSame(end, 'day')) {
    // 同一天：开始时间改为 00:00:00，结束时间改为 23:59:59
    return [start.startOf('day'), end.endOf('day')]
  }
  return dates
}

const loadingTip = computed(() => {
  if (mediaImageLoading.value) {
    return '图片加载中...'
  } else if (analysisLoading.value) {
    return '图片分析中...'
  }
  return '加载中...'
})

const mediaContentRef = ref()
interface DeviceChild {
  device_sn: string;
  nickname: string;
}

interface DeviceChildren {
  [key: string]: DeviceChild; // 定义children对象的索引签名
}

interface DeviceItem {
  device_sn: string;
  nickname: string;
  children?: DeviceChildren; // 使用具体的类型
}

interface TreeNode {
  key: string;
  title: string;
  children?: TreeNode[];
  selectable?: boolean;
  isParent?: boolean;
}

const folderPanoramaLoading = ref(false)
const mediaPanoramaLoading = ref(false)

const treeData = ref<TreeNode[]>([])
const expandedKeys = ref<string[]>([])

const handleSaveStatus = (current, status, key, cb) => {
  const obj = {
    id: current.id,
    type: cb || current.type === 'file' ? 'file' : 'folder',
  }
  obj[key] = status ? 1 : 0
  updateMediaStatus(obj).then(res => {
    if (res && res.code === 0) {
      message.success('更新成功')
      if (cb) {
        cb()
      } else {
        current[key] = status ? 1 : 0
      }
    }
  })
}

const handleImgMapLoadStatus = async (current, status, key, cb) => {
  const obj = {
    id: current.id,
    type: 'file',
    parent_id: current.folder_id
  }
  obj[key] = status ? 1 : 0
  updateMediaStatus(obj).then(res => {
    if (res && res.code === 0) {
      message.success('更新成功')
      if (cb) {
        cb()
      } else {
        current[key] = status ? 1 : 0
      }
    }
  })
}

const handleTreeExpand = (expandedKeysList: string[], info: any) => {
  expandedKeys.value = expandedKeysList
}

const fetchTreeNodeData = async () => {
  const res = await getDeviceTopo(workspaceId)
  const keys: string[] = []
  treeData.value = res.data.map((item: DeviceItem) => {
    keys.push(item.device_sn)
    const node: TreeNode = {
      key: item.device_sn,
      title: item.nickname,
      isParent: true,
      selectable: false,
    }

    if (item.children) {
      node.children = [item.children].map((child: DeviceChild) => ({
        key: child.device_sn,
        title: child.nickname,
        selectable: true,
      }))
    }
    return node
  })
  expandedKeys.value = keys
}

interface flyPagination {
  page: number; // 当前页（从1开始）
  page_size: number; // 每页条数
  total: number; // 总条数（接口返回）
}

// 分页状态
const pagination = ref<flyPagination>({
  page: 1,
  page_size: 10,
  total: 0 // 初始总条数为0，后续从接口获取
})

const flyRecordData = ref<fightPath[]>([])
const flyAllRecordData = ref<fightPath[]>([])
const childFolderId = ref('')
const childFolderName = ref('')
const selectFolderId = ref('')
const currentFlyRecord = ref<fightPath>()
const hasInvalidFlyRecord = ref(false)

const resetFlyData = () => {
  imgFlyDate.value = []
  fetchFlyRecordData()
}

// 飞行轨迹
const fetchFlyRecordData = async () => {
  let mediaType = ''
  if (menuSelectedKey.value === 'media') {
    mediaType = 'jpg,png,jpeg'
  } else if (menuSelectedKey.value === 'history_play') {
    mediaType = 'mp4'
  }
  const [startTime, endTime] = normalizeDateRange(imgFlyDate.value)
  const queryParam: fightPathPageRequest = {
    page: pagination.value.page,
    page_size: pagination.value.page_size,
    param: {
      device_sn: selectDeviceSn.value,
      start_time: startTime ? startTime.format('YYYY-MM-DD HH:mm:ss') : '',
      end_time: endTime ? endTime.format('YYYY-MM-DD HH:mm:ss') : '',
      media_type: mediaType
    }
  }
  getFightPathPage(queryParam).then(res => {
    if (res && res.code === 0) {
      flyRecordData.value = res.data.list
      pagination.value.total = res.data.pagination.total || 0
      pagination.value.page = res.data.pagination.page || 1
    }
  })
}

const handleFlyRecordClick = (flyData: fightPath) => {
  const isSameRecord = currentFlyRecord.value ? currentFlyRecord.value.id === flyData.id : false

  if (isSameRecord) {
    // 点击已选中项：取消选择，重置状态
    selectFolderId.value = ''
    currentFlyRecord.value = undefined // 清空当前选中
    hasInvalidFlyRecord.value = false
  } else {
    // 点击新项：设置选中状态
    const folderId = flyData.folder_id || ''
    selectFolderId.value = folderId
    currentFlyRecord.value = flyData
    hasInvalidFlyRecord.value = !folderId
  }

  triggerTableQuery()
}

const triggerTableQuery = () => {
  paginationProp.current = 1
  if (menuSelectedKey.value === 'media') {
    getFiles()
  } else if (menuSelectedKey.value === 'history_play') {
    getHistoryPlayFiles()
  } else {
    fetchCompositeData()
  }
}

const handlePageChange = (page: number, pageSize: number) => {
  pagination.value.page = page
  pagination.value.page_size = pageSize
  fetchFlyRecordData()
}

const nodeClickCount = ref<Record<string, number>>({})

const currentSelectedKey = ref<string | null>(null)

const selectDeviceSn = ref('')

const handleTreeSelect = (selectedKeys: string[], info: any) => {
  const selectedKey = selectedKeys[0]

  if (!selectedKey) {
    selectDeviceSn.value = ''
    currentSelectedKey.value = null
    resetTable()
    return
  } else {
    const findNode = (nodes: TreeNode[]): TreeNode | null => {
      for (const node of nodes) {
        if (node.key === selectedKey) return node
        if (node.children && node.children.length > 0) {
          const childNode = findNode(node.children)
          if (childNode) return childNode
        }
      }
      return null
    }
    const selectedNode = findNode(treeData.value)
    if (selectedNode) {
      currentSelectedKey.value = selectedKey
      selectDeviceSn.value = selectedNode.key
    } else {
      selectDeviceSn.value = ''
      currentSelectedKey.value = null
    }
  }
  fetchFlyRecordData()
  triggerTableQuery()
}

const resetTable = () => {
  pagination.value.page = 1
  fetchFlyRecordData()
  if (menuSelectedKey.value === 'media') {
    paginationProp.current = 1
    getFiles()
  } else if (menuSelectedKey.value === 'history_play') {
    paginationHistoryPlayProp.current = 1
    getHistoryPlayFiles()
  } else {
    compositePaginationProp.current = 1
    fetchCompositeData()
  }
}

const panaraShow = ref(false)

const currentMediaFileInfo = ref<any>(null)

const currentHistoryVideoInfo = ref<any>(null)

const imageShow = ref(false)
const currentIndex = ref(0)
const scale = ref(1)

const x = ref(0)
const y = ref(0)
const startX = ref(0)
const startY = ref(0)
const isDragging = ref(false)

const imageList = computed(() => {
  // 定义常见的图片格式
  const imageFormats = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']

  return mediaData.data.filter(item => {
    if (!item.url) return false

    // 获取文件扩展名
    const ext = item.url.toLowerCase().split('.').pop()
    // 只保留图片格式
    return imageFormats.includes(ext)
  })
})

const resetImage = () => {
  scale.value = 1
  x.value = 0
  y.value = 0
}

// 处理缩放
const handleZoom = (e) => {
  if (e.deltaY < 0) {
    scale.value = Math.min(3, scale.value + 0.1)
  } else {
    scale.value = Math.max(0.5, scale.value - 0.1)

    // 缩小到原始大小时重置位置
    if (scale.value <= 1) {
      x.value = 0
      y.value = 0
    }
  }
}

// 开始拖拽
const startDrag = (e) => {
  if (scale.value > 1) {
    isDragging.value = true
    startX.value = e.clientX - x.value
    startY.value = e.clientY - y.value
  }
}

// 处理拖拽
const handleDrag = (e) => {
  if (isDragging.value && scale.value > 1) {
    x.value = e.clientX - startX.value
    y.value = e.clientY - startY.value
  }
}

// 停止拖拽
const stopDrag = () => {
  isDragging.value = false
}

// 关闭预览
const handleCancel = () => {
  imageShow.value = false
  panaraShow.value = false
  compositeShow.value = false
  imageUrl.value = ''
  analysisChecked.value = false
  analysisMessage.value = false
  analysisUrl.value = ''
  analysisResults.value = []
  resetImage()
  folderPanoramaLoading.value = false
  mediaPanoramaLoading.value = false
  folderImageLoading.value = false
  mediaImageLoading.value = false
  compositeImageLoading.value = false
  analysisImageLoading.value = false
  analysisShow.value = false
  currentPreviewMediaSource.value = 'system'
}

const menuSelectedKey = ref('folder')

const handleSelect = (e: { key: string }) => {
  const newKey = e.key

  if (menuSelectedKey.value !== newKey) {
    // 重置媒体库相关状态
    if (menuSelectedKey.value === 'folder') {
      breadcrumbs.value = []
      breadcrumbsIdentify.value = []
      currentFolderId.value = null
      isSubFolder.value = false
      selectedFolderRowKeys.value = []
      selectedFolderRows.value = []
      folderPagination.current = 1
      columnses.value[0].dataIndex = 'folder_name'
      columnses.value[0].key = 'folderName'
      folderName.value = ''
      fetchFolders()
    }

    // 切换菜单时强制关闭并重置分析结果弹窗
    if (filesResultsVisible.value) {
      resetFilesResults()
      filesResultsVisible.value = false
    }
    if (aiResultVisible.value) {
      handleCloseAiResult()
    }

    menuSelectedKey.value = newKey

    currentSelectedKey.value = null
    selectDeviceSn.value = ''
    nodeClickCount.value = {}

    selectedRowKeys.value = []
    selectedRows.value = []

    resetSynthesisModal()

    if (newKey === 'media' || newKey === 'history_play') {
      pagination.value.page = 1
      fetchFlyRecordData()
    } else if (newKey === 'composite_file') {
      compositePaginationProp.current = 1
      fetchCompositeData()
    }

    reset(1)
    reset(2)

    // 新增：确保隐患识别和第三方媒体菜单进入时显示根目录
    if (newKey === 'identify_file') {
      breadcrumbsIdentify.value = []
      currentIdentifyFolderId.value = null
      isIdentifyFolder.value = false
      identifyFileName.value = ''
      identifyFilePagination.current = 1
      identifyFolderPagination.current = 1
      identifyColumnses.value[0].dataIndex = 'folderName'
      identifyColumnses.value[0].key = 'folderName'
      fetchIdentifyFolders()
    } else if (newKey === 'third_media') {
      breadcrumbsThirdMedia.value = []
      currentThirdMediaFolderId.value = null
      isThirdMediaFolder.value = false
      thirdMediaFileName.value = ''
      thirdMediaFilePagination.current = 1
      thirdMediaFolderPagination.current = 1
      thirdMediaColumnses.value[0].dataIndex = 'folderName'
      thirdMediaColumnses.value[0].key = 'folderName'
      fetchThirdMediaFolders()
    }
  }
}

const folderPagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0
})

const filePagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0
})

const mediaPanoramaUrl = ref('')

/* const handleMediaImagePreview = (url: string, index: number, record: any) => {
  currentMediaFileInfo.value = record
  resetImage()
  mediaImageLoading.value = true

  if (record.panorama) {
    mediaPanoramaLoading.value = true
    panaraShow.value = true
    mediaPanoramaUrl.value = url
  } else {
    imageUrl.value = url
    currentIndex.value = index
    imageShow.value = true

    if (record.analysis_result) {
      analysisChecked.value = true
      loadAnalysisImage().finally(() => {
      })
    }
  }
} */

// 统一的图片预览入口
const openImagePreview = (record: any, source: 'system' | 'thirdParty') => {
  // 重置缩放状态
  resetImage()
  mediaImageLoading.value = true
  currentMediaFileInfo.value = record
  currentPreviewMediaSource.value = source

  // 判断是否为全景图（第三方媒体暂不考虑全景图）
  const isPanorama = source === 'system' && record.panorama === true
  if (isPanorama) {
    mediaPanoramaLoading.value = true
    panaraShow.value = true
    mediaPanoramaUrl.value = record.url
    return
  }

  // 普通图片预览
  imageUrl.value = record.url
  imageShow.value = true

  // 检查是否已有分析结果
  let hasAnalysis = false
  if (source === 'system') {
    hasAnalysis = !!(record.analysis_result && record.analysis_result !== '' && record.analysis_result !== '{}')
  } else {
    hasAnalysis = !!(record.analysisUrl && record.analysisResult)
  }

  if (hasAnalysis) {
    analysisChecked.value = true
    if (source === 'thirdParty' && record.analysisUrl) {
      analysisUrl.value = record.analysisUrl
      analysisResults.value = formatAnalysisResults(record.analysisResult)
      analysisLoading.value = false
    } else if (source === 'system' && record.analysis_url) {
      analysisUrl.value = record.analysis_url
      analysisResults.value = formatAnalysisResults(record.analysis_result)
    } else {
      // 没有预置 analysisUrl 但存在分析结果，尝试调用接口获取分析图
      loadAnalysisImage()
    }
  } else {
    // 无分析结果，确保分析浮窗不显示
    analysisChecked.value = false
    analysisResults.value = []
    analysisUrl.value = ''
  }
}

// 修改普通媒体预览
const handleMediaImagePreview = (url: string, index: number, record: any) => {
  openImagePreview(record, 'system')
}

// 修改第三方媒体预览（原 openThirdMediaFile）
const openThirdMediaFile = (record: any) => {
  if (!auth.hasPermi(['media:preview'])) return
  openImagePreview(record, 'thirdParty')
}

/* const handleAnalysisChange = async (checked) => {
  analysisChecked.value = checked
  if (checked) {
    await loadAnalysisImage()
  }
} */

const handleAnalysisChange = async (checked: boolean) => {
  if (!checked) {
    // 关闭开关：隐藏分析图，清空结果
    analysisChecked.value = false
    analysisUrl.value = ''
    analysisResults.value = []
    analysisMessage.value = false
    return
  }

  // 开启开关
  if (!currentMediaFileInfo.value) {
    analysisChecked.value = false
    return
  }

  const isThirdParty = currentPreviewMediaSource.value === 'thirdParty'

  // 检查是否已有分析结果
  let hasAnalysisResult = false
  if (isThirdParty) {
    hasAnalysisResult = !!(
      currentMediaFileInfo.value.analysisUrl &&
      currentMediaFileInfo.value.analysisResult &&
      currentMediaFileInfo.value.analysisResult !== '' &&
      currentMediaFileInfo.value.analysisResult !== '{}'
    )
  } else {
    const result = currentMediaFileInfo.value.analysis_result
    if (result) {
      if (typeof result === 'string') {
        hasAnalysisResult = result !== '' && result !== '{}'
      } else if (Array.isArray(result)) {
        hasAnalysisResult = result.length > 0
      } else if (typeof result === 'object') {
        hasAnalysisResult = Object.keys(result).length > 0
      }
    }
  }

  if (hasAnalysisResult) {
    // 已有分析结果，直接加载显示
    analysisChecked.value = true
    if (isThirdParty && currentMediaFileInfo.value.analysisUrl) {
      analysisUrl.value = currentMediaFileInfo.value.analysisUrl
      analysisResults.value = formatAnalysisResults(currentMediaFileInfo.value.analysisResult)
      analysisMessage.value = false
    } else if (!isThirdParty && currentMediaFileInfo.value.analysis_url) {
      analysisUrl.value = currentMediaFileInfo.value.analysis_url
      analysisResults.value = formatAnalysisResults(currentMediaFileInfo.value.analysis_result)
      analysisMessage.value = false
    } else {
      // 有分析结果但没有 analysisUrl，调用接口获取
      await loadAnalysisImage()
    }
  } else {
    // 无分析结果，弹出算法选择框
    isFromPreview.value = true
    const fileId = isThirdParty
      ? currentMediaFileInfo.value.fileId
      : currentMediaFileInfo.value.file_id
    submitAlgoAnalysisFileId.value = fileId
    // 重置表单默认值
    formAlgoAnalysisData.value = {
      algorithmId: null,
      confidence: 0.5,
      enableLargeModel: 0
    }
    algoMediaAnalysisVisible.value = true
    // 保持 analysisChecked 为 false，等待分析成功后再设置
    analysisChecked.value = false
  }
}

/* const loadAnalysisImage = async () => {
  if (!currentMediaFileInfo.value) return
  analysisLoading.value = true
  analysisError.value = false
  analysisMessage.value = false
  try {
    const res = await getMediaFileAnalysis(currentMediaFileInfo.value.file_id)
    if (!res.data?.analysisUrl) {
      analysisError.value = true
      analysisMessage.value = true
      analysisChecked.value = false
    } else {
      analysisUrl.value = res.data.analysisUrl
      if (res.data.analysisResult) {
        try {
          if (typeof res.data.analysisResult === 'string') {
            analysisResults.value = JSON.parse(res.data.analysisResult)
          } else {
            analysisResults.value = res.data.analysisResult
          }
        } catch (error) {
          console.error('分析结果解析失败:', error)
          analysisResults.value = []
        }
      } else {
        analysisResults.value = []
      }
    }
  } catch (error) {
    console.error('获取分析图失败:', error)
    analysisError.value = true
    analysisChecked.value = false
  } finally {
    analysisLoading.value = false
  }
} */

const loadAnalysisImage = async () => {
  if (!currentMediaFileInfo.value) return
  analysisLoading.value = true
  analysisError.value = false
  analysisMessage.value = false

  try {
    const isThirdParty = currentPreviewMediaSource.value === 'thirdParty'
    const fileId = isThirdParty
      ? currentMediaFileInfo.value.fileId // 第三方媒体字段
      : currentMediaFileInfo.value.file_id // 普通媒体字段

    if (isThirdParty) {
      // 第三方媒体：优先使用记录中已有的 analysisUrl
      if (currentMediaFileInfo.value.analysisUrl) {
        analysisUrl.value = currentMediaFileInfo.value.analysisUrl
        analysisResults.value = formatAnalysisResults(currentMediaFileInfo.value.analysisResult)
        analysisLoading.value = false
        return
      } else {
        // 无分析结果，显示提示
        analysisMessage.value = true
        analysisChecked.value = false
        analysisLoading.value = false
        return
      }
    } else {
      // 普通媒体：调用后端接口
      const res = await getMediaFileAnalysis(fileId)
      if (!res.data?.analysisUrl) {
        analysisError.value = true
        analysisMessage.value = true
        analysisChecked.value = false
      } else {
        analysisUrl.value = res.data.analysisUrl
        analysisResults.value = formatAnalysisResults(res.data.analysisResult)
      }
    }
  } catch (error) {
    console.error('获取分析图失败:', error)
    analysisError.value = true
    analysisChecked.value = false
  } finally {
    analysisLoading.value = false
  }
}

// 将各种格式的分析结果统一转为 [{ name, count }] 数组
const formatAnalysisResults = (rawResult: any): Array<{ name: string; count: number }> => {
  if (!rawResult) return []

  // 如果是数组，直接返回（假设已经是正确格式）
  if (Array.isArray(rawResult)) {
    return rawResult.map(item => ({
      name: item.name || item.type || '未知',
      count: item.count || 0
    }))
  }

  // 如果是对象，转为数组
  if (typeof rawResult === 'object') {
    return Object.entries(rawResult).map(([key, value]) => ({
      name: key,
      count: Number(value) || 0
    }))
  }

  // 如果是字符串
  if (typeof rawResult === 'string') {
    // 尝试作为 JSON 解析
    try {
      const parsed = JSON.parse(rawResult)
      return formatAnalysisResults(parsed)
    } catch {
      // 不是 JSON，尝试解析 "关键词: 数量" 格式
      const lines = rawResult.split('\n')
      const results: { name: string; count: number }[] = []
      for (const line of lines) {
        const match = line.match(/^(.+?)\s*:\s*(\d+)$/)
        if (match) {
          results.push({ name: match[1].trim(), count: parseInt(match[2], 10) })
        } else if (line.trim()) {
          // 无法解析的行，作为单条记录，count 为 1
          results.push({ name: line.trim(), count: 1 })
        }
      }
      return results.length ? results : [{ name: rawResult, count: 1 }]
    }
  }

  return []
}

const handleOriginalImageLoad = () => {
  mediaImageLoading.value = false
}

const handleOriginalImageError = () => {
  mediaImageLoading.value = false
  message.error('原图加载失败')
}

const handleAnalysisImageLoad = () => {
  analysisLoading.value = false
  mediaImageLoading.value = false
}

const handleAnalysisImageError = () => {
  analysisLoading.value = false
  mediaImageLoading.value = false
  analysisError.value = true
  message.error('分析图加载失败')
  // 加载失败时切换回原图
  analysisChecked.value = false
}

const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId)!
const loading = ref(false)

const imageUrl = ref('')
const analysisUrl = ref('')
const analysisChecked = ref(false)
const analysisMessage = ref(false)
const analysisResults = ref([])
const videoShow = ref(false)
const jobName = ref('')
const videoUrl = ref('')
const exportShow = ref(false)
const exportTabKey = ref('today')
const droneDataList = ref<any[]>([])
const droneValue = ref('')
const customStart = ref<any>()
const customEnd = ref<any>()
const body: IPage = {
  page: 1,
  total: 0,
  page_size: 20,
}
const exportMadel = () => {
  exportShow.value = true
  exportTabKey.value = 'today'
  getBindingDevices(workspaceId, body, 0).then(res => {
    if (res && res.code === 0) {
      droneDataList.value = res.data.list
    }
  })
}

const doExport = async () => {
  let start_time = ''
  let end_time = ''
  const now = dayjs()
  if (exportTabKey.value === 'today') {
    start_time = now.startOf('day').format('YYYY-MM-DD HH:mm:ss')
    end_time = now.format('YYYY-MM-DD HH:mm:ss') // 使用当前时间，不是结束时间
  } else if (exportTabKey.value === 'yesterday') {
    const y = now.subtract(1, 'day')
    start_time = y.startOf('day').format('YYYY-MM-DD HH:mm:ss')
    end_time = y.endOf('day').format('YYYY-MM-DD HH:mm:ss')
  } else {
    start_time = customStart.value ? dayjs(customStart.value).format('YYYY-MM-DD HH:mm:ss') : ''
    end_time = customEnd.value ? dayjs(customEnd.value).format('YYYY-MM-DD HH:mm:ss') : ''
  }
  const body: any = {
    start_time,
    end_time,
    device_sn: droneValue.value,
  }
  try {
    loading.value = true
    exportShow.value = false
    const res = await downloadZip(body)
    const blob: Blob = res.data
    if (blob && blob.type === 'application/json') {
      const text = await blob.text()
      try {
        const obj = JSON.parse(text)
        message.error(obj.message || '导出失败')
      } catch (e) {
        message.error('导出失败')
      }
      return
    }
    let filename = `${droneValue.value || 'export'}.zip`
    const disposition = res.headers['content-disposition'] || res.headers['Content-Disposition']
    if (disposition) {
      const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(disposition)
      const rawName = (match && (match[1] || match[2])) || ''
      if (rawName) {
        try {
          filename = decodeURIComponent(rawName)
        } catch {
          filename = rawName
        }
      }
    }

    downloadFile(blob, filename)
  } finally {
    loading.value = false
  }
}

// 图片合成
const selectedRowKeys = ref([])
const selectedRows = ref([])
const selectedFolderRowKeys = ref<string[]>([])
const selectedFolderRows = ref<any[]>([])

const synthesisShow = ref(false)
const synthesisLoading = ref(false)
const synthesisProgress = ref(0)
let progressTimer: ReturnType<typeof setInterval> | null = null

const synthesisValue = ref('')
const synthesisRadioValue = ref('opencv')

const onSelectChange = (keys, rows) => {
  const imageRows = rows.filter(row => {
    // 检查是否是图片类型
    const isImage = row.file_type && ['jpeg', 'jpg', 'png'].includes(row.file_type.toLowerCase())
    // 检查是否是全景图，全景图不能参与合成
    const isPanorama = row.panorama === true
    return isImage && !isPanorama
  })

  // 只保留非全景图的图片类型的key
  const imageKeys = imageRows.map(row => row.file_id)

  selectedRowKeys.value = imageKeys
  selectedRows.value = imageRows
}

const getCheckboxProps = (record) => {
  // 检查是否是图片类型
  const isImage = record.file_type && ['jpeg', 'jpg', 'png'].includes(record.file_type)
  // 检查是否是全景图
  const isPanorama = record.panorama === true

  // 只有图片类型且不是全景图的记录才能被选择
  return {
    disabled: !isImage || isPanorama,
  }
}

const handleImageSynthesis = () => {
  // 检查已选中的行中是否包含全景图
  const hasPanorama = selectedRows.value.some(row => row.panorama === true)

  if (hasPanorama) {
    message.warning('全景图不能参与图片合成，请重新选择普通图片')
    // 清空选中的全景图
    const nonPanoramaRows = selectedRows.value.filter(row => row.panorama !== true)
    selectedRows.value = nonPanoramaRows
    selectedRowKeys.value = nonPanoramaRows.map(row => row.file_id)

    if (selectedRowKeys.value.length < 2) {
      message.warning('请至少选择2张非全景图片进行合成')
      return
    }
  }

  // 确保在打开模态框前重置状态
  resetSynthesisModal()
  synthesisShow.value = true
}

const okButtonProps = computed(() => ({
  disabled: synthesisLoading.value || currentSelectedCount.value < 2
}))

const startProgressSimulation = () => {
  synthesisProgress.value = 0
  progressTimer = setInterval(() => {
    if (synthesisProgress.value < 90) {
      synthesisProgress.value += 10
    }
  }, 500)
}

const stopProgressSimulation = () => {
  if (progressTimer) {
    clearInterval(progressTimer)
    progressTimer = null
  }
  synthesisProgress.value = 100
  setTimeout(() => {
    synthesisProgress.value = 0
  }, 2000)
}

const onFolderSelectChange = (keys: string[], rows: any[]) => {
  const imageRows = rows.filter(row => {
    const isImage = row.file_type && ['jpeg', 'jpg', 'png'].includes(row.file_type.toLowerCase())
    const isPanorama = row.panorama === true
    const isVideo = row.file_type === 'mp4'
    return isImage && !isPanorama && !isVideo
  })

  const allRows = rows

  selectedFolderRowKeys.value = imageRows.map(row => row.id)
  selectedFolderRows.value = imageRows

  selectedFolderRowKeysForMove.value = keys
  selectedFolderRowsForMove.value = allRows
}

const getFolderCheckboxProps = (record: any) => {
  /* const isImage = record.file_type && ['jpeg', 'jpg', 'png'].includes(record.file_type.toLowerCase())
  const isPanorama = record.panorama === true
  const isVideo = record.file_type === 'mp4'
  return {
    disabled: !isImage || isPanorama || isVideo
  } */
  return {}
}

const handleFolderImageSynthesis = () => {
  const hasPanorama = selectedFolderRows.value.some(row => row.panorama === true)
  const hasVideo = selectedFolderRows.value.some(row => row.file_type === 'mp4')

  if (hasPanorama || hasVideo) {
    message.warning('全景图和视频不能参与图片合成，请重新选择普通图片')
    const validRows = selectedFolderRows.value.filter(row =>
      row.panorama !== true && row.file_type !== 'mp4'
    )
    selectedFolderRows.value = validRows
    selectedFolderRowKeys.value = validRows.map(row => row.id)

    if (selectedFolderRowKeys.value.length < 2) {
      message.warning('请至少选择2张非全景、非视频的图片进行合成')
      return
    }
  }

  resetSynthesisModal()
  synthesisShow.value = true
}

const synthesisOk = async () => {
  if (!synthesisValue.value.trim()) {
    message.error('请输入合成图片文件名')
    return
  }

  // 根据当前菜单判断数据来源
  let selectedRowsData = []
  let selectedKeys = []

  if (menuSelectedKey.value === 'folder') {
    // 文件夹数据
    selectedRowsData = selectedFolderRows.value
    selectedKeys = selectedFolderRowKeys.value
  } else {
    // 媒体文件数据
    selectedRowsData = selectedRows.value
    selectedKeys = selectedRowKeys.value
  }

  // 检查全景图
  const hasPanorama = selectedRowsData.some(row => row.panorama === true)
  if (hasPanorama) {
    message.error('全景图不能参与图片合成，请重新选择普通图片')
    return
  }

  if (selectedKeys.length < 2) {
    message.error('请至少选择2张图片进行合成')
    return
  }

  if (!synthesisRadioValue.value) {
    message.error('请选择拼接方式')
    return
  }

  // 验证文件名格式
  const fileNameRegex = /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/
  if (!fileNameRegex.test(synthesisValue.value)) {
    message.error('文件名只能包含中文、英文、数字和下划线')
    return
  }

  // 获取图片路径
  let imagePaths = []
  if (menuSelectedKey.value === 'folder') {
    // 文件夹数据：使用 url 字段
    imagePaths = selectedRowsData
      .filter(row => row.url) // 确保有URL
      .map(row => row.url)
  } else {
    // 媒体文件数据：使用 object_key 字段
    imagePaths = selectedRowsData
      .filter(row => row.object_key) // 确保有URL
      .map(row => row.object_key)
  }

  if (imagePaths.length < 2) {
    message.error('选中的图片中缺少有效的URL，请重新选择')
    return
  }

  const params = {
    method: synthesisRadioValue.value,
    image_paths: imagePaths,
    name: synthesisValue.value
  }

  synthesisLoading.value = true
  startProgressSimulation()

  try {
    const res = await getImageSynthesis(params)
    if (res && res.code === 0) {
      stopProgressSimulation()
      await new Promise(resolve => setTimeout(resolve, 1000))
      message.success('图片合成成功，请前往合成文件查看！')
      resetSynthesisModal()
      synthesisShow.value = false

      // 刷新合成文件列表
      fetchCompositeData()

      // 清空选择
      if (menuSelectedKey.value === 'folder') {
        selectedFolderRowKeys.value = []
        selectedFolderRows.value = []
      } else {
        selectedRowKeys.value = []
        selectedRows.value = []
      }
    } else {
      message.error(res?.message || '图片合成失败！')
    }
  } catch (error) {
    message.error('图片合成失败！')
  } finally {
    synthesisLoading.value = false
  }
}

const handleSynthesisCancel = () => {
  resetSynthesisModal()
  synthesisShow.value = false

  // 新增：清空选择的行数据
  if (menuSelectedKey.value === 'folder') {
    selectedFolderRowKeys.value = []
    selectedFolderRows.value = []
  } else {
    selectedRowKeys.value = []
    selectedRows.value = []
  }
}

// 确保 resetSynthesisModal 函数也重置进度和状态
const resetSynthesisModal = () => {
  synthesisValue.value = ''
  synthesisRadioValue.value = 'opencv'
  synthesisProgress.value = 0
  synthesisLoading.value = false
  if (progressTimer) {
    clearInterval(progressTimer)
    progressTimer = null
  }
}

const currentSelectedImages = computed(() => {
  if (menuSelectedKey.value === 'folder') {
    return selectedFolderRows.value
  } else {
    return selectedRows.value
  }
})

const currentSelectedCount = computed(() => {
  if (menuSelectedKey.value === 'folder') {
    return selectedFolderRowKeys.value.length
  } else {
    return selectedRowKeys.value.length
  }
})

const columns = [
  { title: '示例图', width: 200, dataIndex: 'abbreviation_url', key: 'url', align: 'center' },
  { title: '文件名称', dataIndex: 'url', key: 'img', align: 'center' },
  { title: '文件路径', dataIndex: 'file_path', ellipsis: true },
  { title: '设备sn', dataIndex: 'drone', align: 'center', ellipsis: true },
  { title: '设备名称', dataIndex: 'payload', align: 'center', ellipsis: true },
  { title: '大小', dataIndex: 'size', align: 'center' },
  { title: '报告显示', dataIndex: 'in_report', align: 'center' },
  { title: '图片类型', dataIndex: 'panorama', align: 'center' },
  { title: '创建时间', dataIndex: 'create_time', key: 'create_time', align: 'center', sorter: true },
  { title: '操作', width: 150, key: 'action' }
]

// 历史回放表格列定义
const historyPlayColumns = [
  { title: '文件', dataIndex: 'url', key: 'img', align: 'center' },
  { title: '文件路径', dataIndex: 'file_path', ellipsis: true, key: 'path' },
  { title: '设备sn', dataIndex: 'drone', align: 'center', key: 'drone' },
  { title: '设备名称', dataIndex: 'payload', key: 'payload', align: 'center' },
  { title: '大小', dataIndex: 'size', align: 'center', key: 'size' },
  { title: '类型', dataIndex: 'panorama', align: 'center', key: 'panoramas' },
  { title: '创建时间', dataIndex: 'create_time', key: 'create_time', align: 'center', sorter: true },
  { title: '操作', key: 'action' }
]

// 媒体文件分页配置
const paginationProp = reactive<{
  pageSizeOptions: string[];
  showSizeChanger: boolean;
  pageSize: number;
  current: number;
  total: number;
  showTotal:(total: number) => string
    }>({
      pageSizeOptions: ['10', '20', '50', '100'],
      showSizeChanger: true,
      pageSize: 10,
      current: 1,
      total: 0,
      showTotal: (total: number) => `总计 ${total} 条`
    })

// 历史回放分页配置
const paginationHistoryPlayProp = reactive<{
  pageSizeOptions: string[];
  showSizeChanger: boolean;
  pageSize: number;
  current: number;
  total: number;
  showTotal:(total: number) => string
    }>({
      pageSizeOptions: ['10', '20', '50', '100'],
      showSizeChanger: true,
      pageSize: 10,
      current: 1,
      total: 0,
      showTotal: (total: number) => `总计 ${total} 条`
    })

// 范围类型指定为联合类型
type Dayjs = dayjs.Dayjs

const rangeType = ref<'yesterday' | 'today' | 'custom' | ''>('')
const dataTime = ref<[Dayjs | null, Dayjs | null]>([null, null])
const imgDataTime = ref<[Dayjs | null, Dayjs | null]>([null, null])
const vidDataTime = ref<[Dayjs | null, Dayjs | null]>([null, null])
const imgFlyDate = ref<[Dayjs | null, Dayjs | null]>([null, null])

// 快捷选择范围
const handleQuickSelect = (type: 'yesterday' | 'today') => {
  let start: Dayjs, end: Dayjs

  if (type === 'yesterday') {
    // 昨天：从昨天 00:00:00 到昨天 23:59:59
    start = dayjs().subtract(1, 'day').startOf('day')
    end = dayjs().subtract(1, 'day').endOf('day')
  } else {
    // 今天：从今天 00:00:00 到当前时间
    start = dayjs().startOf('day')
    end = dayjs() // 当前时间
  }

  imgDataTime.value = [start, end]
  vidDataTime.value = [start, end]
  rangeType.value = type

  // 触发数据请求
  if (menuSelectedKey.value === 'media') {
    getFiles(true)
  } else if (menuSelectedKey.value === 'history_play') {
    getHistoryPlayFiles(true)
  } else {
    fetchCompositeData(true)
  }
}

const handleCustomDateChange = (dates: [Dayjs | null, Dayjs | null]) => {
  const [start, end] = normalizeDateRange(dates)
  imgDataTime.value = [start, end]
  vidDataTime.value = [start, end]
  // 关键：选择自定义日期时，将类型设为custom，取消按钮高亮
  rangeType.value = 'custom'
  if (menuSelectedKey.value === 'media') {
    getFiles(true)
  } else if (menuSelectedKey.value === 'history_play') {
    getHistoryPlayFiles(true)
  } else {
    fetchCompositeData(true)
  }
}

const fileName = ref('')
const mediaType = ref(null)
const mediaTypeDataList = ref<any[]>([])
type Pagination = TableState['pagination']

interface MediaFile {
  fingerprint: string,
  drone: string,
  payload: string,
  is_original: string,
  file_name: string,
  file_path: string,
  create_time: string,
  file_id: string,
  url: string
}

const mediaData = reactive({
  data: [] as MediaFile[]
})

const historyPlayData = reactive({
  data: [] as MediaFile[]
})

const showHistoryVideo = (url: string, record: any) => {
  videoShow.value = true
  videoUrl.value = url
  currentHistoryVideoInfo.value = record
}

const videoShowCancel = () => {
  videoShow.value = false
  videoUrl.value = ''
}

/* function getMediaTypeList () {
  getDictDataList('media_type').then(res => {
    if (res && res.code === 0) {
      mediaTypeDataList.value = res.data
    }
  })
} */

const panoramaSelect = ref(null)

function getFiles (resetPage = false) {
  if (resetPage) {
    paginationProp.current = 1
  }
  if (hasInvalidFlyRecord.value) {
    mediaData.data = []
    paginationProp.total = 0
    paginationProp.current = 1
    selectedRowKeys.value = []
    selectedRows.value = []
    return
  }
  const [startTime, endTime] = normalizeDateRange(imgDataTime.value)
  const body: any = {
    page: paginationProp.current,
    page_size: paginationProp.pageSize,
    param: {
      file_name: fileName.value,
      media_type: 'jpg,png,jpeg',
      start_time: startTime ? startTime.format('YYYY-MM-DD HH:mm:ss') : '',
      end_time: endTime ? endTime.format('YYYY-MM-DD HH:mm:ss') : '',
      job_name: jobName.value,
      device_sn: selectDeviceSn.value,
      folder_id: selectFolderId.value,
      sort_field: sortImageField.value,
      order_by: sortImageOrder.value
    }
  }
  if (panoramaSelect.value === 'true' || panoramaSelect.value === 'false') {
    body.param.panorama = panoramaSelect.value === 'true'
  } else if (panoramaSelect.value === '1') {
    body.param.sub_file_type = panoramaSelect.value
  }
  getMediaFilesPage(workspaceId, body).then(res => {
    mediaData.data = res.data.list
    paginationProp.total = res.data.pagination.total
    paginationProp.current = res.data.pagination.page
  })
}

function getHistoryPlayFiles (resetPage = false) {
  if (resetPage) {
    paginationHistoryPlayProp.current = 1
  }
  if (hasInvalidFlyRecord.value) {
    historyPlayData.data = []
    paginationHistoryPlayProp.total = 0
    paginationHistoryPlayProp.current = 1
    return
  }

  const body: any = {
    page: paginationHistoryPlayProp.current,
    page_size: paginationHistoryPlayProp.pageSize,
    param: {
      file_name: fileName.value,
      media_type: 'mp4',
      start_time: vidDataTime.value[0] ? dayjs(vidDataTime.value[0]).format('YYYY-MM-DD HH:mm:ss') : '',
      end_time: vidDataTime.value[1] ? dayjs(vidDataTime.value[1]).format('YYYY-MM-DD HH:mm:ss') : '',
      job_name: jobName.value,
      device_sn: selectDeviceSn.value,
      folder_id: selectFolderId.value,
      sort_field: sortVideoField.value,
      order_by: sortVideoOrder.value
    }
  }
  getMediaFilesPage(workspaceId, body).then(res => {
    historyPlayData.data = res.data.list
    paginationHistoryPlayProp.total = res.data.pagination.total
    paginationHistoryPlayProp.current = res.data.pagination.page
  })
}

function refreshData (page: Pagination, filters: any, sorter: any) {
  paginationProp.current = page?.current!
  paginationProp.pageSize = page?.pageSize!
  if (sorter && sorter.columnKey && sorter.order) {
    const fieldMap: Record<string, string> = {
      create_time: 'CREATE_TIME'
    }
    sortImageField.value = fieldMap[sorter.columnKey] || ''
    sortImageOrder.value = sorter.order === 'ascend' ? 'ASC' : sorter.order === 'descend' ? 'DESC' : ''
  } else {
    sortImageField.value = ''
    sortImageOrder.value = ''
  }
  getFiles()
}

function refreshHistoryPlayData (page: Pagination, filters: any, sorter: any) {
  paginationHistoryPlayProp.current = page?.current!
  paginationHistoryPlayProp.pageSize = page?.pageSize!
  if (sorter && sorter.columnKey && sorter.order) {
    const fieldMap: Record<string, string> = {
      create_time: 'CREATE_TIME'
    }
    sortVideoField.value = fieldMap[sorter.columnKey] || ''
    sortVideoOrder.value = sorter.order === 'ascend' ? 'ASC' : sorter.order === 'descend' ? 'DESC' : ''
  } else {
    sortVideoField.value = ''
    sortVideoOrder.value = ''
  }
  getHistoryPlayFiles()
}

function downloadMedia (media: MediaFile) {
  loading.value = true
  downloadWatermarkMediaFile(media.file_id).then(res => {
    if (!res) {
      message.error('下载失败')
      return
    }
    const data = new Blob([res])
    downloadFile(data, media.file_name)
    message.info('下载成功')
  }).finally(() => {
    loading.value = false
  })
}

function downloadMediaVideo (media: MediaFile) {
  loading.value = true
  downloadMediaFile(workspaceId, media.file_id).then(res => {
    if (!res) {
      message.error('下载失败')
      return
    }
    const data = new Blob([res])
    downloadFile(data, media.file_name)
    message.info('下载成功')
  }).finally(() => {
    loading.value = false
  })
}

const reset = (type: number) => {
  fileName.value = ''
  jobName.value = ''
  mediaType.value = null
  imgDataTime.value = [null, null]
  vidDataTime.value = [null, null]
  imgFlyDate.value = [null, null]
  rangeType.value = ''
  selectFolderId.value = ''
  currentFlyRecord.value = null
  selectDeviceSn.value = ''
  currentSelectedKey.value = null
  panoramaSelect.value = null
  selectedRowKeys.value = []
  selectedRows.value = []
  if (type === 1) {
    paginationProp.current = 1
    getFiles()
    fetchFlyRecordData()
  } else {
    paginationHistoryPlayProp.current = 1
    getHistoryPlayFiles()
    fetchFlyRecordData()
  }
}

// 文件夹
interface BreadcrumbItem {
  folder_id: string;
  folder_name: string;
}

const folderName = ref('')
const flightTypeValue = ref(null)
const flightTypeSelectValue = ref([])
const flightTypeDict = ref([])
const folderDataTime = ref([])
const currentFolderId = ref(null)
const isSubFolder = ref(false)
const breadcrumbs = ref<BreadcrumbItem[]>([])
const tableDatas = ref<folderParam[] | subsetParam[]>([])

const fetchflightTypeSelect = async () => {
  const res = await getDictList('media_flight_type')
  flightTypeSelectValue.value = res.data
  flightTypeDict.value = res.data
}

const getFlightTypeLabel = (dictValue) => {
  const matchItem = flightTypeDict.value.find(item => item.dictValue === dictValue)
  return matchItem ? matchItem.dictLabel : dictValue || '-'
}

const handleSearch = () => {
  if (isSubFolder.value) {
    filePagination.current = 1
    if (currentFolderId.value) {
      fetchFiles(currentFolderId.value)
    }
  } else {
    folderPagination.current = 1
    fetchFolders()
  }
}

const handleReset = () => {
  folderName.value = ''
  flightTypeValue.value = null
  filePagination.current = 1
  folderPagination.current = 1
  selectedFolderRowKeys.value = []
  selectedFolderRows.value = []
  selectedFolderRowKeysForMove.value = []
  selectedFolderRowsForMove.value = []
  folderDataTime.value = []
  if (isSubFolder.value && currentFolderId.value) {
    fetchFiles(currentFolderId.value)
  } else {
    fetchFolders()
  }
}

const paginationProp1 = computed(() => ({
  pageSizeOptions: ['10', '20', '50', '100'],
  showSizeChanger: true,
  pageSize: isSubFolder.value ? filePagination.pageSize : folderPagination.pageSize,
  current: isSubFolder.value ? filePagination.current : folderPagination.current,
  total: isSubFolder.value ? filePagination.total : folderPagination.total,
  showTotal: (total: number) => `总计 ${total} 条`
}))

const handleTableChange = (pagination: any, filters: any, sorter: any) => {
  // 根据当前是否为子文件夹切换分页状态
  if (isSubFolder.value) {
    filePagination.current = pagination.current
    filePagination.pageSize = pagination.pageSize
    if (sorter && sorter.columnKey && sorter.order) {
      const fieldMap: Record<string, string> = {
        create_time: 'CREATE_TIME'
      }
      sortFilesField.value = fieldMap[sorter.columnKey] || ''
      sortFilesOrder.value = sorter.order === 'ascend' ? 'ASC' : sorter.order === 'descend' ? 'DESC' : ''
    } else {
      sortFilesField.value = ''
      sortFilesOrder.value = ''
    }

    if (currentFolderId.value) {
      fetchFiles(currentFolderId.value)
    }
  } else {
    folderPagination.current = pagination.current
    folderPagination.pageSize = pagination.pageSize
    // 保存根目录分页状态
    const rootKey = 'root'
    folderPaginationMap.value[rootKey] = {
      current: folderPagination.current,
      pageSize: folderPagination.pageSize
    }
    if (sorter && sorter.columnKey && sorter.order) {
      const fieldMap: Record<string, string> = {
        create_time: 'CREATE_TIME',
        flight_type: 'FLIGHT_TYPE'
      }
      sortFolderField.value = fieldMap[sorter.columnKey] || ''
      sortFolderOrder.value = sorter.order === 'ascend' ? 'ASC' : sorter.order === 'descend' ? 'DESC' : ''
    } else {
      sortFolderField.value = ''
      sortFolderOrder.value = ''
    }
    fetchFolders()
  }
}

const columnses = computed(() => {
  if (!isSubFolder.value) {
    // 文件夹模式
    return [
      { title: '文件名称', width: 250, dataIndex: 'folder_name', key: 'folderName', ellipsis: true },
      { title: '飞行类型', dataIndex: 'flight_type', key: 'flightType', sorter: true },
      { title: '任务名称', dataIndex: 'job_name', key: 'job_name', align: 'center' },
      { title: '航线名称', dataIndex: 'wayline_name', key: 'waylineName', align: 'center' },
      { title: '媒体数量', dataIndex: 'media_count', key: 'media_count', align: 'center' },
      { title: '创建时间', dataIndex: 'create_time', key: 'create_time', sorter: true, align: 'center' },
      { title: '操作', key: 'operation' }
    ]
  } else {
    // 子文件夹模式
    return [
      { title: '文件名称', width: 300, dataIndex: 'name', key: 'folderName' },
      { title: '示例图', width: 200, dataIndex: 'url', key: 'url', align: 'center' },
      { title: '设备Sn', width: 250, dataIndex: 'drone', key: 'drone', align: 'center' },
      { title: '设备负载', width: 250, dataIndex: 'payload', key: 'payload', align: 'center' },
      { title: '报告显示', dataIndex: 'in_report', key: 'in_report', align: 'center' },
      { title: '类型', width: 150, dataIndex: 'panorama', key: 'panoramas', align: 'center' },
      { title: '大小', width: 100, dataIndex: 'size', key: 'size', align: 'center' },
      { title: '创建时间', width: 250, dataIndex: 'create_time', key: 'create_time', align: 'center' },
      { title: '操作', key: 'operation' }
    ]
  }
})

const removeColumns = [
  { title: '文件名称', dataIndex: 'folder_name', key: 'folder_name' },
  { title: '飞行类型', width: 120, dataIndex: 'flight_type', key: 'flightType' },
  { title: '创建时间', dataIndex: 'create_time', key: 'create_time', align: 'center' },
]

const folderPaginationMap = ref<Record<string, { current: number; pageSize: number }>>({})

const handleFolderNameClick = (record: folderParam) => {
  // 保存当前文件夹的分页状态
  if (currentFolderId.value) {
    folderPaginationMap.value[currentFolderId.value] = {
      current: filePagination.current,
      pageSize: filePagination.pageSize
    }
  }

  filePagination.current = 1
  folderPagination.current = 1
  selectedFolderRowKeys.value = []
  selectedFolderRows.value = []

  if (!record || !record.folder_id) {
    console.error('无效的文件夹记录或缺少folder_id', record)
    return
  }

  breadcrumbs.value.push({
    folder_id: record.folder_id,
    folder_name: record.folder_name
  })

  currentFolderId.value = record.folder_id
  isSubFolder.value = true

  columnses.value[0].dataIndex = 'name'
  columnses.value[0].key = 'folderName'

  // 如果有保存的分页状态，则恢复
  if (folderPaginationMap.value[record.folder_id]) {
    const savedPagination = folderPaginationMap.value[record.folder_id]
    filePagination.current = savedPagination.current
    filePagination.pageSize = savedPagination.pageSize
  }

  handleReset()
  // fetchFiles(record.folder_id)
}

// 调用第一个接口：获取文件夹列表
const fetchFolders = async () => {
  const [startTime, endTime] = normalizeDateRange(folderDataTime.value)
  const queryParam = {
    page: folderPagination.current,
    page_size: folderPagination.pageSize,
    param: {
      folder_name: folderName.value,
      start_time: startTime ? startTime.format('YYYY-MM-DD HH:mm:ss') : '',
      end_time: endTime ? endTime.format('YYYY-MM-DD HH:mm:ss') : '',
      flight_type: flightTypeValue.value,
      sort_field: sortFolderField.value,
      order_by: sortFolderOrder.value
    }
  }
  const rootKey = 'root'
  folderPaginationMap.value[rootKey] = {
    current: folderPagination.current,
    pageSize: folderPagination.pageSize
  }
  getFolderPage(workspaceId, queryParam).then(res => {
    if (res && res.code === 0) {
      tableDatas.value = res.data.list
      folderPagination.total = res.data.pagination.total || 0
    }
  })
}

const removeFolderId = ref('')

// 调用第二个接口：获取文件列表
const fetchFiles = async (folder_id) => {
  removeFolderId.value = folder_id
  const queryParam = {
    page: filePagination.current,
    page_size: filePagination.pageSize,
    param: {
      folder_name: folderName.value,
      sort_field: sortFilesField.value,
      order_by: sortFilesOrder.value
    }
  }
  getSubsetPage(workspaceId, folder_id, queryParam).then(res => {
    if (res && res.code === 0) {
      tableDatas.value = res.data.list
      filePagination.total = res.data.pagination.total || 0
      // getAllRecordData(folder_id)
    }
  })
}

const getAllRecordData = (folder_id) => {
  const queryParam = {
    page: 1,
    page_size: filePagination.total,
    param: {
      folder_name: folderName.value
      /* algorithm_id: algorithmId.value,
        device_name: deviceName.value,
        start_time: dataTime.value[0] ? dataTime.value[0].format('YYYY-MM-DD HH:mm:ss') : '',
        end_time: dataTime.value[1] ? dataTime.value[1].format('YYYY-MM-DD HH:mm:ss') : '' */
    }
  }
  childFolderId.value = folder_id
  childFolderName.value = folderName.value

  getSubsetPage(workspaceId, folder_id, queryParam).then(res => {
    if (res && res.code === 0) {
      flyAllRecordData.value = res.data.list
    }
  })
}
const folderLoading = ref(false)

const downloadFolder = async (record: folderParam, isMark: boolean) => {
  folderLoading.value = true
  try {
    const params = {
      folder_id: record.folder_id,
      is_mark: isMark
    }
    const res = await getNewFolderDownload(params)
    const blob: Blob = res.data

    if (blob && blob.type === 'application/json') {
      const text = await blob.text()
      try {
        const obj = JSON.parse(text)
        message.error(obj.message || '导出失败')
      } catch (e) {
        message.error('导出失败')
      }
      return
    }
    const folderName = record.folder_name ? record.folder_name.replace(/^uav--/, '') : ''
    const filename = `${getFlightTypeLabel(record.flight_type) + '_' + folderName}.zip`

    // let filename = `${record.folder_name || 'export'}.zip`
    /* const disposition = res.headers['content-disposition'] || res.headers['Content-Disposition']
    if (disposition) {
      const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(disposition)
      const rawName = (match && (match[1] || match[2])) || ''
      if (rawName) {
        try {
          filename = decodeURIComponent(rawName)
        } catch {
          filename = rawName
        }
      }
    } */
    downloadFile(blob, filename)
  } catch (error) {
    message.error('下载失败，请稍后再试')
  } finally {
    folderLoading.value = false
  }
}

const downloadMedias = async (record: subsetParam) => {
  if (!record.url) {
    message.warning('文件URL不存在，无法下载')
    return
  }
  folderLoading.value = true

  const fileName = record.name || `download.${record.file_type}`

  if (record.file_type === 'mp4') {
    try {
      const response = await fetch(record.url, {
        method: 'GET',
        headers: {
          Accept: 'image/*, video/*'
        }
      })

      if (!response.ok) {
        throw new Error(`请求失败：${response.status} ${response.statusText}`)
      }

      const blob = await response.blob()

      const blobUrl = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = blobUrl
      link.download = fileName

      link.style.display = 'none'
      document.body.appendChild(link)

      const clickEvent = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true
      })
      link.dispatchEvent(clickEvent)

      setTimeout(() => {
        document.body.removeChild(link)
        window.URL.revokeObjectURL(blobUrl)
      }, 100)

      message.success(`开始下载：${fileName}`)
    } catch (error) {
      console.error('下载失败：', error)

      const link = document.createElement('a')

      link.href = `${record.url}?t=${Date.now()}`
      link.download = fileName
      link.style.display = 'none'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      message.warning('自动下载可能失败，请右键链接选择「另存为」')
    } finally {
      folderLoading.value = false
    }
  } else {
    downloadWatermarkMediaFile(record.file_id).then(res => {
      if (!res) {
        message.error('下载失败')
        return
      }
      const data = new Blob([res])
      downloadFile(data, record.name)
      message.info('下载成功')
    }).finally(() => {
      folderLoading.value = false
    })
  }
}

// 文件夹分析结果
const mediaFolderMes = ref([])
const mediaFolderVisible = ref(false)
const folderAnalysisLoading = ref(false)

const viewAnalysisResults = async (record) => {
  mediaFolderVisible.value = true
  folderAnalysisLoading.value = true

  try {
    const res = await getMediaFileAnalysisStatistics(record.folder_id)
    mediaFolderMes.value = res.data
  } catch (error) {
    console.error('获取分析结果失败:', error)
    mediaFolderMes.value = []
  } finally {
    folderAnalysisLoading.value = false
  }
}

const cancelAnalysisResults = () => {
  mediaFolderVisible.value = false
  mediaFolderMes.value = []
  folderAnalysisLoading.value = false
}

// 新建文件夹
const newFolderVisible = ref(false)
const createFormRef = ref(null)

const createForm = reactive({
  name: '',
  flightType: null
})

const createRules = reactive({
  name: [
    { required: true, message: '请填写文件夹名称', trigger: 'blur' },
    { min: 2, max: 20, message: '文件夹名称长度在2-20个字符之间', trigger: 'blur' }
  ],
  flightType: [
    { required: true, message: '请选择飞行类型', trigger: 'change' }
  ]
})

const openCreateFolder = () => {
  newFolderVisible.value = true
  createForm.name = ''
  createForm.flightType = null
  fetchflightTypeSelect()
}

const handleFolderSubmit = async () => {
  await createFormRef.value.validate()
  const param = {
    folder_name: createForm.name,
    flight_type: createForm.flightType,
    workspace_id: workspaceId
  }
  const res = await getCreateNewFolder(param)
  if (res.code === 0) {
    message.success('文件夹新建成功')
    cancelFolderSubmit()
    fetchFolders()
  }
}

const cancelFolderSubmit = () => {
  createForm.name = ''
  createForm.flightType = null
  newFolderVisible.value = false
}

// 文件移动
const removeFolderVisible = ref(false)
const removeDatas = ref([])
const removePaginationProp = reactive({
  current: 1,
  pageSize: 10,
  total: 0
})
const selectedRemoveRowKeys = ref([])
const selectedRemoveRow = ref(null)
const selectedRemoveFolder = ref<string[]>([])
const selectedFolderRowKeysForMove = ref<string[]>([])
const selectedFolderRowsForMove = ref<any[]>([])

const removeRowSelection = computed(() => {
  return {
    type: 'radio',
    selectedRowKeys: selectedRemoveRowKeys.value,
    onChange: (keys, rows) => {
      selectedRemoveRowKeys.value = keys
      selectedRemoveRow.value = rows[0] || null
    },
  }
})

const handleRemoveFolderImage = () => {
  console.log('移动按钮被点击，选中行数量：', selectedFolderRowsForMove.value.length)
  selectedRemoveFolder.value = selectedFolderRowsForMove.value.map(row => row.file_id)
  removeFolderVisible.value = true
  selectedRemoveRowKeys.value = []
  selectedRemoveRow.value = null
  fetchRemoveFolders()
}

const fetchRemoveFolders = async () => {
  const queryParam = {
    page: removePaginationProp.current,
    page_size: removePaginationProp.pageSize,
    param: {
      // folder_name: folderName.value,
      // start_time: folderDataTime.value[0] ? dayjs(folderDataTime.value[0]).format('YYYY-MM-DD HH:mm:ss') : '',
      // end_time: folderDataTime.value[1] ? dayjs(folderDataTime.value[1]).format('YYYY-MM-DD HH:mm:ss') : '',
      // flight_type: flightTypeValue.value
    }
  }
  getFolderPage(workspaceId, queryParam).then(res => {
    if (res && res.code === 0) {
      removeDatas.value = res.data.list
      removePaginationProp.total = res.data.pagination.total || 0
    }
  })
}

const handleRemoveChange = (pagination: any) => {
  removePaginationProp.current = pagination.current
  removePaginationProp.pageSize = pagination.pageSize
  selectedRemoveRowKeys.value = []
  selectedRemoveRow.value = null
  fetchRemoveFolders()
}

const handleRemoveSubmit = async () => {
  const targetFolderId = selectedRemoveRow.value.folder_id

  const fileIds = selectedRemoveFolder.value

  const param = {
    folder_id: targetFolderId,
    file_ids: fileIds
  }
  const res = await getRemoveFolder(param)
  if (res && res.code === 0) {
    message.success('移动成功')
    cancelRemoveSubmit()
    fetchFiles(removeFolderId.value)
  }
}

const cancelRemoveSubmit = () => {
  removeFolderVisible.value = false
  selectedRemoveRowKeys.value = []
  selectedRemoveRow.value = null
}

// 模型生成
const newModelVisible = ref(false)
const modelFormRef = ref(null)
const modelLoading = ref(false)
const progressPercent = ref(0)
let modelProgressTimer: number | null = null

const modelForm = reactive({
  name: '',
  device: null
})

const modelRules = reactive({
  name: [
    { required: true, message: '请填写模型名称', trigger: 'blur' },
    { min: 2, max: 20, message: '模型名称长度在2-20个字符之间', trigger: 'blur' }
  ],
  device: [
    { required: true, message: '请选择设备', trigger: 'change' }
  ]
})

const deviceSelectValue = ref([])
const currentRecord = ref(null)
const isDeviceFixed = computed(() => {
  return currentRecord.value?.workspace_id
})

const fixedDeviceNickname = computed(() => {
  if (!currentRecord.value?.workspace_id) return ''
  const deviceFromList = deviceSelectValue.value.find(
    item => item.workspace_id === currentRecord.value.workspace_id
  )
  if (deviceFromList) {
    return deviceFromList.nickname
  }
  return currentRecord.value.deviceName || currentRecord.value.nickname || ''
})

const fetchDeviceData = async () => {
  const res = await getDeviceTopo(workspaceId)
  deviceSelectValue.value = res.data.filter(item => item.domain === 3)
}

const viewModelResults = async (record: any) => {
  modelForm.name = ''
  modelForm.device = null
  currentRecord.value = record
  if (record.workspace_id) {
    modelForm.device = record.workspace_id
  }
  await fetchDeviceData()
  newModelVisible.value = true
}

const cancelModelSubmit = () => {
  modelForm.name = ''
  modelForm.device = null
  newModelVisible.value = false
}

const handleModelSubmit = async () => {
  await modelFormRef.value.validate()

  modelLoading.value = true
  progressPercent.value = 0

  if (modelProgressTimer) { clearInterval(modelProgressTimer) }
  modelProgressTimer = window.setInterval(() => {
    if (progressPercent.value < 99) {
      progressPercent.value += 1
    }
  }, 200)

  try {
    let workspaceIdValue = ''
    if (isDeviceFixed.value) {
      workspaceIdValue = currentRecord.value.workspace_id
    } else {
      workspaceIdValue = modelForm.device
    }

    const param = {
      folderIds: [currentRecord.value.id],
      mediaOriginType: 'inner',
      type: 'auto',
      name: modelForm.name,
      workspaceId: workspaceIdValue
    }
    const res = await getGenerateorthophoto(param)
    if (res.code === 200) {
      progressPercent.value = 100
      message.success('已开始生成正射影像，请稍后前往数据中台查看！')
      setTimeout(() => {
        newModelVisible.value = false
        progressPercent.value = 0
        modelLoading.value = false
      }, 1000)
    } else {
      throw new Error(res.message || '生成失败')
    }
  } catch (error) {
    message.error(error.message || '生成失败')
    progressPercent.value = 0
    modelLoading.value = false
  } finally {
    if (modelProgressTimer) {
      clearInterval(modelProgressTimer)
      modelProgressTimer = null
    }
  }
}

// 面包屑点击事件（返回上级）
const handleBreadcrumbClick = (index) => {
  // 保存当前文件夹的分页状态
  if (currentFolderId.value) {
    folderPaginationMap.value[currentFolderId.value] = {
      current: filePagination.current,
      pageSize: filePagination.pageSize
    }
  }

  selectedFolderRowKeys.value = []
  selectedFolderRows.value = []
  selectedFolderRowKeysForMove.value = []
  selectedFolderRowsForMove.value = []

  if (index === 0) {
    // 返回根目录
    breadcrumbs.value = []
    currentFolderId.value = null
    isSubFolder.value = false
    columnses.value[0].dataIndex = 'folder_name'
    columnses.value[0].key = 'folderName'

    // 检查是否有保存的根目录分页状态
    const rootKey = 'root'
    if (folderPaginationMap.value[rootKey]) {
      const savedPagination = folderPaginationMap.value[rootKey]
      folderPagination.current = savedPagination.current
      folderPagination.pageSize = savedPagination.pageSize
    } else {
      // 如果没有保存的状态，则重置到第一页
      folderPagination.current = 1
    }

    fetchFolders()
    return
  }

  const targetCrumb = breadcrumbs.value[index - 1]
  breadcrumbs.value = breadcrumbs.value.slice(0, index)

  currentFolderId.value = targetCrumb.folder_id
  isSubFolder.value = true
  columnses.value[0].dataIndex = 'name'
  columnses.value[0].key = 'folderName'

  // 恢复目标文件夹的分页状态
  if (folderPaginationMap.value[targetCrumb.folder_id]) {
    const savedPagination = folderPaginationMap.value[targetCrumb.folder_id]
    filePagination.current = savedPagination.current
    filePagination.pageSize = savedPagination.pageSize
  } else {
    // 如果没有保存的状态，则使用第一页
    filePagination.current = 1
  }

  fetchFiles(targetCrumb.folder_id)
}

const inReportChange = async (checked, record) => {
  const param = {
    fileId: record.file_id,
    inReport: checked ? 0 : 1
  }
  const res = await getWhetherUpdatedReport(param)
  if (res.code === 0) {
    message.success('更新成功')
    fetchFiles(record.folder_id)
  }
}

const inReportFileChange = async (checked, record) => {
  const param = {
    fileId: record.file_id,
    inReport: checked ? 0 : 1
  }
  const res = await getWhetherUpdatedReport(param)
  if (res.code === 0) {
    message.success('更新成功')
    getFiles(true)
  }
}

const formatEmptyValue = (value: any) => {
  // 判断值是否为空（包括null、undefined、空字符串、纯空格）
  if (value === null || value === undefined || value.toString().trim() === '') {
    return '--'
  }
  return value
}

const currentMediaUrl = ref('')
const currentFileName = ref('')

const isVideo = (record: subsetParam) => {
  if (!record.file_type) return false
  const videoTypes = ['mp4', 'mov', 'avi', 'mkv', 'flv', 'wmv']
  return videoTypes.includes(record.file_type.toLowerCase())
}

// 判断是否为图片文件
const isImage = (record: subsetParam) => {
  if (!record.file_type) return false
  const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
  return imageTypes.includes(record.file_type.toLowerCase())
}

const handleFilePreview = (record: subsetParam) => {
  if (!auth.hasPermi(['media:preview'])) return
  // 保留参数验证逻辑
  if (!record || !record.url) {
    console.warn('无效的文件记录或缺少URL', record)
    return
  }

  currentFileName.value = record.name || '未知文件'

  folderImageLoading.value = true

  getAllRecordData(record.folder_id)

  const list = flyAllRecordData.value
  let index = list.findIndex(item => item.id === record.id)
  if (index % filePagination.pageSize === 0) {
    index += 1
  }

  mediaContentRef.value.initData(list, index + 1, workspaceId, childFolderId.value, filePagination.current, childFolderName.value, record)
}

const compositeEmus = {
  fusion: '融合合成',
  opencv: '特征合成',
  orb: '特质合成',
  simple: '拼凑合成'
}

const compositeName = ref('')
const compositeSelect = ref(null)
const compositeTableDatas = ref([])

const compositePaginationProp = reactive({
  pageSizeOptions: ['10', '20', '50', '100'],
  showSizeChanger: true,
  pageSize: 10,
  current: 1,
  total: 0,
  showTotal: (total: number) => `总计 ${total} 条`
})

function handleCompositeTableChange (page: Pagination, filters: any, sorter: any) {
  compositePaginationProp.current = page?.current!
  compositePaginationProp.pageSize = page?.pageSize!
  if (sorter && sorter.columnKey && sorter.order) {
    const fieldMap: Record<string, string> = {
      create_time: 'CREATE_TIME'
    }
    sortAnalysisField.value = fieldMap[sorter.columnKey] || ''
    sortAnalysisOrder.value = sorter.order === 'ascend' ? 'ASC' : sorter.order === 'descend' ? 'DESC' : ''
  } else {
    sortAnalysisField.value = ''
    sortAnalysisOrder.value = ''
  }
  fetchCompositeData()
}

const compositeColumns = [
  { title: '示例图', dataIndex: 'url', key: 'url', align: 'center' },
  { title: '文件名称', dataIndex: 'name', key: 'name', align: 'center' },
  { title: '图片类型', dataIndex: 'type', key: 'type', align: 'center' },
  { title: '创建时间', dataIndex: 'create_time', key: 'create_time', align: 'center', sorter: true },
  { title: '创建人', dataIndex: 'username', align: 'center' },
  { title: '操作', key: 'action' }
]

const fetchCompositeData = async (resetPage = false) => {
  if (resetPage) {
    compositePaginationProp.current = 1
  }
  const paramsQuery: synthesisPageRequest = {
    page: compositePaginationProp.current,
    page_size: compositePaginationProp.pageSize,
    param: {
      name: compositeName.value,
      type: compositeSelect.value,
      sort_field: sortAnalysisField.value,
      order_by: sortAnalysisOrder.value
    }
  }
  const res = await getImageSynthesisPage(paramsQuery)
  compositeTableDatas.value = res.data.list
  compositePaginationProp.total = res.data.pagination.total
}

const refreshCompositeData = () => {
  compositeName.value = ''
  compositeSelect.value = null
  compositePaginationProp.current = 1
  fetchCompositeData()
}

const compositeShow = ref(false)
const currentCompositeFile = ref('')
const compositeUrl = ref('')

const openCompositeFile = (record) => {
  compositeShow.value = true
  currentCompositeFile.value = record
  compositeImageLoading.value = true
  compositeUrl.value = record.url
}

const viewOriginalImage = (record) => {
  const list = record.file_list
  const index = 0
  mediaContentRef.value.initData(list, index)
}

const downloadUrl = (url) => {
  window.open(url, '_blank')
}

const analysisShow = ref(false)
const currentAnalysisFile = ref([])
const analysisImageLoading = ref(false)
const analysisUrls = ref('')
const readyAnalysisResults = ref([])

const openAIAnalysisPhoto = (record) => {
  currentAnalysisFile.value = record
  analysisImageLoading.value = true
  analysisShow.value = true
  analysisUrls.value = record.analysis_url
  if (typeof currentAnalysisFile.value.analysis_result === 'string') {
    readyAnalysisResults.value = JSON.parse(currentAnalysisFile.value.analysis_result)
  } else {
    readyAnalysisResults.value = currentAnalysisFile.value.analysis_result
  }
}

const regulationVisible = ref(false)
const regulationVisibleName = ref('添加规章制度条约')
const currentFileId = ref('')
const currentFileRecord = ref<any>(null) // 当前正在编辑的文件
const ruleChose = ref<string[]>([]) // 存储选中的条约ID数组
const ruleChoseDisplay = ref('') // 显示选中的条约名称
const hiddenDanger = ref('')
const regulationTableVisible = ref(false)
const currentRuleData = ref([])

const ruleData = ref([])
const selectedRuleKeys = ref<string[]>([])
const selectedRuleRows = ref<any[]>([])

const rulePagination = reactive({
  pageSizeOptions: ['10', '20', '50', '100'],
  showQuickJumper: true,
  showSizeChanger: true,
  pageSize: 10,
  current: 1,
  total: 0,
  showTotal: (total: number) => `总计 ${total} 条`
})

const ruleColumns = [
  { title: '条例标题', dataIndex: 'title', key: 'title', align: 'center' },
  { title: '条例内容', dataIndex: 'content', align: 'center' },
  { title: '创建人', dataIndex: 'createBy', key: 'createBy', align: 'center' },
  { title: '创建时间', dataIndex: 'createTime', key: 'createTime', align: 'center' },
  { title: '更新人', dataIndex: 'updateBy', key: 'updateBy', align: 'center' },
  { title: '更新时间', dataIndex: 'updateTime', key: 'updateTime', align: 'center' },
]

const rowRuleSelection = computed(() => {
  return {
    type: 'checkbox',
    selectedRowKeys: selectedRuleKeys.value,
    onChange: (selectedKeys: string[], selectedRowsData: any[]) => {
      selectedRuleKeys.value = selectedKeys
      selectedRuleRows.value = selectedRowsData
      updateRuleChoseDisplay()
    },
  }
})

const updateRuleChoseDisplay = () => {
  if (selectedRuleRows.value.length > 0) {
    ruleChoseDisplay.value = selectedRuleRows.value.map(item => item.title).join('、')
    ruleChose.value = selectedRuleRows.value.map(item => item.id)
  } else {
    ruleChoseDisplay.value = ''
    ruleChose.value = []
  }
}

function refreshRuleData (page: Pagination) {
  rulePagination.current = page?.current!
  rulePagination.pageSize = page?.pageSize!
  fetchRuleData()
}

const openRegulations = async (record) => {
  regulationVisible.value = true
  currentFileId.value = record.file_id
  currentFileRecord.value = record

  // 清空当前数据
  ruleChose.value = []
  ruleChoseDisplay.value = ''
  hiddenDanger.value = ''
  selectedRuleKeys.value = []
  selectedRuleRows.value = []

  try {
    const res = await getFileRegulations(currentFileId.value)
    if (res && res.code === 0 && res.data && res.data.length > 0) {
      regulationVisibleName.value = '编辑规章条约'

      currentRuleData.value = res.data

      const ids = res.data.map(item => item.id)
      const titles = res.data.map(item => item.title)

      ruleChose.value = ids
      ruleChoseDisplay.value = titles.join('、')
      hiddenDanger.value = res.data[0].hiddenDanger

      selectedRuleKeys.value = ids.map(id => String(id))
    } else {
      regulationVisibleName.value = '添加规章制度条约'
      currentRuleData.value = []
    }
  } catch (error) {
    console.error('获取文件条约失败:', error)
    regulationVisibleName.value = '添加规章制度条约'
    currentRuleData.value = []
  }
}

const fetchRuleData = async () => {
  const queryParam = {
    page: rulePagination.current,
    pageSize: rulePagination.pageSize,
    param: {
      status: 1
    }
  }
  const res = await getRegulationsPage(queryParam)
  ruleData.value = res.data.list
  rulePagination.total = res.data.pagination.total
}

const getRulesData = async () => {
  const res = await getFileRegulations(currentFileId.value)
  currentRuleData.value = res.data
}

const addRegulaionOk = async () => {
  if (!ruleChoseDisplay.value) {
    message.warning('请选择条约')
    return
  }
  if (!hiddenDanger.value) {
    message.warning('请填写存在隐患')
    return
  }

  const param = {
    fileId: currentFileId.value,
    regulationIds: ruleChose.value.join(','),
    hiddenDanger: hiddenDanger.value
  }
  const res = await getRegulationsFileRule(param)
  if (res.code === 0) {
    message.success('规章条约添加成功')
    regulationVisible.value = false
    await getRulesData()
  }
}

const addRegulaionCancel = () => {
  regulationVisible.value = false
}

const addRegulaionTableOk = () => {
  if (selectedRuleRows.value.length === 0) {
    message.warning('请至少选择一条条约')
    return
  }
  updateRuleChoseDisplay()
  regulationTableVisible.value = false
}

const addRegulaionTableCancel = () => {
  // 恢复之前的选择
  if (ruleChose.value.length > 0) {
    const matchedRows = ruleData.value.filter(item => ruleChose.value.includes(item.id))
    if (matchedRows.length > 0) {
      selectedRuleRows.value = matchedRows
      selectedRuleKeys.value = matchedRows.map(item => item.id)
      updateRuleChoseDisplay()
    }
  } else {
    selectedRuleRows.value = []
    selectedRuleKeys.value = []
    ruleChoseDisplay.value = ''
  }
  regulationTableVisible.value = false
}

const selectRules = () => {
  regulationTableVisible.value = true
  fetchRuleData()

  // 恢复之前选中的条约
  if (ruleChose.value.length > 0) {
    // 等待数据加载完成后再设置选中状态
    setTimeout(() => {
      const matchedRows = ruleData.value.filter(item => ruleChose.value.includes(item.id))
      if (matchedRows.length > 0) {
        selectedRuleRows.value = matchedRows
        selectedRuleKeys.value = matchedRows.map(item => item.id)
      }
    }, 100)
  }
}

// identify_file 外部
const identifyFileName = ref('')
const identifyLoading = ref(false)
const isIdentifyFolder = ref(false)
const tableIdentifyDatas = ref([])
const currentIdentifyFolderId = ref(null)
const breadcrumbsIdentify = ref<BreadcrumbItem[]>([])
const folderIdentifyPaginationMap = ref<Record<string, { current: number; pageSize: number }>>({})

const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B'
  if (!bytes || isNaN(bytes)) return '--'

  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))

  // 保留两位小数
  const value = bytes / Math.pow(k, i)
  return `${value.toFixed(2)} ${sizes[i]}`
}

const identifyColumnses = computed(() => {
  if (!isIdentifyFolder.value) {
    // 文件夹模式
    return [
      { title: '文件名称', dataIndex: 'folderName', key: 'folderName' },
      { title: '创建人', dataIndex: 'createBy', key: 'createBy' },
      { title: '媒体数量', dataIndex: 'fileCount', key: 'fileCount' },
      { title: '创建时间', dataIndex: 'createTime', key: 'createTime', align: 'center' }
    ]
  } else {
    // 子文件夹模式
    return [
      { title: '文件名称', dataIndex: 'fileName', key: 'folderName' },
      { title: '原图', dataIndex: 'url', key: 'url', align: 'center' },
      { title: '大模型分析结果', dataIndex: 'largeModelAnalysisResult', key: 'largeModelAnalysisResult', align: 'center' },
      { title: '文件大小', dataIndex: 'fileSize', key: 'fileSize', align: 'center' },
      { title: '创建时间', dataIndex: 'createTime', key: 'createTime', align: 'center' },
      { title: '操作', key: 'operation' }
    ]
  }
})

const identifyFolderPagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0
})

const identifyFilePagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0
})

const identifyPaginationProp = computed(() => ({
  pageSizeOptions: ['10', '20', '50', '100'],
  showSizeChanger: true,
  pageSize: isIdentifyFolder.value ? identifyFilePagination.pageSize : identifyFolderPagination.pageSize,
  current: isIdentifyFolder.value ? identifyFilePagination.current : identifyFolderPagination.current,
  total: isIdentifyFolder.value ? identifyFilePagination.total : identifyFolderPagination.total,
  showTotal: (total: number) => `总计 ${total} 条`
}))

const handleIdentifyBreadcrumbClick = (index) => {
  // 保存当前文件夹的分页状态
  if (currentIdentifyFolderId.value) {
    folderIdentifyPaginationMap.value[currentIdentifyFolderId.value] = {
      current: identifyFilePagination.current,
      pageSize: identifyFilePagination.pageSize
    }
  }

  if (index === 0) {
    // 返回根目录
    breadcrumbsIdentify.value = []
    currentIdentifyFolderId.value = null
    isIdentifyFolder.value = false
    identifyColumnses.value[0].dataIndex = 'folderName'
    identifyColumnses.value[0].key = 'folderName'

    // 检查是否有保存的根目录分页状态
    const rootKey = 'root'
    if (folderIdentifyPaginationMap.value[rootKey]) {
      const savedPagination = folderIdentifyPaginationMap.value[rootKey]
      identifyFolderPagination.current = savedPagination.current
      identifyFolderPagination.pageSize = savedPagination.pageSize
    } else {
      // 如果没有保存的状态，则重置到第一页
      identifyFolderPagination.current = 1
    }

    fetchIdentifyFolders()
    return
  }

  const targetCrumb = breadcrumbsIdentify.value[index - 1]
  breadcrumbsIdentify.value = breadcrumbsIdentify.value.slice(0, index)

  currentIdentifyFolderId.value = targetCrumb.folderId
  isIdentifyFolder.value = true
  identifyColumnses.value[0].dataIndex = 'fileName'
  identifyColumnses.value[0].key = 'folderName'

  // 恢复目标文件夹的分页状态
  if (folderIdentifyPaginationMap.value[targetCrumb.folderId]) {
    const savedPagination = folderIdentifyPaginationMap.value[targetCrumb.folderId]
    identifyFilePagination.current = savedPagination.current
    identifyFilePagination.pageSize = savedPagination.pageSize
  } else {
    // 如果没有保存的状态，则使用第一页
    identifyFilePagination.current = 1
  }

  fetchIdentifyFiles(targetCrumb.folderId)
}

const handleIdentifyTableChange = (pagination: any) => {
  // 根据当前是否为子文件夹切换分页状态
  if (isIdentifyFolder.value) {
    identifyFilePagination.current = pagination.current
    identifyFilePagination.pageSize = pagination.pageSize

    if (currentIdentifyFolderId.value) {
      fetchIdentifyFiles(currentIdentifyFolderId.value)
    }
  } else {
    identifyFolderPagination.current = pagination.current
    identifyFolderPagination.pageSize = pagination.pageSize
    // 保存根目录分页状态
    const rootKey = 'root'
    folderIdentifyPaginationMap.value[rootKey] = {
      current: identifyFolderPagination.current,
      pageSize: identifyFolderPagination.pageSize
    }
    fetchIdentifyFolders()
  }
}

const handleIdentifySearch = () => {
  if (isIdentifyFolder.value) {
    identifyFilePagination.current = 1
    if (currentIdentifyFolderId.value) {
      fetchIdentifyFiles(currentIdentifyFolderId.value)
    }
  } else {
    identifyFolderPagination.current = 1
    fetchIdentifyFolders()
  }
}

const handleIdentifyNameClick = (record) => {
  // 保存当前文件夹的分页状态
  if (currentIdentifyFolderId.value) {
    folderIdentifyPaginationMap.value[currentIdentifyFolderId.value] = {
      current: identifyFilePagination.current,
      pageSize: identifyFilePagination.pageSize
    }
  }

  identifyFilePagination.current = 1
  identifyFolderPagination.current = 1

  if (!record || !record.folderId) {
    console.error('无效的文件夹记录或缺少folderId', record)
    return
  }

  breadcrumbsIdentify.value.push({
    folderId: record.folderId,
    folderName: record.folderName
  })

  currentIdentifyFolderId.value = record.folderId
  isIdentifyFolder.value = true

  if (folderIdentifyPaginationMap.value[record.folderId]) {
    const saved = folderIdentifyPaginationMap.value[record.folderId]
    identifyFilePagination.current = saved.current
    identifyFilePagination.pageSize = saved.pageSize
  }

  fetchIdentifyFiles(record.folderId)
}

const handleIdentifyReset = () => {
  identifyFileName.value = '' // 清空搜索关键词
  identifyFilePagination.current = 1 // 重置子文件夹分页
  identifyFolderPagination.current = 1 // 重置根文件夹分页

  if (isIdentifyFolder.value && currentIdentifyFolderId.value) {
    // 当前在子文件夹内：重置后仍留在该文件夹，重新获取文件列表
    fetchIdentifyFiles(currentIdentifyFolderId.value)
  } else {
    // 当前在根目录：重置后重新获取根目录文件夹列表
    fetchIdentifyFolders()
  }
}

const fetchIdentifyFolders = async () => {
  const queryParam = {
    page: identifyFolderPagination.current,
    pageSize: identifyFolderPagination.pageSize,
    param: {
      folderName: identifyFileName.value
    }
  }
  const rootKey = 'root'
  folderIdentifyPaginationMap.value[rootKey] = {
    current: identifyFolderPagination.current,
    pageSize: identifyFolderPagination.pageSize
  }
  getOutFolderLmPage(queryParam).then(res => {
    if (res && res.code === 0) {
      tableIdentifyDatas.value = res.data.list
      identifyFolderPagination.total = res.data.pagination.total || 0
    }
  })
}

const fetchIdentifyFiles = async (folderId) => {
  const queryParam = {
    page: identifyFilePagination.current,
    pageSize: identifyFilePagination.pageSize,
    param: {
      fileName: identifyFileName.value,
      folderId: folderId
    }
  }
  getOutFolderLmFilePage(queryParam).then(res => {
    if (res && res.code === 0) {
      tableIdentifyDatas.value = res.data.list
      identifyFilePagination.total = res.data.pagination.total || 0
    }
  })
}

const openIdentifyFile = (record) => {
  if (!auth.hasPermi(['media:preview'])) return
  compositeShow.value = true
  currentCompositeFile.value = record
  compositeImageLoading.value = true
  compositeUrl.value = record.url
}

// third_media 外部
const thirdMediaFileName = ref('')
const thirdMediaLoading = ref(false)
const isThirdMediaFolder = ref(false)
const tableThirdMediaDatas = ref([])
const currentThirdMediaFolderId = ref(null)
const breadcrumbsThirdMedia = ref<BreadcrumbItem[]>([])
const folderThirdMediaPaginationMap = ref<Record<string, { current: number; pageSize: number }>>({})

const thirdMediaColumnses = computed(() => {
  if (!isThirdMediaFolder.value) {
    // 文件夹模式
    return [
      { title: '文件名称', dataIndex: 'folderName', key: 'folderName' },
      { title: '创建人', dataIndex: 'createBy', key: 'createBy' },
      { title: '媒体数量', dataIndex: 'fileCount', key: 'fileCount' },
      { title: '创建时间', dataIndex: 'createTime', key: 'createTime', align: 'center' },
    ]
  } else {
    // 子文件夹模式
    return [
      { title: '文件名称', dataIndex: 'fileName', key: 'folderName' },
      { title: '原图', dataIndex: 'url', key: 'url', align: 'center' },
      { title: '大模型分析结果', dataIndex: 'largeModelAnalysisResult', key: 'largeModelAnalysisResult', align: 'center' },
      { title: '文件大小', dataIndex: 'fileSize', key: 'fileSize', align: 'center' },
      { title: '创建时间', dataIndex: 'createTime', key: 'createTime', align: 'center' },
      { title: '操作', key: 'operation' }
    ]
  }
})

const thirdMediaFolderPagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0
})

const thirdMediaFilePagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0
})

const thirdMediaPaginationProp = computed(() => ({
  pageSizeOptions: ['10', '20', '50', '100'],
  showSizeChanger: true,
  pageSize: isThirdMediaFolder.value ? thirdMediaFilePagination.pageSize : thirdMediaFolderPagination.pageSize,
  current: isThirdMediaFolder.value ? thirdMediaFilePagination.current : thirdMediaFolderPagination.current,
  total: isThirdMediaFolder.value ? thirdMediaFilePagination.total : thirdMediaFolderPagination.total,
  showTotal: (total: number) => `总计 ${total} 条`
}))

const handleThirdMediaBreadcrumbClick = (index) => {
  // 保存当前文件夹的分页状态
  if (currentThirdMediaFolderId.value) {
    folderThirdMediaPaginationMap.value[currentThirdMediaFolderId.value] = {
      current: thirdMediaFilePagination.current,
      pageSize: thirdMediaFilePagination.pageSize
    }
  }

  if (index === 0) {
    // 返回根目录
    breadcrumbsThirdMedia.value = []
    currentThirdMediaFolderId.value = null
    isThirdMediaFolder.value = false
    thirdMediaColumnses.value[0].dataIndex = 'folderName'
    thirdMediaColumnses.value[0].key = 'folderName'

    // 检查是否有保存的根目录分页状态
    const rootKey = 'root'
    if (folderThirdMediaPaginationMap.value[rootKey]) {
      const savedPagination = folderThirdMediaPaginationMap.value[rootKey]
      thirdMediaFolderPagination.current = savedPagination.current
      thirdMediaFolderPagination.pageSize = savedPagination.pageSize
    } else {
      // 如果没有保存的状态，则重置到第一页
      thirdMediaFolderPagination.current = 1
    }

    fetchThirdMediaFolders()
    return
  }

  const targetCrumb = breadcrumbsThirdMedia.value[index - 1]
  breadcrumbsThirdMedia.value = breadcrumbsThirdMedia.value.slice(0, index)

  currentThirdMediaFolderId.value = targetCrumb.folderId
  isThirdMediaFolder.value = true
  thirdMediaColumnses.value[0].dataIndex = 'fileName'
  thirdMediaColumnses.value[0].key = 'folderName'

  // 恢复目标文件夹的分页状态
  if (folderThirdMediaPaginationMap.value[targetCrumb.folderId]) {
    const savedPagination = folderThirdMediaPaginationMap.value[targetCrumb.folderId]
    thirdMediaFilePagination.current = savedPagination.current
    thirdMediaFilePagination.pageSize = savedPagination.pageSize
  } else {
    // 如果没有保存的状态，则使用第一页
    thirdMediaFilePagination.current = 1
  }

  fetchThirdMediaFiles(targetCrumb.folderId)
}

const handleThirdMediaTableChange = (pagination: any) => {
  // 根据当前是否为子文件夹切换分页状态
  if (isThirdMediaFolder.value) {
    thirdMediaFilePagination.current = pagination.current
    thirdMediaFilePagination.pageSize = pagination.pageSize

    if (currentThirdMediaFolderId.value) {
      fetchThirdMediaFiles(currentThirdMediaFolderId.value)
    }
  } else {
    thirdMediaFolderPagination.current = pagination.current
    thirdMediaFolderPagination.pageSize = pagination.pageSize
    // 保存根目录分页状态
    const rootKey = 'root'
    folderThirdMediaPaginationMap.value[rootKey] = {
      current: thirdMediaFolderPagination.current,
      pageSize: thirdMediaFolderPagination.pageSize
    }
    fetchThirdMediaFolders()
  }
}

const handleThirdMediaSearch = () => {
  if (isThirdMediaFolder.value) {
    thirdMediaFilePagination.current = 1
    if (currentThirdMediaFolderId.value) {
      fetchThirdMediaFiles(currentThirdMediaFolderId.value)
    }
  } else {
    thirdMediaFolderPagination.current = 1
    fetchThirdMediaFolders()
  }
}

const handleThirdMediaNameClick = (record) => {
  // 保存当前文件夹的分页状态
  if (currentThirdMediaFolderId.value) {
    folderThirdMediaPaginationMap.value[currentThirdMediaFolderId.value] = {
      current: thirdMediaFilePagination.current,
      pageSize: thirdMediaFilePagination.pageSize
    }
  }

  thirdMediaFilePagination.current = 1
  thirdMediaFolderPagination.current = 1

  if (!record || !record.folderId) {
    console.error('无效的文件夹记录或缺少folderId', record)
    return
  }

  breadcrumbsThirdMedia.value.push({
    folderId: record.folderId,
    folderName: record.folderName
  })

  currentThirdMediaFolderId.value = record.folderId
  isThirdMediaFolder.value = true

  if (folderThirdMediaPaginationMap.value[record.folderId]) {
    const saved = folderThirdMediaPaginationMap.value[record.folderId]
    thirdMediaFilePagination.current = saved.current
    thirdMediaFilePagination.pageSize = saved.pageSize
  }

  fetchThirdMediaFiles(record.folderId)
}

const handleThirdMediaReset = () => {
  thirdMediaFileName.value = '' // 清空搜索关键词
  thirdMediaFilePagination.current = 1 // 重置子文件夹分页
  thirdMediaFolderPagination.current = 1 // 重置根文件夹分页

  if (isThirdMediaFolder.value && currentThirdMediaFolderId.value) {
    // 当前在子文件夹内：重置后仍留在该文件夹，重新获取文件列表
    fetchThirdMediaFiles(currentThirdMediaFolderId.value)
  } else {
    // 当前在根目录：重置后重新获取根目录文件夹列表
    fetchThirdMediaFolders()
  }
}

const fetchThirdMediaFolders = async () => {
  const queryParam = {
    page: thirdMediaFolderPagination.current,
    pageSize: thirdMediaFolderPagination.pageSize,
    param: {
      folderName: thirdMediaFileName.value
    }
  }
  const rootKey = 'root'
  folderThirdMediaPaginationMap.value[rootKey] = {
    current: thirdMediaFolderPagination.current,
    pageSize: thirdMediaFolderPagination.pageSize
  }
  getOutFolderPage(queryParam).then(res => {
    if (res && res.code === 0) {
      tableThirdMediaDatas.value = res.data.list
      thirdMediaFolderPagination.total = res.data.pagination.total || 0
    }
  })
}

const fetchThirdMediaFiles = async (folderId) => {
  const queryParam = {
    page: thirdMediaFilePagination.current,
    pageSize: thirdMediaFilePagination.pageSize,
    param: {
      fileName: thirdMediaFileName.value,
      folderId: folderId
    }
  }
  getOutFilePage(queryParam).then(res => {
    if (res && res.code === 0) {
      tableThirdMediaDatas.value = res.data.list
      thirdMediaFilePagination.total = res.data.pagination.total || 0
    }
  })
}

/* const openThirdMediaFile = (record) => {
  if (!auth.hasPermi(['media:preview'])) return
  compositeShow.value = true
  currentCompositeFile.value = record
  compositeImageLoading.value = true
  compositeUrl.value = record.url
} */

// 图片检测
const monitorTypeValue = ref(null)
const monitorName = ref('')
const monitorDataTime = ref([])
const monitorValue = ref([])
const monitorCreateVisible = ref(false)
const panelActiveKeys = ref<Record<string, string[]>>({})
const advancedActiveKey = ref([])
const sourceImage = ref(null) // 选中的原图记录
const targetImage = ref(null) // 选中的对比图记录
const createSubmitting = ref(false)
const uploadingState = ref(null)

const canCreateTask = computed(() => sourceImage.value && targetImage.value && !createSubmitting.value)

const systemPickerVisible = ref(false)
const systemPickerTarget = ref<'source' | 'target' | null>(null)
const systemMediaList = ref([])
const pickerLoading = ref(false)
const selectedPickerRecord = ref<any>(null)
const selectedPickerRowKey = ref<string[]>([])

const statusConfig = {
  FAILED: { text: '失败', color: 'red' },
  RUNNING: { text: '处理中', color: 'orange' },
  PENDING: { text: '待处理', color: 'blue' },
  SUCCESS: { text: '成功', color: 'green' }
}

const monitorPagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0,
  pageSizeOptions: ['10', '20', '50'],
  showQuickJumper: true,
  showSizeChanger: true,
  showTotal: (total: number) => `总计 ${total} 条`
})

const handleMonitorPageChange = (page: number, pageSize: number) => {
  monitorPagination.current = page
  monitorPagination.pageSize = pageSize
  fetchMonitorData(false)
}

const handleMonitorPageSizeChange = (current: number, size: number) => {
  monitorPagination.current = 1
  monitorPagination.pageSize = size
  fetchMonitorData(true)
}

const fetchMonitorData = async (resetPage = false) => {
  if (resetPage) {
    monitorPagination.current = 1
  }
  const [startTime, endTime] = normalizeDateRange(monitorDataTime.value)
  const queryParam = {
    page: monitorPagination.current,
    pageSize: monitorPagination.pageSize,
    param: {
      name: monitorName.value,
      workspaceId: '',
      status: monitorTypeValue.value,
      startTime: startTime ? startTime.format('YYYY-MM-DD HH:mm:ss') : '',
      endTime: endTime ? endTime.format('YYYY-MM-DD HH:mm:ss') : '',
    }
  }
  const res = await getMontiorPage(queryParam)
  monitorValue.value = res.data.list
  monitorPagination.total = res.data.pagination.total
  monitorValue.value.forEach(item => {
    if (!panelActiveKeys.value[item.id]) {
      panelActiveKeys.value[item.id] = []
    }
  })
}

const handleMonitorReset = () => {
  monitorTypeValue.value = null
  monitorName.value = ''
  monitorDataTime.value = []
  monitorPagination.current = 1
  fetchMonitorData()
}

const handleMonitorCreate = () => {
  monitorCreateVisible.value = true
  resetCreateTaskDialog()
}

const createStep = ref(0)
const createTaskFormRef = ref(null)

const createTaskForm = reactive({
  name: '',
  alignmentModel: 'HOMOGRAPHY',
  illuminanceMode: 'STANDARD',
  orbFeatures: 8000,
  matchRatio: 0.75,
  ransacReprojThreshold: 8,
  minContourAreaRatio: 0.00015,
  mergeBoxIou: 0.35,
  maxBoxes: 200,
  minInliers: 40,
  minAbsdiffAfterOtsu: 10,
})

const createTaskRules = {
  name: [{ required: true, message: '请输入任务名称', trigger: 'blur' }]
}

const pickerPagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0,
  showSizeChanger: true,
  pageSizeOptions: ['10', '20', '50', '100'],
  showTotal: (total: number) => `总计 ${total} 条`
})

const pickerQuery = reactive({
  fileName: '',
  dataTime: []
})

const pickerColumns = [
  { title: '缩略图', align: 'center', key: 'thumb', dataIndex: 'img' },
  { title: '文件名称', dataIndex: 'file_name', key: 'fileName', ellipsis: true },
  { title: '创建时间', dataIndex: 'create_time', key: 'createTime', customRender: ({ text }) => text || '--' }
]

// 判断是否为图片行（用于禁用非图片行点击）
const isImageRow = (record) => {
  const imageTypes = ['jpeg', 'jpg', 'png']
  return record.file_type && imageTypes.includes(record.file_type.toLowerCase())
}

// 行样式：非图片行添加禁用样式（不可点击）
const pickerRowClassName = (record) => {
  return isImageRow(record) ? '' : 'picker-row-disabled'
}

const fetchSystemMediaList = async () => {
  pickerLoading.value = true
  const body = {
    page: pickerPagination.current,
    page_size: pickerPagination.pageSize,
    param: {
      file_name: pickerQuery.fileName,
      media_type: 'jpg,png,jpeg',
      start_time: pickerQuery.dataTime[0] ? dayjs(pickerQuery.dataTime[0]).format('YYYY-MM-DD HH:mm:ss') : '',
      end_time: pickerQuery.dataTime[1] ? dayjs(pickerQuery.dataTime[1]).format('YYYY-MM-DD HH:mm:ss') : '',
    }
  }
  try {
    const res = await getMediaFilesPage(workspaceId, body)
    if (res && res.code === 0) {
      systemMediaList.value = res.data.list
      pickerPagination.total = res.data.pagination.total
      pickerPagination.current = res.data.pagination.page
    } else {
      systemMediaList.value = []
      pickerPagination.total = 0
    }
  } catch (error) {
    console.error('获取媒体文件失败', error)
    systemMediaList.value = []
    pickerPagination.total = 0
  } finally {
    pickerLoading.value = false
  }
}

const handlePickerTableChange = (pagination: any) => {
  pickerPagination.current = pagination.current
  pickerPagination.pageSize = pagination.pageSize
  fetchSystemMediaList()
}

const handlePickerSearch = () => {
  pickerPagination.current = 1
  fetchSystemMediaList()
}

const resetPickerQuery = () => {
  pickerQuery.fileName = ''
  pickerQuery.dataTime = []
  pickerPagination.current = 1
  fetchSystemMediaList()
}

const onPickerRowSelect = (keys: string[], rows: any[]) => {
  if (rows.length > 0) {
    selectedPickerRecord.value = rows[0]
    selectedPickerRowKey.value = [rows[0].file_id]
  } else {
    selectedPickerRecord.value = null
    selectedPickerRowKey.value = []
  }
}

const confirmPickerSelection = () => {
  if (!selectedPickerRecord.value) return
  const record = selectedPickerRecord.value
  if (!record.object_key) {
    message.warning('该文件缺少 objectKey，无法用于变化检测')
    return
  }
  const imageData = {
    objectKey: record.object_key,
    fileName: record.file_name,
    url: record.url || '',
    isUploaded: false
  }
  if (systemPickerTarget.value === 'source') {
    // 检查是否与对比图重复
    if (targetImage.value && targetImage.value.objectKey === record.object_key) {
      message.warning('原图不能与对比图为同一文件')
      return
    }
    sourceImage.value = imageData
  } else if (systemPickerTarget.value === 'target') {
    if (sourceImage.value && sourceImage.value.objectKey === record.object_key) {
      message.warning('对比图不能与原图为同一文件')
      return
    }
    targetImage.value = imageData
  }
  systemPickerVisible.value = false
  selectedPickerRecord.value = null
  selectedPickerRowKey.value = []
}

const openSystemPicker = (target: 'source' | 'target') => {
  systemPickerTarget.value = target
  systemPickerVisible.value = true
  selectedPickerRecord.value = null
  selectedPickerRowKey.value = []
  pickerPagination.current = 1
  fetchSystemMediaList()
}

const triggerUpload = (target: 'source' | 'target') => {
  const input = document.createElement('input')
  input.type = 'file'
  input.accept = 'image/*'
  input.onchange = (e: any) => {
    const file = e.target.files[0]
    if (!file) return
    if (!file.type.startsWith('image/')) {
      message.warning('请选择图片文件')
      return
    }
    handleLocalUpload(file, target)
  }
  input.click()
}

const handleLocalUpload = async (file: File, target: 'source' | 'target') => {
  console.log('file', file)
  uploadingState.value = target
  const previewUrl = URL.createObjectURL(file)
  const tempImage = {
    fileName: file.name,
    previewUrl,
    isUploaded: true,
    uploading: true
  }
  if (target === 'source') sourceImage.value = tempImage
  else targetImage.value = tempImage

  try {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('path', `change-task/${Date.now()}`)
    const uploadRes = await uploadUavFile(formData)

    if (uploadRes.code !== 0 || !uploadRes.data) {
      throw new Error(uploadRes.msg || '上传失败')
    }
    const objectKey = uploadRes.data
    // 获取访问 URL
    // const fd = new FormData()
    // fd.append('objectKey', objectKey)
    const urlRes = await getFileUrlByObjectKeyLongZst(objectKey)
    if (urlRes.code !== 0 || !urlRes.data) {
      throw new Error('获取文件URL失败')
    }
    const uploadedImage = {
      objectKey,
      fileName: file.name,
      url: urlRes.data,
      previewUrl: urlRes.data,
      isUploaded: true
    }
    if (target === 'source') sourceImage.value = uploadedImage
    else targetImage.value = uploadedImage
    message.success('图片上传成功')
  } catch (error: any) {
    message.error(error.message || '上传失败')
    if (target === 'source') sourceImage.value = null
    else targetImage.value = null
  } finally {
    uploadingState.value = null
  }
}

const clearImage = (target: 'source' | 'target') => {
  if (target === 'source') sourceImage.value = null
  else targetImage.value = null
}

const pickerCustomRow = (record: any) => {
  return {
    onClick: () => handlePickerRowClick(record)
  }
}

const handlePickerRowClick = (record) => {
  if (!isImageRow(record)) {
    message.warning('仅支持选择图片文件')
    return
  }
  if (createStep.value === 0) {
    // 选择原图
    sourceImage.value = record
    // 如果已选对比图且与当前选中的原图相同，则清空对比图
    if (targetImage.value && targetImage.value.file_id === record.file_id) {
      targetImage.value = null
    }
  } else {
    // 选择对比图
    if (sourceImage.value && sourceImage.value.file_id === record.file_id) {
      message.warning('对比图不能与原图相同，请重新选择')
      return
    }
    targetImage.value = record
  }
}

const submitNewCreateTask = async () => {
  try {
    await createTaskFormRef.value.validate()
  } catch {
    return
  }
  if (!sourceImage.value || !targetImage.value) {
    message.warning('请选择原图与对比图')
    return
  }
  if (uploadingState.value) {
    message.warning('图片正在上传中，请稍后')
    return
  }
  const sourceKey = sourceImage.value.objectKey
  const targetKey = targetImage.value.objectKey
  if (!sourceKey || !targetKey) {
    message.warning('图片信息不完整，请重新选择或上传')
    return
  }

  createSubmitting.value = true
  const requestData: any = {
    name: createTaskForm.name,
    sourceObjectKey: sourceKey,
    targetObjectKey: targetKey,
    algorithmCode: 'change_default'
  }
  // 添加非空高级参数
  const advancedKeys = [
    'alignmentModel', 'illuminanceMode', 'orbFeatures', 'matchRatio',
    'ransacReprojThreshold', 'minContourAreaRatio', 'mergeBoxIou', 'maxBoxes',
    'minInliers', 'minAbsdiffAfterOtsu'
  ]
  advancedKeys.forEach(key => {
    const val = createTaskForm[key]
    if (val !== null && val !== undefined) {
      requestData[key] = val
    }
  })
  try {
    const res = await getCreateMontior(requestData)
    if (res.code === 0) {
      message.success('任务已创建')
      monitorCreateVisible.value = false
      resetCreateTaskDialog()
      fetchMonitorData() // 刷新检测列表
    } else {
      message.error(res.msg || '创建失败')
    }
  } catch (error) {
    message.error('创建失败')
  } finally {
    createSubmitting.value = false
  }
}

const resetCreateTaskDialog = () => {
  createStep.value = 0
  sourceImage.value = null
  targetImage.value = null
  createTaskForm.name = ''
  createTaskForm.alignmentModel = 'HOMOGRAPHY'
  createTaskForm.illuminanceMode = 'STANDARD'
  createTaskForm.orbFeatures = 8000
  createTaskForm.matchRatio = 0.75
  createTaskForm.ransacReprojThreshold = 8
  createTaskForm.minContourAreaRatio = 0.00015
  createTaskForm.mergeBoxIou = 0.35
  createTaskForm.maxBoxes = 200
  createTaskForm.minInliers = 40
  createTaskForm.minAbsdiffAfterOtsu = 10
  pickerQuery.fileName = ''
  pickerQuery.dataTime = []
  pickerPagination.current = 1
  fetchSystemMediaList()
  if (createTaskFormRef.value) {
    createTaskFormRef.value.clearValidate()
  }
}

const retryMonitorVisible = ref(false)
const retryMonitorLoading = ref(false)
const retryMonitorFormRef = ref(null)

const alignmentModelTooltip = 'HOMOGRAPHY（透视变换）：适用于拍摄角度差异大、有透视形变的场景；AFFINE（仿射变换）：适用于视角平行移动，仅有旋转/缩放/平移的场景'
const illuminanceModeTooltip = 'NORMALIZE_MEAN_STD（归一化）：标准化处理，适用于光照变化大的场景；STANDARD（标准）：不做光照处理；GRADIENT_MAGNITUDE（梯度）：提取边缘特征，适用于纹理丰富的场景'

const MonitorTaskData = ref({
  id: null, // 任务 ID
  sourceImageUrl: '',
  targetImageUrl: '',
  sourceFileId: null,
  targetFileId: null
})

const retryMonitorFormData = reactive({
  alignmentModel: 'HOMOGRAPHY',
  illuminanceMode: 'NORMALIZE_MEAN_STD',
  orbFeatures: 8000,
  matchRatio: 0.75,
  ransacReprojThreshold: 3.0,
  minContourAreaRatio: 0.0001,
  mergeBoxIou: 0.5,
  maxBoxes: 100,
  minInliers: 50,
  minAbsdiffAfterOtsu: 20
})

const resetMonitor = async (record) => {
  MonitorTaskData.value = record
  retryMonitorVisible.value = true
  try {
    const res = await montiorTaskData(record.id)
    if (res.code === 0) {
      retryMonitorFormData.alignmentModel = res.data.alignmentModel || retryMonitorFormData.alignmentModel
      retryMonitorFormData.illuminanceMode = res.data.illuminanceMode || retryMonitorFormData.illuminanceMode
      retryMonitorFormData.orbFeatures = res.data.orbFeatures || retryMonitorFormData.orbFeatures
      retryMonitorFormData.matchRatio = res.data.matchRatio || retryMonitorFormData.matchRatio
      retryMonitorFormData.ransacReprojThreshold = res.data.ransacReprojThreshold || retryMonitorFormData.ransacReprojThreshold
      retryMonitorFormData.minContourAreaRatio = res.data.minContourAreaRatio || retryMonitorFormData.minContourAreaRatio
      retryMonitorFormData.mergeBoxIou = res.data.mergeBoxIou || retryMonitorFormData.mergeBoxIou
      retryMonitorFormData.maxBoxes = res.data.maxBoxes || retryMonitorFormData.maxBoxes
      retryMonitorFormData.minInliers = res.data.minInliers || retryMonitorFormData.minInliers
      retryMonitorFormData.minAbsdiffAfterOtsu = res.data.minAbsdiffAfterOtsu || retryMonitorFormData.minAbsdiffAfterOtsu
    } else {
      message.error(res.message || '获取任务数据失败')
    }
  } catch (error) {
    message.error('获取任务数据失败')
  }
}

const doRetryWithParams = async () => {
  retryMonitorLoading.value = true
  try {
    const params = {
      taskId: MonitorTaskData.value.id,
      ...retryMonitorFormData
    }
    const res = await resetParameterMontiorTask(params)
    if (res.code === 0) {
      message.success('重试成功')
      retryMonitorVisible.value = false
    } else {
      message.error(res.message || '重试失败')
    }
  } catch (error) {
    message.error('重试请求失败')
  } finally {
    retryMonitorLoading.value = false
  }
}

const retryMonitorSubmit = async () => {
  try {
    await retryMonitorFormRef.value?.validate()
  } catch (error) {
    return
  }

  if (!MonitorTaskData.value) {
    message.error('当前任务信息丢失')
    return
  }

  retryMonitorLoading.value = true

  const checkData = {
    sourceObjectKey: MonitorTaskData.value.sourceFileObjectKey,
    targetObjectKey: MonitorTaskData.value.targetFileObjectKey,
    ...retryMonitorFormData
  }

  try {
    const res = await checkSameMontiorTask(checkData)
    if (res.code === 0 && res.data && res.data.exists) {
      Modal.confirm({
        title: '参数重复提示',
        content: `发现相同参数的历史记录（检测到 ${res.data.changeAreaCount || 0} 处变化），是否直接取消比对？`,
        okText: '取消比对',
        cancelText: '重新比对',
        onOk: () => {
          retryMonitorVisible.value = false
          retryMonitorLoading.value = false
          message.success('已加载历史比对结果')
        },
        onCancel: () => {
          doRetryWithParams()
        }
      })
    } else {
      await doRetryWithParams()
    }
  } catch (error) {
    await doRetryWithParams()
  } finally {
    retryMonitorLoading.value = false
  }
}

const retryMonitorCancel = () => {
  retryMonitorVisible.value = false
  retryMonitorFormRef.value?.resetFields()
}

const historyDialogVisible = ref(false)
const historyLoading = ref(false)
const historyList = ref([])

const historyMonitor = async (record) => {
  historyDialogVisible.value = true
  historyLoading.value = true
  const res = await historyMontiorTask(record.id)
  if (res.code === 0) {
    historyList.value = res.data
    historyLoading.value = false
  }
}

const filesResultsVisible = ref(false)

const resultsFormData = reactive({
  allMessage: '',
  analysisResult: '',
  largeModelAnalysisResult: '',
  regulationDetails: ''
})

const aiResultVisible = ref(false)
const aiTitle = ref('')
const submitAiLoading = ref(false)
const aiResultLoading = ref(false)
const categoryList = ref([])
const aiResultType = ref('')
const currentAiResultRow = ref(null)

const appList = ref([])
const aiResultForm = reactive({
  fileId: '',
  typeId: '',
  typeName: '',
  analysisResult: '',
  type: ''
})

const iconUrlCache = reactive({})
const fetchingIconUrls = new Set()

const themeColorMap = {
  green: '#52c41a',
  purple: '#722ed1',
  orange: '#fa8c16',
  blue: '#1890ff',
  pink: '#eb2f96',
  violet: '#9254de',
}

const getCategoryList = async () => {
  try {
    const res = await listAllSpecialAppCategory(1)
    if (res?.code === 0) {
      const list = Array.isArray(res.data) ? res.data : []
      categoryList.value = buildCategoryFullPath(list).sort(compareCategory)
    } else {
      categoryList.value = []
    }
  } catch (error) {
    console.error('获取分类列表失败', error)
    categoryList.value = []
  }
}

const getIconUrl = (objectKey) => {
  if (!objectKey) return ''
  if (/^https?:\/\//i.test(objectKey)) return objectKey
  return iconUrlCache[objectKey] || ''
}

const loadIconUrl = (objectKey) => {
  if (!objectKey) return
  if (/^https?:\/\//i.test(objectKey)) {
    iconUrlCache[objectKey] = objectKey
    return
  }
  if (iconUrlCache[objectKey] || fetchingIconUrls.has(objectKey)) return
  fetchingIconUrls.add(objectKey)
  getFileUrlByObjectKeyLong(objectKey)
    .then((res) => {
      if (res?.code === 0 && res.data) {
        iconUrlCache[objectKey] = res.data.toString()
      }
    })
    .catch(() => {
      iconUrlCache[objectKey] = objectKey
    })
    .finally(() => {
      fetchingIconUrls.delete(objectKey)
    })
}

const getCategoryTimestamp = (node) => {
  if (!node) return 0
  const value = node.createTime || node.createTimeStr || node.createTimeMillis
  if (!value) return 0
  if (typeof value === 'number') return value
  const time = new Date(value).getTime()
  return isNaN(time) ? 0 : time
}

const compareCategory = (a, b) => {
  return getCategoryTimestamp(b) - getCategoryTimestamp(a)
}

const buildCategoryFullPath = (list) => {
  if (!Array.isArray(list)) return []
  const map = {}
  list.forEach((item) => {
    if (item.id) map[item.id] = item
  })
  const getPathNames = (item) => {
    const names = []
    let current = item
    const safeGuard = new Set()
    while (current && current.id && !safeGuard.has(current.id)) {
      safeGuard.add(current.id)
      names.unshift(current.name)
      if (!current.parentId) break
      current = map[current.parentId]
    }
    return names.join(' / ')
  }
  return list.map((item) => ({
    ...item,
    fullPathName: getPathNames(item),
  }))
}

const getAppList = async () => {
  aiResultLoading.value = true
  try {
    const response = await getAllSpecialData()
    if (response?.code === 0) {
      appList.value = Array.isArray(response.data) ? response.data : []
      appList.value.forEach((app) => {
        if (app.iconPath) loadIconUrl(app.iconPath)
      })
    } else {
      appList.value = []
      if (response?.msg) message.error(response.msg)
    }
  } catch (error) {
    console.error('查询专题应用列表失败:', error)
    message.error(error.message || '查询失败')
    appList.value = []
  } finally {
    aiResultLoading.value = false
  }
}

const getAppsByCategory = (category) => {
  return appList.value.filter((app) => app.category === category)
}

const isSelected = (id) => {
  return aiResultForm.typeId === id
}

const handleCardClick = (app) => {
  aiResultForm.fileId = currentAiResultRow.value.file_id
  aiResultForm.typeId = app.id
  aiResultForm.typeName = app.appName
  aiResultForm.type = app.type
  if (aiResultType.value === 'regulation') {
    aiResultForm.analysisResult = currentAiResultRow.value.large_model_analysis_result || ''
  }
}

const handleAIRegulation = () => {
  getAcquisitionRegulations({
    type: aiResultForm.type,
    portion: aiResultForm.typeName,
    hiddenDanger: aiResultForm.analysisResult,
  }).then((res) => {
    const content =
      res.data && res.data.length > 0
        ? res.data.map((el) => el.specifications.join('\n')).join('\n')
        : ''
    Modal.confirm({
      title: '确认提交',
      content: `识别条例: ${content} ,是否确认提交？`,
      zIndex: 2100,
      width: '500px',
      onOk: () => {
        const body = {
          fileId: aiResultForm.fileId,
          largeModelAnalysisResult: aiResultForm.analysisResult,
          regulationDetails: content,
        }
        updateFileAnalysisResult(body)
          .then(() => {
            // 更新当前选中行的数据
            if (currentAiResultRow.value) {
              currentAiResultRow.value.large_model_analysis_result = aiResultForm.analysisResult
              currentAiResultRow.value.regulation_details = content
            }
            // 如果分析结果对话框已打开且是同一个文件，同步更新 resultsFormData
            if (filesResultsVisible.value && resultsFormData.allMessage?.file_id === body.fileId) {
              resultsFormData.largeModelAnalysisResult = aiResultForm.analysisResult
              resultsFormData.regulationDetails = content
            }
            // 刷新列表
            if (menuSelectedKey.value === 'folder') {
              if (currentFolderId.value) {
                fetchFiles(currentFolderId.value) // 媒体库刷新当前文件夹
              }
            } else {
              getFiles(true) // 媒体文件刷新列表
            }
            handleCloseAiResult()
            submitAiLoading.value = false
          })
          .catch(() => {
            submitAiLoading.value = false
          })
      },
      onCancel: () => {
        submitAiLoading.value = false
      },
    })
  })
}

const toggleSelection = async () => {
  if (!aiResultForm.typeId) {
    message.warning('请选择一个专题应用')
    return
  }
  submitAiLoading.value = true
  try {
    if (aiResultType.value === 'regulation') {
      const toStr = (val: any): string => {
        if (val === null || val === undefined) return ''
        if (Array.isArray(val)) return val.join('\n')
        return String(val)
      }
      const hiddenDangerValue = editingResultsForm.largeModelAnalysisResult || aiResultForm.analysisResult
      // 条例识别（所有菜单通用）
      const res = await getAcquisitionRegulations({
        type: aiResultForm.type,
        portion: aiResultForm.typeName,
        hiddenDanger: toStr(hiddenDangerValue),
      })
      const content = res.data && res.data.length > 0 ? res.data.map(el => `${el.name}：${el.specifications.join('\n')}`).join('\n\n') : ''
      if (currentAiTargetField === 'regulationDetails') {
        editingResultsForm.regulationDetails = content
      } else if (currentAiTargetField === 'largeModelAnalysisResult') {
        editingResultsForm.largeModelAnalysisResult = content
      }
    } else {
      // AI识别 / 模型识别
      let content = ''
      if (mediaActiveKey.value === 'third_media') {
        const res = await getModelOutFileAnalysisResult(aiResultForm.fileId, aiResultForm.typeName, aiResultForm.type)
        content = res.data?.largeModelAnalysisResult || res.data?.hiddenDanger || ''
      } else {
        // 原有媒体文件：调用 getAlarmModelAnalysis
        const formData = new FormData()
        formData.append('portion', aiResultForm.typeName)
        formData.append('type', aiResultForm.type)
        formData.append('fileId', aiResultForm.fileId)
        const res = await getAlarmModelAnalysis(formData)
        content = res.data?.hiddenDanger && res.data.hiddenDanger.length > 0
          ? res.data.hiddenDanger.join('\n')
          : ''
      }
      if (currentAiTargetField === 'largeModelAnalysisResult') {
        editingResultsForm.largeModelAnalysisResult = content
      } else if (currentAiTargetField === 'regulationDetails') {
        editingResultsForm.regulationDetails = content
      }
    }
    handleCloseAiResult()
  } catch (error) {
    message.error('识别失败')
  } finally {
    submitAiLoading.value = false
  }
}

let currentAiTargetField: string = ''

const handleClearResult = () => {
  aiResultType.value = ''
  aiResultForm.fileId = ''
  aiResultForm.typeId = ''
  aiResultForm.typeName = ''
  aiResultForm.type = ''
  aiResultForm.analysisResult = ''
}

const handleCloseAiResult = () => {
  aiResultVisible.value = false
  handleClearResult()
}

const openAiResultModal = (row, type) => {
  handleClearResult()
  currentAiResultRow.value = row
  aiResultType.value = type
  aiTitle.value = type === 'regulation' ? '条例识别' : 'AI识别'
  aiResultVisible.value = true
  getCategoryList()
  getAppList()
}

const getCardBackground = (colorTheme) => {
  if (!colorTheme) {
    return 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)'
  }
  let color = themeColorMap[colorTheme] || colorTheme
  if (color.startsWith('rgba')) {
    const rgbaMatch = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/)
    if (rgbaMatch) {
      const r = parseInt(rgbaMatch[1])
      const g = parseInt(rgbaMatch[2])
      const b = parseInt(rgbaMatch[3])
      color = `rgb(${r}, ${g}, ${b})`
    }
  }
  if (color.startsWith('#') || color.startsWith('rgb')) {
    let r, g, b
    if (color.startsWith('#')) {
      const hex = color.replace('#', '')
      r = parseInt(hex.substring(0, 2), 16)
      g = parseInt(hex.substring(2, 4), 16)
      b = parseInt(hex.substring(4, 6), 16)
    } else {
      const rgbMatch = color.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/)
      if (rgbMatch) {
        r = parseInt(rgbMatch[1])
        g = parseInt(rgbMatch[2])
        b = parseInt(rgbMatch[3])
      } else {
        return `linear-gradient(135deg, ${color} 0%, ${color} 100%)`
      }
    }
    const darkerR = Math.max(0, Math.floor(r * 0.7))
    const darkerG = Math.max(0, Math.floor(g * 0.7))
    const darkerB = Math.max(0, Math.floor(b * 0.7))
    return `linear-gradient(135deg, ${color} 0%, rgb(${darkerR}, ${darkerG}, ${darkerB}) 100%)`
  }
  return color
}

// ========== 分析结果编辑相关 ==========
const saveResultsLoading = ref(false)
const currentEditingFileRecord = ref<any>(null)
const algorithmAnalysisLoading = ref(false)
const algoFileId = ref('')

const editingResultsForm = reactive({
  analysisResult: '',
  largeModelAnalysisResult: '',
  regulationDetails: '',
})

const currentOptionData = ref('')

const viewAnalysisFilesResults = async (record) => {
  filesResultsVisible.value = true
  currentEditingFileRecord.value = record
  editingResultsForm.analysisResult = record.analysis_result || record.analysisResult || ''
  editingResultsForm.largeModelAnalysisResult = record.large_model_analysis_result || record.largeModelAnalysisResult || ''
  editingResultsForm.regulationDetails = record.regulation_details || record.regulationDetails || ''
  // currentOptionData.value = record.portion
  algoFileId.value = record.fileId
  console.log('record.fileId', record.fileId)
  // 统一将文件ID存储到 file_id 字段（方便保存时使用）
  if (mediaActiveKey.value === 'third_media') {
    currentEditingFileRecord.value.file_id = record.fileId // 第三方媒体使用 id
  } else {
    currentEditingFileRecord.value.file_id = record.file_id
  }
}

const currentEditingFileRecordForAlgo = ref<any>(null)

const openAiAnalysisForField = async (targetField: 'analysisResult' | 'largeModelAnalysisResult' | 'regulationDetails') => {
  if (!currentEditingFileRecord.value) {
    message.error('文件信息丢失')
    return
  }

  // 对于 analysisResult（算法识别）分支，检查是否已有分析结果
  if (targetField === 'analysisResult') {
    const hasAnalysisResult = (() => {
      const result = currentEditingFileRecord.value.analysis_result
      if (!result) return false
      if (typeof result === 'string') {
        return result !== '' && result !== '{}'
      }
      if (Array.isArray(result)) {
        return result.length > 0
      }
      if (typeof result === 'object') {
        return Object.keys(result).length > 0
      }
      return false
    })()

    if (hasAnalysisResult) {
      // 已有分析结果，直接填充到表单
      let formattedResult = ''
      const rawResult = currentEditingFileRecord.value.analysis_result
      if (typeof rawResult === 'string') {
        try {
          const parsed = JSON.parse(rawResult)
          if (Array.isArray(parsed)) {
            formattedResult = parsed.map(item => `${item.name || item.type}: ${item.count || 0}`).join('\n')
          } else {
            formattedResult = rawResult
          }
        } catch {
          formattedResult = rawResult
        }
      } else if (Array.isArray(rawResult)) {
        formattedResult = rawResult.map(item => `${item.name || item.type}: ${item.count || 0}`).join('\n')
      } else {
        formattedResult = JSON.stringify(rawResult, null, 2)
      }
      editingResultsForm.analysisResult = formattedResult
      return
    }

    // 无分析结果，弹出算法选择弹窗
    isFromPreview.value = false // 标记不是来自预览开关
    submitAlgoAnalysisFileId.value = currentEditingFileRecord.value.file_id
    // 重置表单默认值
    formAlgoAnalysisData.value = {
      algorithmId: null,
      confidence: 0.5,
      enableLargeModel: 0
    }
    algoMediaAnalysisVisible.value = true
    // 保存当前正在编辑的文件记录，以便分析成功后更新
    currentEditingFileRecordForAlgo.value = currentEditingFileRecord.value
    return
  }

  // 其他字段（大模型识别结果、识别条例）使用专题应用选择弹窗（保持不变）
  currentAiTargetField = targetField
  handleClearResult()
  currentAiResultRow.value = currentEditingFileRecord.value
  aiResultType.value = targetField === 'largeModelAnalysisResult' ? 'ai' : 'regulation'
  aiTitle.value = targetField === 'largeModelAnalysisResult' ? 'AI识别' : '条例识别'
  aiResultVisible.value = true
  await getCategoryList()
  await getAppList()
}

const handleSaveResults = async () => {
  if (!currentEditingFileRecord.value) {
    message.error('文件信息丢失')
    return
  }
  saveResultsLoading.value = true
  try {
    const toStr = (val: any): string => {
      if (val === null || val === undefined) return ''
      if (Array.isArray(val)) return val.join('\n')
      return String(val)
    }
    const params = {
      analysisResult: editingResultsForm.analysisResult,
      largeModelAnalysisResult: toStr(editingResultsForm.largeModelAnalysisResult),
      regulationDetails: editingResultsForm.regulationDetails,
    }
    let res
    if (mediaActiveKey.value === 'third_media') {
      // 第三方媒体专用保存接口，参数使用 fileId
      res = await updateOutFileAnalysisResult({
        fileId: currentEditingFileRecord.value.file_id,
        ...params
      })
    } else {
      // 原有媒体文件保存接口，参数使用 fileId
      res = await updateFileAnalysisResult({
        fileId: currentEditingFileRecord.value.file_id,
        ...params
      })
    }
    if (res.code === 0) {
      // 同步更新原始记录
      if (mediaActiveKey.value === 'third_media') {
        // 第三方媒体记录结构不同，更新其字段
        currentEditingFileRecord.value.analysis_result = editingResultsForm.analysisResult
        currentEditingFileRecord.value.large_model_analysis_result = editingResultsForm.largeModelAnalysisResult
        currentEditingFileRecord.value.regulation_details = editingResultsForm.regulationDetails
      } else {
        currentEditingFileRecord.value.analysis_result = editingResultsForm.analysisResult
        currentEditingFileRecord.value.large_model_analysis_result = editingResultsForm.largeModelAnalysisResult
        currentEditingFileRecord.value.regulation_details = editingResultsForm.regulationDetails
      }
      // 刷新列表
      if (menuSelectedKey.value === 'folder') {
        if (currentFolderId.value) fetchFiles(currentFolderId.value)
      } else if (menuSelectedKey.value === 'media') {
        getFiles(true)
      } else if (mediaActiveKey.value === 'third_media') {
        fetchThirdMediaFiles(currentThirdMediaFolderId.value)
      }
      filesResultsVisible.value = false
      resetFilesResults()
    } else {
      message.error(res.message || '更新失败')
    }
  } catch (error) {
    message.error('保存失败，请重试')
  } finally {
    saveResultsLoading.value = false
  }
}

const resetFilesResults = () => {
  filesResultsVisible.value = false
  editingResultsForm.analysisResult = ''
  editingResultsForm.largeModelAnalysisResult = ''
  editingResultsForm.regulationDetails = ''
  currentEditingFileRecord.value = null
  currentAiTargetField = ''
  // 如果专题应用选择弹窗还开着，也一并关闭
  if (aiResultVisible.value) handleCloseAiResult()
}

// 上传文件
const addThirdMediaVisible = ref(false)
const addThirdPercent = ref(0)
const formAddRef = ref()
const uploadRef = ref()
const addLoading = ref(false)
const formAddTreeData = ref({
  folderName: '',
  file: null as File | null,
  remark: ''
})

const folderType = ref<'custom' | 'existing'>('custom')
const existingFolderList = ref<any[]>([])
const existingFolderPagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0
})
const selectedFolderId = ref<string | null>(null)
const existingFolderLoading = ref(false)

const formAddRules = reactive({
  folderName: [{ required: true, trigger: 'blur', message: '请输入文件夹名称' }],
  file: [{ required: true, trigger: 'change', message: '请选择文件' }]
})

const hasMoreFolders = computed(() => existingFolderList.value.length < existingFolderPagination.total)

const loadMoreFolders = async () => {
  if (existingFolderLoading.value || !hasMoreFolders.value) return
  // 注意：当前页码已在上次加载后自增，所以直接请求即可
  await fetchExistingFolders(true)
}

const fetchExistingFolders = async (isLoadMore = false) => {
  if (existingFolderLoading.value) return
  if (!isLoadMore) {
    existingFolderPagination.current = 1
    existingFolderList.value = []
  }
  existingFolderLoading.value = true
  try {
    const queryParam = {
      page: existingFolderPagination.current,
      pageSize: existingFolderPagination.pageSize,
      param: { folderName: '' }
    }
    const res = await getOutFolderPage(queryParam)
    if (res && res.code === 0) {
      const newList = res.data.list || []
      if (isLoadMore) {
        existingFolderList.value = [...existingFolderList.value, ...newList]
      } else {
        existingFolderList.value = newList
      }
      existingFolderPagination.total = res.data.pagination.total || 0
      // 加载更多后页码+1，供下次加载使用
      if (newList.length > 0) {
        existingFolderPagination.current += 1
      }
    }
  } catch (error) {
    console.error('获取已有文件夹失败', error)
  } finally {
    existingFolderLoading.value = false
  }
}

const loadMoreExistingFolders = async () => {
  if (existingFolderLoading.value) return
  // 检查是否还有更多数据
  const currentCount = existingFolderList.value.length
  if (currentCount >= existingFolderPagination.total) return

  const nextPage = Math.floor(currentCount / existingFolderPagination.pageSize) + 1
  // 理论上不会超过 totalPage，但做安全判断
  if (nextPage > Math.ceil(existingFolderPagination.total / existingFolderPagination.pageSize)) return

  existingFolderLoading.value = true
  try {
    const queryParam = {
      page: nextPage,
      pageSize: existingFolderPagination.pageSize,
      param: { folderName: '' }
    }
    const res = await getOutFolderPage(queryParam)
    if (res && res.code === 0) {
      const newList = res.data.list || []
      existingFolderList.value = [...existingFolderList.value, ...newList]
      existingFolderPagination.total = res.data.pagination.total || 0
    }
  } catch (error) {
    console.error('加载更多失败', error)
  } finally {
    existingFolderLoading.value = false
  }
}

let scrollTimer: ReturnType<typeof setTimeout> | null = null
const handleSelectPopupScroll = (e: Event) => {
  if (scrollTimer) clearTimeout(scrollTimer)
  scrollTimer = setTimeout(() => {
    const target = e.target as HTMLElement
    if (target.scrollTop + target.clientHeight >= target.scrollHeight - 10) {
      loadMoreExistingFolders()
    }
  }, 100)
}

// 下拉框展开时加载数据
const handleDropdownVisibleChange = (open: boolean) => {
  if (open && existingFolderList.value.length === 0) {
    fetchExistingFolders()
  }
}

const openAddThirdMedia = () => {
  addThirdMediaVisible.value = true
  formAddTreeData.value.folderName = ''
  formAddTreeData.value.remark = ''
  formAddTreeData.value.file = null
  folderType.value = 'custom'
  selectedFolderId.value = null
  existingFolderList.value = []
  existingFolderPagination.current = 1
  existingFolderPagination.total = 0
  if (uploadRef.value) {
    uploadRef.value.fileList = []
  }
}

const handleThirdMediaUpload: UploadProps['beforeUpload'] = () => {
  return false
}
const handleThirdMediaChange: UploadProps['onChange'] = info => {
  formAddTreeData.value.file = info.file
  console.log(info.file, 'handleChange')
}

const handleThirdMediaSubmit = () => {
  // 表单验证（动态规则可自行扩展，这里手动校验）
  if (folderType.value === 'custom') {
    if (!formAddTreeData.value.folderName) {
      message.warning('请输入文件夹名称')
      return
    }
  } else {
    if (!selectedFolderId.value) {
      message.warning('请选择已有文件夹')
      return
    }
  }
  if (!formAddTreeData.value.file) {
    message.warning('请选择压缩包文件')
    return
  }

  addLoading.value = true
  addThirdPercent.value = 0
  if (progressTimer) clearInterval(progressTimer)
  progressTimer = setInterval(() => {
    if (addThirdPercent.value < 90) addThirdPercent.value += 10
  }, 200)

  const formData = new FormData()
  formData.append('workspaceId', workspaceId)
  formData.append('remark', formAddTreeData.value.remark)
  if (folderType.value === 'custom') {
    formData.append('folderName', formAddTreeData.value.folderName)
  } else {
    formData.append('folderId', selectedFolderId.value)
  }
  formData.append('file', formAddTreeData.value.file)

  updateImageZip(formData)
    .then(res => {
      if (res.code === 0) {
        if (progressTimer) clearInterval(progressTimer)
        addThirdPercent.value = 100
        setTimeout(() => {
          addThirdMediaVisible.value = false
          fetchThirdMediaFolders() // 刷新列表
          message.success('上传并解压成功')
        }, 500)
      } else {
        throw new Error(res.msg || '上传失败')
      }
    })
    .catch(err => {
      console.error(err)
      message.error(err.message || '上传失败，请重试')
      handleThirdMediaCancel()
    })
    .finally(() => {
      addLoading.value = false
      if (progressTimer) clearInterval(progressTimer)
      setTimeout(() => { addThirdPercent.value = 0 }, 1000)
    })
}

const handleThirdMediaCancel = () => {
  formAddRef.value?.resetFields()
  if (uploadRef.value && uploadRef.value.fileList.length > 0) {
    uploadRef.value.fileList = []
    if (addLoading.value) {
      uploadRef.value?.upload.abort()
      addLoading.value = false
    }
  }
  addThirdMediaVisible.value = false
  addThirdPercent.value = 0
  folderType.value = 'custom'
  selectedFolderId.value = null
  existingFolderList.value = []
  if (progressTimer) {
    clearInterval(progressTimer)
    progressTimer = null
  }
}

const algoMediaAnalysisVisible = ref(false)
const submitAlgoAnalysisLoading = ref(false)
const submitAlgoAnalysisFileId = ref('')
const isFromPreview = ref(false)

const formAlgoAnalysisData = ref({
  algorithmId: null,
  confidence: 0.5,
  enableLargeModel: 0
})

const algorithmDataList = ref<any[]>([])
async function loadAlgorithmList () {
  const queryParam = {}
  const res = await getAllAlgList(queryParam)
  if (res && res.code === 200) {
    algorithmDataList.value = res.data || []
  }
}

const handleCloseAlgoMediaAnalysis = () => {
  algoMediaAnalysisVisible.value = false
  if (isFromPreview.value) {
    analysisChecked.value = false
    isFromPreview.value = false
  } else if (currentEditingFileRecordForAlgo.value) {
    // 非预览来源但关闭弹窗，清空待更新记录
    currentEditingFileRecordForAlgo.value = null
  }
  submitAlgoAnalysisLoading.value = false
  formAlgoAnalysisData.value.algorithmId = null
  formAlgoAnalysisData.value.confidence = 0.5
  formAlgoAnalysisData.value.enableLargeModel = 0
}

const currentPreviewMediaSource = ref<'system' | 'thirdParty'>('system')

const toggleAlgoAnalysis = async () => {
  submitAlgoAnalysisLoading.value = true
  try {
    let res
    const isThirdParty = mediaActiveKey.value === 'third_media'

    if (isThirdParty) {
      // 第三方媒体使用专用分析接口
      res = await getAiOutFileAnalysisResult(
        submitAlgoAnalysisFileId.value,
        formAlgoAnalysisData.value.confidence,
        formAlgoAnalysisData.value.algorithmId
      )
    } else {
      // 普通媒体分析接口
      res = await getAlgoAnalysisResult(
        submitAlgoAnalysisFileId.value,
        formAlgoAnalysisData.value.confidence,
        formAlgoAnalysisData.value.algorithmId,
        formAlgoAnalysisData.value.enableLargeModel
      )
    }

    if (res.code === 0) {
      if (res.data && res.data.analysisUrl) {
        // 统一格式化分析结果
        const formattedResults = formatAnalysisResults(res.data.analysisResult)

        // 如果是预览开关触发的分析
        if (isFromPreview.value && currentMediaFileInfo.value) {
          // 更新当前预览的媒体文件信息
          if (isThirdParty) {
            currentMediaFileInfo.value.analysisUrl = res.data.analysisUrl
            currentMediaFileInfo.value.analysisResult = res.data.analysisResult
          } else {
            currentMediaFileInfo.value.analysis_url = res.data.analysisUrl
            currentMediaFileInfo.value.analysis_result = res.data.analysisResult
          }
          // 更新预览浮窗显示
          analysisUrl.value = res.data.analysisUrl
          analysisResults.value = formattedResults
          analysisChecked.value = true
          // 图片加载完成后关闭 loading（图片 onload 会处理）
          await loadAnalysisImage() // 重新加载确保图片正确显示
        }

        // 如果是算法识别按钮（文件结果弹窗中的“算法识别”）
        if (!isFromPreview.value && currentEditingFileRecordForAlgo.value) {
          const targetRecord = currentEditingFileRecordForAlgo.value
          if (isThirdParty) {
            targetRecord.analysisUrl = res.data.analysisUrl
            targetRecord.analysisResult = res.data.analysisResult
          } else {
            targetRecord.analysis_url = res.data.analysisUrl
            targetRecord.analysis_result = res.data.analysisResult
          }
          // 将格式化的结果展示在文本域中（纯文本展示，方便编辑）
          let displayText = ''
          if (typeof res.data.analysisResult === 'string') {
            displayText = res.data.analysisResult
          } else if (Array.isArray(res.data.analysisResult)) {
            displayText = res.data.analysisResult.map(item => `${item.name || item.type}: ${item.count || 0}`).join('\n')
          } else if (typeof res.data.analysisResult === 'object') {
            displayText = Object.entries(res.data.analysisResult).map(([k, v]) => `${k}: ${v}`).join('\n')
          } else {
            displayText = String(res.data.analysisResult)
          }
          editingResultsForm.analysisResult = displayText
        }
      }

      // 关闭算法选择弹窗
      if (isFromPreview.value) {
        algoMediaAnalysisVisible.value = false
      } else {
        algoMediaAnalysisVisible.value = false // 统一关闭
      }
    } else {
      message.error(res.message || '分析失败')
      if (isFromPreview.value) {
        analysisChecked.value = false
      }
    }
  } catch (error) {
    console.error('分析失败:', error)
    message.error('分析失败')
    if (isFromPreview.value) {
      analysisChecked.value = false
    }
  } finally {
    submitAlgoAnalysisLoading.value = false
    // 重置临时状态
    isFromPreview.value = false
    currentEditingFileRecordForAlgo.value = null
  }
}

onMounted(() => {
  getFiles()
  // getMediaTypeList()
  reset(1)
  reset(2)
  fetchFolders()
  getHistoryPlayFiles()
  fetchTreeNodeData()
  fetchFlyRecordData()
  fetchCompositeData()
  fetchflightTypeSelect()
  handleIdentifyReset()
  fetchMonitorData()
  handleThirdMediaReset()
  loadAlgorithmList()
})

onUnmounted(() => {
  if (progressTimer) {
    clearInterval(progressTimer)
    progressTimer = null
  }
  if (modelProgressTimer) {
    clearInterval(modelProgressTimer)
    modelProgressTimer = null
  }
})
</script>

<style lang="scss" scoped>
.media-panel-wrapper {
  width: 100%;
  padding: 16px;

  .media-table {
    background: #fff;
    margin-top: 10px;
  }

  .action-area {
    color: $primary;
    cursor: pointer;
  }
}

.folder-create {
  display: flex;
  justify-content: space-between;
}

.img-thumbnail {
  width: 165px;
  height: 100px;
  cursor: pointer;
}

.header {
  width: 100%;
  height: 60px;
  background: #fff;
  padding: 16px;
  font-size: 20px;
  font-weight: bold;
  text-align: start;
  color: #000;
}

.tab-header {
  width: 100%;
  background: #fff;
  padding: 16px;
  font-size: 20px;
  text-align: start;
  color: #000;
}

.flex-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* .a-input,
.a-select,
.a-range-picker {
  width: 200px;
} */

/* .ant-select-selector,
.ant-select,
.ant-select-single,
.ant-select-show-arrow {
  width: 100px !important;
} */

.media-item-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.media-item-filename {
  margin-bottom: 5px;
  text-align: center;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.media-item-video {
  max-width: 100px;
  max-height: 60px;
}

.media-item-video-preview {
  //color: aqua;
  cursor: pointer;
}

.media-item-image {
  max-width: 100px;
  max-height: 60px;
  cursor: pointer;
}

/* export modal layout */
.export-modal-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.export-field {
  display: flex;
  align-items: center;
  gap: 12px;
}

.export-label {
  width: 72px;
  color: #333;
  text-align: right;
}

.export-picker {
  width: 360px;
}

.export-select {
  width: 360px !important;
}

.export-select .ant-select-selector {
  width: 100% !important;
}

.thumbnail-container {
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  border-radius: 4px;
  border: 1px solid #e8e8e8;
}

.thumbnail {
  object-fit: cover;
  transition: transform 0.2s ease;
}

.thumbnail-container:hover .thumbnail {
  transform: scale(1.05);
}

.preview-image {
  display: block;
  margin: 0 auto;
  width: 100%;
  height: 650px;
}

.preview-container {
  position: relative;
  width: 100%;
  min-height: 500px;
}

.main-preview {
  position: relative;
  width: 100%;
  height: 650px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #eee;
}

/* 鸟瞰图导航栏 */
.thumbnail-nav {
  display: flex;
  gap: 10px;
  padding: 5px 0;
  margin-top: 10px;
}

.ana-thumbnail-nav {
  display: flex;
  gap: 10px;
  padding: 5px 0;
  margin-top: 30px;
}

.thumbnail-item {
  width: 80px;
  height: 60px;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 4px;
  overflow: hidden;
}

.thumbnail-item.active {
  border-color: #1890ff;
  /* 高亮当前选中的缩略图 */
}

.thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 导航按钮 */
.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.nav-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.prev-btn {
  left: 10px;
}

.next-btn {
  right: 10px;
}

/* 缩放控制 */
.zoom-controls {
  position: absolute;
  bottom: 0px;
  right: 20px;
  display: flex;
  gap: 10px;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  padding: 5px 10px;
  border-radius: 4px;
}

.zoom-controls button {
  padding: 2px 8px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 2px;
  cursor: pointer;
}

/* 表格图片样式 */
.media-item-image {
  width: 100px;
  height: 70px;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.2s;
}

.media-item-image:hover {
  transform: scale(1.05);
}

.analysis-results-float {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 20;
  background: rgba(0, 0, 0, 0.75);
  color: white;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  width: 130px;
  overflow: hidden;
  backdrop-filter: blur(4px);

  .analysis-results-header {
    padding: 10px 15px;
    background: rgba(0, 0, 0, 0.8);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    font-weight: 600;
    font-size: 14px;
  }

  .analysis-results-content {
    padding: 12px 15px;

    .analysis-result-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }

      .result-name {
        font-size: 13px;
        color: rgba(255, 255, 255, 0.9);
      }

      .result-count {
        font-size: 14px;
        font-weight: 600;
        color: #52c41a; // 绿色高亮显示数量
      }
    }

    .no-analysis-data {
      font-size: 13px;
      color: rgba(255, 255, 255, 0.8);
      text-align: center;
      display: block;
      padding: 8px 0;
    }
  }
}

.info-overlay {
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
  z-index: 2;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 8px 16px;
  display: flex;
  gap: 20px;
  font-size: 14px;
  border-radius: 4px;
}

.ana-info-overlay {
  position: absolute;
  bottom: 41px;
  left: 0;
  right: 0;
  z-index: 2;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 8px 16px;
  display: flex;
  gap: 20px;
  font-size: 14px;
  border-radius: 4px;
}

.pana-info-overlay {
  position: absolute;
  bottom: 7px;
  left: 0;
  right: 0;
  z-index: 2;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 8px 16px;
  display: flex;
  gap: 20px;
  font-size: 14px;
  border-radius: 4px;
}

.info-overlay-folder-video {
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
  z-index: 2;
  color: #000;
  padding: 4px 16px;
  display: flex;
  gap: 20px;
  font-size: 14px;
  border-radius: 4px;
  margin: 0 10px;
}

.media-page-container {
  display: flex;
  width: 100%;
  min-height: calc(100vh - 60px);
  box-sizing: border-box;
}

/* 左侧树结构容器：固定宽度 + 边框 + 滚动 */
.media-tree-wrapper-device {
  width: 200px;
  /* 树结构固定宽度，可根据需求调整 */
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.media-tree-wrapper {
  width: 262px;
  /* 树结构固定宽度，可根据需求调整 */
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.tree-header {
  height: 48px;
  line-height: 48px;
  padding: 0 6px;
  font-size: 14px;
  font-weight: 500;
  border-bottom: 1px solid #e8e8e8;
  background: #fafafa;
}

.media-tree {
  flex: 1;
  /* 占满父容器剩余高度 */
  padding: 8px 0;
  overflow-y: auto;

  /* 树节点过多时可滚动 */
  &::-webkit-scrollbar {
    width: 6px;
    /* 滚动条宽度 */
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
  }
}

.media-content-wrapper {
  flex: 1;
  /* 自适应剩余宽度 */
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.fly-overflow {
  height: 730px;
  overflow-y: auto;
}

.fly-panel {
  position: relative; /* 为绝对定位的子元素提供参照 */
  background-color: #ebf1fd;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  height: 90px;
  width: 95%;
  font-size: 13px;
  border-radius: 2px;
  cursor: pointer;
  transition: background-color 0.2s;

  &.active {
    background-color: #d1e0fe;
    border: 1px solid #1890ff;
    color: #1890ff;
  }

  .fly-badge {
    position: absolute;
    top: -2px;
    right: -2px;
    z-index: 10;

    :deep(.ant-badge-count) {
      box-shadow: 0 0 0 1px #fff;
      font-size: 10px;
      min-width: 18px;
      height: 18px;
      line-height: 18px;
      padding: 0 4px;
    }
  }

  .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 30px;
    font-weight: bold;
    margin: 0px 10px 0 10px;
  }
}

.fly-name {
  width: 90px;              /* 固定宽度 */
  flex-shrink: 0;            /* 防止被压缩 */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.way-user {
  flex: 1;                   /* 占据剩余空间 */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-left: 8px;          /* 可选，增加间距 */
}

.panoStyle {
  width: 100%;
  height: 800px;
}

.synthesis-modal-content {
  .synthesis-form {
    margin-top: 16px;

    .form-item {
      display: flex;
      flex-direction: row; /* 确保横向排列 */
      align-items: flex-start; /* 顶部对齐 */
      margin-bottom: 20px;

      .form-label {
        width: 110px;
        text-align: right;
        padding-right: 12px;
        line-height: 32px;
        flex-shrink: 0;
        margin-top: 0; /* 确保标签顶部对齐 */

        .required {
          color: #ff4d4f;
          margin-right: 4px;
        }
      }

      .form-content {
        flex: 1;
        min-height: 32px; /* 与标签高度对齐 */

        .form-tips {
          margin-top: 6px;
          color: #999;
          font-size: 12px;
        }

        .radio-options {
          display: flex;
          flex-direction: column;
          gap: 8px;

          .radio-item {
            display: flex;
            flex-direction: row !important;
            align-items: center; /* 垂直居中对齐 */
            padding: 0 !important; /* 移除原有的内边距 */
            border: none !important; /* 移除原有的边框 */
            background: none !important; /* 移除原有的背景色 */
            cursor: pointer;

            &:hover {
              border-color: #1890ff;
            }

            .ant-radio {
              margin-top: 2px; /* 微调对齐 */
            }

            .radio-content {
              // display: flex;
              flex-direction: column;
              // margin-left: 8px;
            }

            .radio-label {
              font-weight: 500;
              margin-bottom: 2px;
            }

            .radio-desc {
              color: #666;
              font-size: 12px;
            }
          }
        }

        .selected-images {
          // border: 1px solid #f0f0f0;
          // border-radius: 4px;
          padding: 16px;
          // background: #fafafa;

          .selected-count {
            margin-bottom: 12px;
            font-weight: 500;
            color: #1890ff;

            .error-tip {
              color: #ff4d4f;
              font-size: 12px;
            }
          }

          .image-preview-list {
            display: flex;
            flex-direction: row; /* 确保图片横向排列 */
            flex-wrap: wrap;
            gap: 12px;

            .image-preview-item {
              width: 80px;
              text-align: center;

              .preview-image {
                width: 80px;
                height: 60px;
                object-fit: cover;
                border-radius: 4px;
                border: 1px solid #e8e8e8;
              }

              .preview-name {
                margin-top: 4px;
                font-size: 12px;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }

            .more-images {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 80px;
              height: 60px;
              color: #999;
              font-size: 12px;
              border: 1px dashed #d9d9d9;
              border-radius: 4px;
            }
          }

          .no-images {
            text-align: center;
            color: #999;
            padding: 20px;
          }
        }
      }
    }

    .synthesis-progress {
      margin-top: 24px;
      padding: 16px;
      background: #fafafa;
      border-radius: 4px;

      .progress-info {
        text-align: center;

        .progress-text {
          margin-top: 8px;
          color: #666;

          &.success {
            color: #52c41a;
            font-weight: 500;
          }
        }
      }
    }
  }
}

.analysis-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;

  :deep(.ant-spin-text) {
    margin-top: 10px;
  }
}

.analysis-results-container {
  min-height: 200px;

  .analysis-items {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 8px 0;

    .analysis-item {
      display: flex;
      align-items: center;

      .analysis-item-content {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 8px 12px;
        background: #f5f5f5;
        border-radius: 4px;
        border-left: 3px solid #1890ff;

        .analysis-name {
          color: #333;
          font-weight: 500;
        }

        .analysis-count {
          color: #52c41a;
          font-weight: 600;
          font-size: 15px;
        }
      }

      &:hover {
        .analysis-item-content {
          background: #e8f4ff;
        }
      }
    }
  }

  .no-analysis-results {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;

    :deep(.ant-empty-image) {
      margin-bottom: 8px;
    }

    :deep(.ant-empty-description) {
      color: #999;
    }
  }
}

/* 针对单选按钮组件的额外样式 */
:deep(.synthesis-modal-content) {
  .ant-radio-wrapper {
    display: flex;
    align-items: center;
  }

  .ant-progress-line {
    margin: 0;
  }
}

:deep(.ai-position) {
  position: absolute;
  bottom: 16px;
  right: 17px;
  width: 30px;
  height: 30px;
  background: #ccc;
  border-radius: 2%;
  color: #1890ff;
}

:deep(.ai-third-position) {
  position: absolute;
  bottom: 16px;
  right: 60px;
  width: 30px;
  height: 30px;
  background: #ccc;
  border-radius: 2%;
  color: #1890ff;
}

.regulation-modal-content {
  padding: 8px 0;

  .regulation-field {
    display: flex;
    margin-bottom: 24px;

    .regulation-label {
      width: 5vw;
      text-align: right;
      padding-right: 12px;
      line-height: 32px;
      flex-shrink: 0;

      .required {
        color: #ff4d4f;
        margin-right: 4px;
      }
    }

    .regulation-content {
      flex: 1;

      .rule-select-wrapper {
        display: flex;
        gap: 8px;

        .rule-input {
          flex: 1;
          cursor: pointer;

          &:hover {
            border-color: #1890ff;
          }
        }

        .select-btn {
          flex-shrink: 0;
        }
      }

      .form-tips {
        margin-top: 6px;
        color: #999;
        font-size: 12px;
      }

      :deep(.ant-textarea) {
        textarea {
          resize: vertical;
        }
      }

      :deep(.ant-input-textarea-show-count) {
        &::after {
          margin-bottom: -8px;
        }
      }
    }
  }
}

:deep(.regulation-modal-content) {
  .ant-modal-footer {
    border-top: 1px solid #f0f0f0;
    padding: 12px 16px;
  }
}

// 选择条约表格样式优化
:deep(.ant-table) {
  .ant-table-thead > tr > th {
    background-color: #fafafa;
    font-weight: 600;
  }

  .ant-table-tbody > tr:hover > td {
    background-color: #e6f7ff;
  }
}

// 选中条约显示区域样式
.rule-selected-info {
  background-color: #f5f5f5;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 16px;

  .selected-title {
    font-weight: 500;
    color: #333;
    margin-bottom: 6px;
  }

  .selected-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;

    .rule-tag {
      background-color: #e6f7ff;
      border-color: #91d5ff;
      color: #1890ff;
    }
  }
}

.monitor-content {
  height: 77%;
  overflow-y: auto;
  width: 99%;
  margin: 10px;
  padding: 10px;
}

.monitor-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  width: 100%;
  border: 1px solid #eee;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 20px;
  background: #fff;
  transition: all 0.3s ease;
  margin-bottom: 10px;
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  margin-top: 16px;
}

.monitor-result {
  padding: 20px;
  border-left: 2px solid #f58709;
}

.monitor-result-header {
  // display: flex;
  // align-items: center;
  // align-items: flex-start;
}

.monitor-title {
  font-size: 18px;
  font-weight: 600
}

.monitor-collapse {
  flex-shrink: 0;      // 防止面板被压缩，保持其内容宽度
}

.monitor-tag {
  font-size: 15px;
  margin-left: 30%;
  margin-top: 5%;
}

.result-container {
  width: 100%;
  height: 50%;
  background-color: #F5F7FA;
  border-radius: 4px;
  padding: 10px;

}

.result-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #727272;
  margin-top: 5px;
}

.monitor-message {
  font-size: 16px;
}

.monitor-body {
  height: 680px;
  overflow-y: auto;
  padding: 20px;
}

.create-steps {
  margin-bottom: 24px;
}

.create-task-form {
  margin: 16px 0;
}

.height-content {
  border-radius: 4px;
}

.height-data {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.height-list {
  flex: 0 0 calc(50% - 8px);
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.height-text {
  font-weight: 600;
  width: 120px;
  text-align: right;
  margin-right: 12px;
  flex-shrink: 0;
}

// 输入控件（a-select、a-input-number）自动占据剩余宽度
/* .height-list :deep(.ant-select),
.height-list :deep(.ant-input-number) {
  flex: 1;
  min-width: 0;                // 防止溢出
} */

.step-alert {
  margin: 16px 0;
}

.picked-summary {
  background-color: #f6f8fa;
  padding: 8px 12px;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 13px;
  .picked-gap {
    margin-left: 20px;
  }
}

.picker-query {
  margin-bottom: 16px;
}

.picker-table {
  margin-top: 8px;
  :deep(.ant-table-cell) {
    padding: 8px 12px;
  }
}

.picker-thumb--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background-color: #f0f2f5;
  border-radius: 4px;
  color: #bfbfbf;
}

.picker-non-image {
  font-size: 12px;
  color: #ff4d4f;
}

.picker-pagination {
  margin-top: 16px;
  text-align: right;
}

:deep(.picker-row-disabled) {
  background-color: #f5f5f5 !important;
  cursor: not-allowed;
  opacity: 0.6;
}

.monitor-image {
  display: flex;
  height: 300px;
  width: 100%;
  background-color: #F5F7FA;
  padding: 20px 40px;
}

.monitorImage {
  width: 320px;
  height: 200px;
}

.two-column-form {
  display: grid;
  grid-template-columns: 1fr 1fr;   /* 两列等宽 */
  column-gap: 24px;                 /* 列间距 */
  .ant-form-item {
    margin-bottom: 16px;            /* 行间距 */
  }
}

.history-list {
  max-height: 60vh;
  overflow-y: auto;
}

.history-steps {
  :deep(.ant-steps-item-content) {
    overflow: visible;
  }
}

.history-card {
  margin-bottom: 8px;
  border-radius: 8px;
  background: #fafafa;
}

.history-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-weight: 500;
}

.history-time {
  font-size: 13px;
  color: #8c8c8c;
  margin-bottom: 8px;
}

.history-params-title {
  font-weight: 500;
  margin-bottom: 8px;
  font-size: 13px;
}

.history-params-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}

.param-tag {
  background: #f0f0f0;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  color: #262626;
}

.history-result {
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
  font-size: 13px;
}

.result-text {
  color: #1890ff;
  font-weight: 500;
}

.history-images {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 12px;
}

.history-image-item {
  flex: 1;
  min-width: 150px;
}

.image-label {
  display: block;
  font-size: 12px;
  margin-bottom: 4px;
  color: #8c8c8c;
}

.history-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

/* 创建任务对话框样式 */
.monitor-create-body {
  max-height: 70vh;
  overflow-y: auto;
  padding: 0 4px;

  .advanced-collapse {
    margin-top: 16px;
    margin-bottom: 16px;
  }
}

.image-select-section {
  margin-top: 20px;

  .ant-alert {
    margin-bottom: 16px;
  }
}

.image-select-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.image-card {
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s;

  &.is-selected {
    border-color: #1890ff;
    border-style: solid;
    background-color: #f0f7ff;
  }

  .image-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    .card-title { font-weight: 600; }
  }

  .image-preview-area {
    height: 160px;
    background: #fafafa;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
    overflow: hidden;
    .ant-image {
      width: 100%;
      height: 100%;
      img { object-fit: cover; width: 100%; height: 100%; }
    }
    .empty-preview {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #bfbfbf;
      .anticon { font-size: 40px; margin-bottom: 8px; }
    }
  }

  .image-actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: center;
  }
}

.system-picker-body {
  .picker-search-form { margin-bottom: 16px; }
}

.results-body {
  max-height: 60vh;
  overflow-y: auto;
  padding: 4px 16px 16px 16px;

  .results-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
    padding-top: 12px;
    border-top: 1px solid #f0f0f0;
  }
}

.app-card.selected {
  border: 2px solid #ff4d4f !important;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2) !important;
  transform: scale(0.98);
  transition: all 0.2s ease;
}

.special-app-content {
  margin-top: 20px;
  max-height: 60vh;
  overflow-y: auto;
}

.category-section {
  margin-bottom: 40px;
}

.category-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .title-bar {
    width: 4px;
    height: 20px;
    background: #1890ff;
    margin-right: 12px;
    border-radius: 2px;
  }

  .title-text {
    font-size: 18px;
    font-weight: 500;
    color: #000000;
  }
}

.app-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 20px;
}

.app-card {
  position: relative;
  height: 120px;
  border-radius: 8px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(0, 0, 0, 0.1) 100%
    );
    opacity: 0.3;
    z-index: 1;
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  }

  .app-icon {
    position: relative;
    z-index: 2;
    font-size: 32px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 8px;
  }

  .app-name {
    position: relative;
    z-index: 2;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    flex: 1;
  }

  .app-count {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 2;
    font-size: 14px;
    color: #ffffff;
    background: rgba(255, 255, 255, 0.2);
    padding: 4px 8px;
    border-radius: 4px;
    font-weight: 500;
  }
}

.app-icon-placeholder {
  font-size: 32px;
  color: #ffffff;
}

.algo-analysis-form {
  padding: 16px 8px;

  .form-item {
    margin-bottom: 24px;

    .form-label {
      font-size: 14px;
      font-weight: 500;
      color: #333;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .form-control {
      width: 100%;

      :deep(.ant-select) {
        width: 100%;
      }

      :deep(.ant-input-number) {
        width: 100%;
      }
    }
  }

  .form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
  }
}

:deep(.analysis-position){
    font-size: 30px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #4098eb;

    &:hover {
        color: #1890ff;
        transform: scale(1.1);
    }
}
</style>
